import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./index.css";
import YandexMetrika from "./YandexMetrika";
import brainBg from "./assets/brain_bg.png";
import oneCBg from "./assets/1c_bg.png";
import twentyFourBg from "./assets/24_bg.png";
import androidBg from "./assets/android_bg.png";
import googleLogo from "./assets/google_logo.png";
import helmetBg from "./assets/helmet_bg.png";
import helmetPreview from "./assets/helmet_preview.png";
import sqlBg from "./assets/sql_bg.png";
import docBg from "./assets/doc_bg.png";
import rustoreLogo from "./assets/rustore_logo.png";

const heroSlides = [
    {
        id: "ai-search",
        image: brainBg,
        alt: "AI search visualization",
        title: "RUCORTEX ДЛЯ ДОКУМЕНТОВ И ПРОИЗВОДСТВА",
        description:
            "Промышленная AI-платформа объединяет документы, корпоративные источники, проверяемые ответы и прикладные модули для производства, склада и КПП.",
        action: {
            label: "Смотреть платформу",
            href: "/rucortex",
        },
    },
    {
        id: "computer-vision",
        image: helmetBg,
        alt: "Helmet logo",
        title: "КАСКИ НА ПРОИЗВОДСТВЕ",
        description:
            "RuCortex подключается к существующему видеонаблюдению, фиксирует отсутствие касок и помогает охране труда реагировать до инцидента.",
        action: {
            label: "Смотреть решение",
            href: "/cv",
        },
    },
    {
        id: "license-plates",
        image: twentyFourBg,
        alt: "License plate recognition visualization",
        title: "РАСПОЗНАВАНИЕ НОМЕРОВ",
        description:
            "RuCortex фиксирует транспортные средства на охраняемой территории, распознает госномера с камер и сохраняет события для учета и проверки.",
        action: {
            label: "Смотреть решение",
            href: "/numbers",
        },
    },
    {
        id: "metal-calculator",
        image: androidBg,
        alt: "Android application icon",
        title: "КАЛЬКУЛЯТОР МЕТАЛЛОПРОКАТА",
        description:
            "Рукортекс.МеталлКалькулятор считает массу, длину, площадь и количество металлопроката по ГОСТ, ТУ и геометрическим формулам без Excel.",
        apkDownload: {
            label: "Скачать APK",
            href: "/rucortex-metal-calculator.apk",
            fileName: "rucortex-metal-calculator.apk",
        },
        storeButtons: [
            {
                id: "google-play",
                label: "Скоро в Google Play",
                href: "",
                accent: "from-[#07101f] via-[#0f1728] to-[#d7b56d]",
                icon: googleLogo,
                iconGlow: "rgba(168, 85, 247, 0.45)",
            },
            {
                id: "rustore",
                label: "Скоро в RuStore",
                href: "",
                accent: "from-[#0d5f73] via-[#09b6d4] to-[#073c49]",
                icon: rustoreLogo,
                iconGlow: "rgba(6, 182, 212, 0.45)",
            },
        ],
    },
];

const ROUTE_PRELOAD_IMAGES = [
    helmetPreview,
    twentyFourBg,
    androidBg,
    oneCBg,
    sqlBg,
    docBg,
];

const integrationItems = [
    {
        id: "1c",
        image: oneCBg,
        title: "СИСТЕМЫ 1С",
        text: "Подключаем номенклатуру, остатки, заявки и регламентные данные, чтобы ассистент отвечал с учетом актуального бизнес-контекста.",
        glow: "rgba(215, 181, 109, 0.55)",
        glowSoft: "rgba(215, 181, 109, 0.18)",
    },
    {
        id: "bitrix24",
        image: twentyFourBg,
        title: "БИТРИКС24 И CRM",
        text: "Связываем обращения, сделки, задачи и базу знаний, чтобы ответы ассистента продолжали текущий процесс, а не жили отдельно от команды.",
        glow: "rgba(6, 182, 212, 0.55)",
        glowSoft: "rgba(6, 182, 212, 0.18)",
    },
    {
        id: "sql",
        image: sqlBg,
        title: "ВНУТРЕННИЕ БАЗЫ ДАННЫХ",
        text: "Подключаем справочники, учетные системы и витрины данных через контролируемые запросы, права доступа и журналирование.",
        glow: "rgba(96, 165, 250, 0.55)",
        glowSoft: "rgba(96, 165, 250, 0.18)",
    },
    {
        id: "docs",
        image: docBg,
        title: "ВАШИ ДОКУМЕНТЫ",
        text: "Индексируем DOC, PDF, Excel и архивы нормативов: ассистент отвечает с цитатами, а не просто генерирует текст.",
        glow: "rgba(168, 85, 247, 0.55)",
        glowSoft: "rgba(168, 85, 247, 0.18)",
    },
];

const cvInsightItems = [
    {
        title: "Отсутствие каски",
        text: "Система выделяет сотрудника без СИЗ, сохраняет кадр, время и камеру, чтобы событие можно было быстро проверить.",
    },
    {
        title: "Зоны повышенного риска",
        text: "Для каждой камеры задаются зоны контроля: проходы, производственные линии, складские участки и опасные периметры.",
    },
    {
        title: "Повторяемость нарушений",
        text: "События группируются по времени, зоне и типу нарушения, чтобы видеть не отдельные случаи, а системные проблемы.",
    },
    {
        title: "Ручное подтверждение",
        text: "Специалист может подтвердить или отклонить событие, снижая шум и формируя базу для улучшения качества модели.",
    },
    {
        title: "Отчёт для службы ОТ",
        text: "Пилот показывает точность, ложные срабатывания, проблемные зоны и рекомендации для масштабирования по площадкам.",
    },
    {
        title: "Без замены инфраструктуры",
        text: "Начинаем с существующих камер и ограниченного контура, чтобы проверить эффект до капитального внедрения.",
    },
];

const cvRolloutItems = [
    {
        step: "01",
        title: "Выбор камер",
        text: "Определяем 2-5 камер, где нарушение СИЗ видно достаточно стабильно и есть понятная зона контроля.",
    },
    {
        step: "02",
        title: "Настройка событий",
        text: "Задаем зоны, пороги фиксации, правила хранения кадров и сценарий проверки событий специалистом.",
    },
    {
        step: "03",
        title: "Пилотная неделя",
        text: "Собираем события на реальном видеопотоке, считаем точность, ложные срабатывания и нагрузку на команду.",
    },
    {
        step: "04",
        title: "Решение о запуске",
        text: "Формируем отчет, требования к инфраструктуре, стоимость масштабирования и план подключения новых камер.",
    },
];

const businessScenarioItems = [
    {
        title: "Найти ответы в нормативах и документах",
        text: "Для инженеров, технологов и продаж: быстрые ответы по ГОСТ, ТУ, каталогам, инструкциям и внутренним файлам с цитатами.",
        actionLabel: "Запустить AI-поиск",
        action: "contact",
    },
    {
        title: "Подключить учет, CRM и базы данных",
        text: "Для компаний, где нужный ответ зависит от данных в других системах: учета, CRM, баз данных, заявок, остатков и истории взаимодействий.",
        actionLabel: "Обсудить интеграцию",
        action: "integration",
    },
    {
        title: "Контроль СИЗ на производстве",
        text: "Для производств и складов: система фиксирует события с отсутствием средств индивидуальной защиты и помогает быстрее реагировать на нарушения.",
        actionLabel: "Смотреть контроль СИЗ",
        action: "cv",
    },
    {
        title: "Вести учет ТС на территории",
        text: "Фиксировать и вести учет всех транспортных средств на охраняемой территории: номер, время, камера и событие проезда.",
        actionLabel: "Смотреть учет транспорта",
        action: "numbers",
    },
    {
        title: "Дать команде мобильный калькулятор",
        text: "Для инженеров, продаж, снабжения и склада: пересчет тонн, метров, штук и м² по металлопрокату без Excel и бумажных таблиц.",
        actionLabel: "Смотреть калькулятор",
        action: "calculator",
    },
];

const pilotStepItems = [
    {
        step: "01",
        title: "Диагностика задачи",
        text: "Фиксируем сценарий, источники данных, ограничения по ИБ и метрики, по которым будет понятно, сработал ли пилот.",
    },
    {
        step: "02",
        title: "Быстрый прототип",
        text: "Подключаем ограниченный контур: несколько документов, одну базу, набор камер или тестовый бизнес-процесс.",
    },
    {
        step: "03",
        title: "Проверка на реальных запросах",
        text: "Прогоняем типовые вопросы, события или расчеты, считаем точность, скорость, ошибки и ручные проверки.",
    },
    {
        step: "04",
        title: "Решение о внедрении",
        text: "Показываем отчет, стоимость масштабирования, требования к инфраструктуре и понятный план запуска в боевом контуре.",
    },
];

const calculatorUseCases = [
    {
        title: "Инженерам и технологам",
        text: "Быстро проверить массу, длину, площадь или количество по нормативным размерам, табличным значениям и формулам ГОСТ.",
    },
    {
        title: "Продажам и снабжению",
        text: "Пересчитать тонны, штуки, метры и квадратные метры во время заявки, переговоров или сверки партии без ручных таблиц.",
    },
    {
        title: "Складу и производству",
        text: "Держать расчеты под рукой на складе, участке, объекте или в дороге: Android-приложение работает без интернета.",
    },
];

const calculatorFeatureItems = [
    "Расчет массы, длины, площади и количества металлоизделий без ручных формул",
    "Пересчет между тоннами, штуками, метрами и квадратными метрами в зависимости от изделия",
    "Нормативная логика по ГОСТ и ТУ: стандартные размеры, табличные значения и геометрические формулы",
    "Учет марки стали, плотности материала, геометрии изделия и массы цинкового покрытия для оцинкованных позиций",
    "Режим произвольных значений для нестандартных размеров с расчетом по формулам из ГОСТа",
    "Офлайн Android-приложение для склада, производства, объекта и дороги",
];

const calculatorProductGroups = [
    "Арматура",
    "Трубы",
    "Листы",
    "Рулоны",
    "Профнастил",
    "Уголки",
    "Швеллеры",
    "Шестигранник",
    "Сортовой прокат",
    "Профильный прокат",
    "Шпунты",
    "Канаты",
    "Крепеж",
];

const plateUseCases = [
    {
        title: "КПП и шлагбаумы",
        text: "Фиксировать номер, время, камеру и событие проезда, чтобы быстрее проверять въезд и выезд транспорта.",
    },
    {
        title: "Парковки и закрытые территории",
        text: "Вести журнал событий по автомобилям, искать проезды по номеру и видеть повторяющиеся нарушения регламента.",
    },
    {
        title: "Склад и логистика",
        text: "Сопоставлять транспорт с заявками, рейсами или пропусками, если нужно связать видеофакт с операционным процессом.",
    },
];

const platePipelineItems = [
    ["Камера", "Берем поток с существующей IP-камеры или тестового видеофайла"],
    ["Детекция", "Выделяем автомобиль и область государственного номера"],
    ["OCR", "Считываем символы номера и сохраняем уверенность распознавания"],
    ["Событие", "Фиксируем кадр, время, камеру и распознанный номер"],
    ["Интеграция", "Передаем событие в журнал, CRM, 1С, систему доступа или отчетность"],
];

const plateFeatureItems = [
    "Распознавание государственных номеров на въезде, выезде или промышленной территории",
    "Журнал событий с кадром, временем, камерой, номером и статусом проверки",
    "Поиск по номеру, периоду, камере или типу события",
    "Сценарии белых и черных списков для пропускного режима и контроля территории",
    "Пилот на существующих камерах до закупки новой инфраструктуры",
    "Возможность интеграции с заявками, пропусками, 1С, CRM или внутренней базой транспорта",
];

const companyPreviewItems = [
    {
        label: "Платформа",
        title: "RuCortex превращает документы и процессы предприятия в управляемую AI-систему",
        text: "Поиск с источниками, загрузка знаний, документогенерация, интеграции и прикладные модули работают как единая продуктовая линейка.",
    },
    {
        label: "Внедрение",
        title: "ВЗ Электросталь — реальное промышленное внедрение продукта",
        text: "Проект прошел реальное промышленное внедрение: продукт использовался на данных и задачах производственной компании.",
    },
    {
        label: "Внедрение",
        title: "Пилот запускается от конкретного процесса, а не от абстрактной презентации AI",
        text: "Сначала выбираем рабочий сценарий, подключаем ограниченный контур и смотрим, насколько он снижает ручной поиск информации.",
    },
];

const platformModuleCards = [
    ["Корпоративные знания", "Работа с документами и корпоративными знаниями через проверяемые ответы."],
    ["Генерация документов", "Подготовка договоров, КП, справок, отчетов и технических описаний."],
    ["Интеграции", "1C, Bitrix24, CRM и внутренние источники в контролируемом контуре."],
    ["Компьютерное зрение", "Распознавание СИЗ и автомобильных номеров по данным с камер."],
    ["Учет транспорта", "Журнал въезда, выезда и транспортных событий на охраняемой территории."],
    ["МеталлКалькулятор", "Расчет массы, длины, площади и количества металлопроката по ГОСТ/ТУ."],
    ["Пилот", "Запуск на ограниченном контуре с понятными метриками результата."],
];

const platformOutcomeItems = [
    ["Поиск", "Сотрудник задает вопрос на обычном языке и получает ответ с привязкой к источникам."],
    ["Проверка", "Ответ можно сверить с исходным документом, разделом, файлом или карточкой данных."],
    ["Действие", "Результат превращается в документ, отчет, расчет, событие или задачу для команды."],
];

const platformProblemItems = [
    {
        label: "Нормы",
        title: "Регламенты и справочники лежат отдельно",
        text: "ГОСТ, ТУ, паспорта, инструкции и внутренние регламенты приходится искать вручную и сверять между собой.",
    },
    {
        label: "Данные",
        title: "Ответ зависит от 1С, CRM и таблиц",
        text: "Остатки, заявки, прайсы, справочники и Excel-файлы часто не связаны с документами и контекстом запроса.",
    },
    {
        label: "Решение",
        title: "Нужен проверяемый рабочий контур",
        text: "Сотруднику важен не чат ради чата, а ответ с источником, проверкой прав, расчетом, документом или следующим действием.",
    },
];

const platformSolutionItems = [
    "Ищет по нормативам, каталогам и внутренним базам в одном интерфейсе",
    "Показывает источники ответа: документ, раздел, строку или карточку данных",
    "Подключается к 1С, Битрикс24, CRM, базам данных и файловым архивам без перестройки процесса",
    "Показывает, какие ручные операции можно убрать или сократить после пилота",
];

const creatorFeatureItems = [
    ["Шаблоны", "договоры, КП, письма, справки, отчеты и технические описания"],
    ["Контекст", "использование исходных данных, базы знаний и требований заказчика"],
    ["Правки", "предложенные изменения можно принять, отклонить или доработать вручную"],
    ["DOCX", "работа с входным DOCX-файлом и подготовка итогового документа"],
];

const platformLayerItems = [
    {
        label: "Контур знаний",
        title: "Документы, регламенты и базы",
        text: "ГОСТ, ТУ, инструкции, каталоги, PDF, DOCX, Excel, 1C, CRM и внутренние базы собираются в управляемые коллекции.",
    },
    {
        label: "AI-ядро",
        title: "RAG, индексы и агентные инструменты",
        text: "Система обрабатывает документы, ищет релевантные фрагменты, ранжирует результаты и формирует контекст для модели.",
    },
    {
        label: "Рабочие модули",
        title: "Поиск, документы, СИЗ, номера, расчеты",
        text: "Пользователь получает не отдельный чат, а набор инструментов для реальных процессов предприятия.",
    },
];

const platformPilotItems = [
    ["1", "Выбрать процесс", "Документы, интеграции, камеры, номера или инженерные расчеты."],
    ["2", "Подключить минимум", "Ограниченный набор источников, камер или файлов для быстрой проверки."],
    ["3", "Проверить пользу", "Сравниваем ручной поиск информации и работу через RuCortex на реальных задачах."],
    ["4", "Масштабировать", "План внедрения, инфраструктура, роли, интеграции и поддержка."],
];

function PrivacyModal({ open, onClose }) {
    // закрытие по ESC
    React.useEffect(() => {
        if (!open) return;
        const h = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", h);
        return () => window.removeEventListener("keydown", h);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            aria-modal="true"
            role="dialog"
            className="fixed inset-0 z-[999] flex items-center justify-center p-4"
            onClick={onClose}
        >
            {/* фон */}
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

            {/* диалог */}
            <div
                className="relative w-full max-w-4xl max-h-[85vh] overflow-hidden rounded-2xl border border-[#d7b56d]/28
                   bg-[#07101f] shadow-[0_24px_70px_rgba(0,0,0,0.42)] text-blue-100"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-between gap-4 px-6 py-4 border-b border-[#d7b56d]/18">
                    <h3 className="text-lg md:text-xl font-bold text-[#f5ead2]">
                        Политика в отношении обработки персональных данных
                    </h3>
                    <button
                        onClick={onClose}
                        className="rounded-md px-3 py-1.5 text-sm bg-white/10 hover:bg-white/15 text-blue-100"
                    >
                        Закрыть
                    </button>
                </div>

                {/* Содержимое — ПРОКРУЧИВАЕМОЕ */}
                <div className="scroll-area px-6 py-5 overflow-y-scroll max-h-[75vh] pr-3 space-y-3 text-sm leading-relaxed">
                {/* ====== ПОЛНЫЙ ТЕКСТ ИЗ ДОКУМЕНТА ====== */}
                    <p><strong>Политика в отношении обработки персональных данных.</strong></p>

                    <p><strong>1. Общие положения.</strong> Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые ВЗ Электросталь (далее — Оператор). 1.1. Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну. 1.2. Настоящая Политика применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта https://rucortex.ru/.</p>

                    <p><strong>2. Основные понятия, используемые в Политике.</strong> Автоматизированная обработка персональных данных; Блокирование персональных данных; Веб-сайт — https://rucortex.ru/; Информационная система персональных данных; Обезличивание персональных данных; Обработка персональных данных; Оператор; Персональные данные; Персональные данные, разрешённые субъектом для распространения; Пользователь; Предоставление персональных данных; Распространение персональных данных; Трансграничная передача персональных данных; Уничтожение персональных данных. (Полные формулировки включены из исходного документа.)</p>

                    <p><strong>3. Основные права и обязанности Оператора.</strong> Оператор имеет право получать достоверную информацию/документы; при отзыве согласия — продолжать обработку при основаниях, указанных в законе; самостоятельно определять меры защиты. Оператор обязан предоставлять субъекту информацию об обработке; организовывать обработку по закону; отвечать на обращения; сообщать в уполномоченный орган сведения в течение 10 дней; публиковать Политику; принимать правовые, организационные и технические меры защиты; прекращать передачу/обработку и уничтожать данные в предусмотренных случаях; исполнять иные обязанности. </p>

                    <p><strong>4. Основные права и обязанности субъектов персональных данных.</strong> Субъекты имеют право: получать информацию об обработке; требовать уточнения/блокирования/уничтожения; выдвигать условие предварительного согласия на обработку в целях продвижения; отзыв согласия; обжаловать действия Оператора; иные права. Обязаны: предоставлять достоверные данные; сообщать об их изменении. Ответственность за недостоверные сведения несут лица, их предоставившие. </p>

                    <p><strong>5. Принципы обработки персональных данных.</strong> Законность и справедливость; ограничение целями; недопустимость объединения несовместимых баз; соответствие данных целям; точность и актуальность; хранение не дольше необходимого срока; уничтожение/обезличивание при достижении целей. </p>

                    <p><strong>6. Цели обработки персональных данных.</strong> Цель — информирование Пользователя посредством отправки электронных писем. Персональные данные: ФИО, электронный адрес, номера телефонов. Правовые основания — уставные (учредительные) документы Оператора. Виды обработки: сбор, запись, систематизация, накопление, хранение, уничтожение и обезличивание. </p>

                    <p><strong>7. Условия обработки персональных данных.</strong> С согласия субъекта; для целей, предусмотренных международными договорами/законом; для осуществления правосудия и исполнения актов; для исполнения/заключения договора; для законных интересов оператора или третьих лиц при соблюдении прав и свобод субъекта; обработка общедоступных данных; данные, подлежащие опубликованию/обязательному раскрытию. </p>

                    <p><strong>8. Порядок сбора, хранения, передачи и иных видов обработки.</strong> Безопасность обеспечивается правовыми, организационными и техническими мерами. Оператор обеспечивает сохранность и исключает доступ неуполномоченных лиц; не передаёт третьим лицам, кроме случаев, установленных законом или с согласия субъекта; субъект может актуализировать данные, отозвать согласие (по адресу: <em>electrosteel@mail.ru</em>); информация сторонних сервисов обрабатывается по их политикам; установленные субъектом запреты на распространение не действуют в публичных интересах; конфиденциальность обеспечивается; хранение — не дольше целей обработки; основанием прекращения обработки может быть достижение целей, истечение срока согласия, отзыв согласия, требование о прекращении, выявление неправомерной обработки. </p>

                    <p><strong>9. Перечень действий с персональными данными.</strong> Сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение; допускается автоматизированная обработка с передачей по сетям или без неё. </p>

                    <p><strong>10. Трансграничная передача.</strong> До начала — уведомление уполномоченного органа; до подачи уведомления — получение необходимых сведений от получателей в иностранном государстве. </p>

                    <p><strong>11. Конфиденциальность персональных данных.</strong> Оператор и иные лица, получившие доступ к персональным данным, обязаны не раскрывать третьим лицам и не распространять персональные данные без согласия субъекта, если иное не предусмотрено федеральным законом. </p>

                    <p><strong>12. Заключительные положения.</strong> Вопросы направлять на <em>electrosteel@mail.ru</em>. В документ будут вноситься изменения; Политика действует бессрочно до замены новой версией; актуальная версия — на https://rucortex.ru/. </p>

                    <div className="pt-3">
                        <a
                            href="/policy.docx"               // ← мы положили файл в public
                            download
                            className="inline-flex items-center gap-2 rounded-full bg-[#d7b56d] px-4 py-2 font-semibold text-[#07111f] hover:bg-[#f0cc7b]"
                        >
                            Скачать (.docx)
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

function SiteFooter({ onOpenPolicy }) {
    return (
        <footer
            className="site-footer relative overflow-hidden border-t border-[#d7b56d]/18 bg-[linear-gradient(180deg,#07101f_0%,#050914_100%)] px-6 py-10 text-center text-blue-100">

            {/* --- Фон подсветки --- */}
            <div
                className="absolute top-0 left-1/2 h-[2px] w-[80%] -translate-x-1/2 bg-gradient-to-r from-transparent via-[#d7b56d] to-transparent opacity-60 blur-[1px]"></div>
            <div
                className="footer-glow-bottom absolute bottom-0 left-1/2 -translate-x-1/2 w-[60%] h-[200px] bg-cyan-500/10 blur-[120px]"></div>
            {/* --- Контент футера --- */}
            <div
                className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">

                {/* Логотип / Название */}
                <div
                    className="bg-gradient-to-r from-[#f5ead2] via-[#d7b56d] to-cyan-200 bg-clip-text text-2xl font-extrabold text-transparent">
                    RuCortex
                </div>

                {/* Контакты */}
                <div className="flex flex-col md:flex-row items-center gap-4 text-sm md:text-base">
                    <span>© {new Date().getFullYear()} RuCortex. Все права защищены.</span>
                    <span className="hidden md:inline">|</span>
                    <a
                        href="mailto:electrosteel@mail.ru"
                        className="text-cyan-200 hover:text-[#d7b56d] transition-all duration-300"
                    >
                        electrosteel@mail.ru
                    </a>
                    <span className="hidden md:inline">|</span>
                    <button
                        className="text-blue-200 hover:text-[#d7b56d] transition-all duration-300"
                        onClick={onOpenPolicy}
                    >
                        Политика конфиденциальности
                    </button>

                </div>
            </div>
        </footer>
    );
}

const CONTACT_ENDPOINT = "/api/contact";

const getFormValue = (form, name) => form.elements[name]?.value?.trim() || "";

async function sendLeadRequest(form, source) {
    const response = await fetch(CONTACT_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            company: getFormValue(form, "company"),
            email: getFormValue(form, "email"),
            phone: getFormValue(form, "phone"),
            comment: getFormValue(form, "comment"),
            website: getFormValue(form, "website"),
            source,
        }),
    });

    let result = null;
    try {
        result = await response.json();
    } catch {
        result = null;
    }

    if (!response.ok || result?.ok === false) {
        throw new Error(result?.message || "Lead request failed");
    }

    return result;
}

function LeadForm({
    title = "Заявка на пилот",
    source = "RuCortex site",
    commentPlaceholder = "Какая задача важнее всего: поиск, интеграция, СИЗ, расчеты или другое",
    submitLabel = "Отправить заявку",
    className = "",
}) {
    const [status, setStatus] = React.useState("");
    const [statusType, setStatusType] = React.useState("idle");
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const isHoneypotSubmission = Boolean(getFormValue(form, "website"));

        setIsSubmitting(true);
        setStatus("");
        setStatusType("idle");

        try {
            await sendLeadRequest(form, source);
            if (!isHoneypotSubmission) {
                window.ym?.(105850410, "reachGoal", "feedback_submit");
            }
            form.reset();
            setStatus("Спасибо! Заявка отправлена. Мы свяжемся с вами.");
            setStatusType("success");
        } catch (error) {
            console.error(error);
            setStatus("Не удалось отправить заявку. Попробуйте позже.");
            setStatusType("error");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={`lead-form-card ${className}`}>
            {title ? <h3 className="lead-form-title">{title}</h3> : null}
            <form className="lead-form" onSubmit={handleSubmit}>
                <input type="text" name="company" placeholder="Компания" autoComplete="organization" required />
                <input type="email" name="email" placeholder="Email" autoComplete="email" required />
                <input type="tel" name="phone" placeholder="Телефон" autoComplete="tel" required />
                <textarea name="comment" placeholder={commentPlaceholder} rows="4" />
                <input
                    className="lead-form-honeypot"
                    type="text"
                    name="website"
                    tabIndex="-1"
                    autoComplete="off"
                    aria-hidden="true"
                />
                <button type="submit" className="lead-submit" disabled={isSubmitting}>
                    {isSubmitting ? "Отправляем..." : submitLabel}
                </button>
            </form>
            {status ? <p className={`lead-form-note lead-form-note--${statusType}`}>{status}</p> : null}
        </div>
    );
}

const PRODUCT_NAV_ITEMS = [
    {
        name: "AI-поиск по документам",
        description: "Ответы с цитатами по ГОСТ, ТУ, каталогам, 1С, базам данных и внутренним файлам.",
        route: "/rucortex",
        target: "rucortex-search-section",
        key: "search",
        kind: "route-section",
    },
    {
        name: "RuCortex Creator",
        description: "Подготовка договоров, КП, справок, отчетов и технических документов.",
        route: "/rucortex",
        target: "creator-section",
        key: "creator",
        kind: "route-section",
    },
    {
        name: "Контроль СИЗ и касок",
        description: "Видеоаналитика по существующим камерам: события, зоны риска и отчет для охраны труда.",
        route: "/cv",
        key: "cv",
        kind: "route",
    },
    {
        name: "Распознавание номеров",
        description: "Фиксация госномеров, времени, камеры и событий проезда на охраняемой территории.",
        route: "/numbers",
        key: "numbers",
        kind: "route",
    },
    {
        name: "Рукортекс.МеталлКалькулятор",
        description: "Офлайн Android-калькулятор массы, длины, площади и количества металлопроката.",
        route: "/calculator",
        key: "calculator",
        kind: "route",
    },
];

const HEADER_PRIMARY_ITEMS = [
    { name: "Компания", kind: "home", key: "home" },
    { name: "Платформа", route: "/rucortex", key: "platform", kind: "route" },
    {
        name: "Внедрение",
        route: "/rucortex",
        target: "rucortex-pilot-section",
        key: "implementation",
        kind: "route-section",
    },
];

const HEADER_ACTION_ITEMS = [
    { name: "Получить демо", target: "contact-section", key: "contact", kind: "section" },
];

function useSpaRouter() {
    const [pathname, setPathname] = React.useState(() => window.location.pathname || "/");
    const pendingScrollFrameRef = React.useRef(null);

    const setRoutePath = React.useCallback((nextPathname) => {
        const updatePath = () => setPathname(nextPathname);
        if (typeof React.startTransition === "function") {
            React.startTransition(updatePath);
            return;
        }

        updatePath();
    }, []);

    const scheduleScrollTop = React.useCallback(() => {
        if (pendingScrollFrameRef.current) {
            window.cancelAnimationFrame(pendingScrollFrameRef.current);
        }

        pendingScrollFrameRef.current = window.requestAnimationFrame(() => {
            pendingScrollFrameRef.current = window.requestAnimationFrame(() => {
                window.scrollTo({ top: 0, left: 0, behavior: "auto" });
                pendingScrollFrameRef.current = null;
            });
        });
    }, []);

    React.useEffect(() => {
        const previousScrollRestoration = window.history.scrollRestoration;
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }

        const handlePopState = () => setRoutePath(window.location.pathname || "/");
        window.addEventListener("popstate", handlePopState);
        return () => {
            window.removeEventListener("popstate", handlePopState);
            if ("scrollRestoration" in window.history) {
                window.history.scrollRestoration = previousScrollRestoration;
            }
            if (pendingScrollFrameRef.current) {
                window.cancelAnimationFrame(pendingScrollFrameRef.current);
            }
        };
    }, [setRoutePath]);

    const navigate = React.useCallback((to, options = {}) => {
        const { scrollTop = true } = options;
        if (to === (window.location.pathname || "/")) return;
        window.history.pushState({}, "", to);
        setRoutePath(to);
        if (scrollTop) {
            scheduleScrollTop();
        }
    }, [scheduleScrollTop, setRoutePath]);

    return { pathname, navigate };
}

function useRoutePageEffect(title, lockScroll = false) {
    React.useEffect(() => {
        const previousTitle = document.title;
        const previousOverflow = document.body.style.overflow;
        const previousHeight = document.body.style.height;
        document.title = title;
        if (lockScroll) {
            document.body.style.overflow = "hidden";
            document.body.style.height = "100%";
        }

        return () => {
            document.title = previousTitle;
            document.body.style.overflow = previousOverflow;
            document.body.style.height = previousHeight;
        };
    }, [title, lockScroll]);
}

function UnifiedHeader({ pathname, navigate, activeSection, onSectionSelect, onCalculatorSelect }) {
    const isMainPage = pathname === "/";
    const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
    const [productMenuOpen, setProductMenuOpen] = React.useState(false);
    const headerRef = React.useRef(null);

    const routeMatches = (route) => pathname === route || pathname.startsWith(`${route}/`);
    const isNavItemActive = (item) =>
        item.kind === "home"
            ? isMainPage
            : item.kind === "route"
                ? routeMatches(item.route)
                : item.kind === "route-section"
                    ? false
            : isMainPage && activeSection === item.key;
    const productMenuActive = PRODUCT_NAV_ITEMS.some((item) => item.kind === "route" && isNavItemActive(item));
    const contactItem = HEADER_ACTION_ITEMS[0];

    React.useEffect(() => {
        setProductMenuOpen(false);
        setMobileMenuOpen(false);
    }, [pathname]);

    React.useEffect(() => {
        if (!productMenuOpen && !mobileMenuOpen) return undefined;

        const handlePointerDown = (event) => {
            if (headerRef.current?.contains(event.target)) return;
            setProductMenuOpen(false);
            setMobileMenuOpen(false);
        };

        const handleKeyDown = (event) => {
            if (event.key !== "Escape") return;
            setProductMenuOpen(false);
            setMobileMenuOpen(false);
        };

        document.addEventListener("pointerdown", handlePointerDown);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("pointerdown", handlePointerDown);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [mobileMenuOpen, productMenuOpen]);

    const scrollToPageTarget = (target) => {
        const section = document.getElementById(target);
        if (!section) return false;

        const headerOffset = 96;
        const elementPosition = section.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: Math.max(elementPosition - headerOffset, 0), behavior: "smooth" });
        return true;
    };

    const schedulePageTargetScroll = (target) => {
        const scroll = () => scrollToPageTarget(target);
        window.requestAnimationFrame(() => window.requestAnimationFrame(scroll));
        window.setTimeout(scroll, 180);
    };

    const handleNavClick = (item) => {
        if (item.kind === "home") {
            if (isMainPage) {
                window.scrollTo({ top: 0, behavior: "smooth" });
            } else {
                navigate("/");
            }
            setProductMenuOpen(false);
            setMobileMenuOpen(false);
            return;
        }

        if (item.kind === "route") {
            navigate(item.route);
            setProductMenuOpen(false);
            setMobileMenuOpen(false);
            return;
        }

        if (item.kind === "route-section") {
            if (routeMatches(item.route)) {
                schedulePageTargetScroll(item.target);
            } else {
                navigate(item.route, { scrollTop: false });
                schedulePageTargetScroll(item.target);
            }
            setProductMenuOpen(false);
            setMobileMenuOpen(false);
            return;
        }

        if (item.kind === "calculator") {
            onCalculatorSelect();
            setProductMenuOpen(false);
            setMobileMenuOpen(false);
            return;
        }

        onSectionSelect(item.target);
        setProductMenuOpen(false);
        setMobileMenuOpen(false);
    };

    return (
        <header
            className="fixed inset-x-0 top-3 z-50 px-3 md:px-6"
            ref={headerRef}
        >
            <div className="relative mx-auto w-full max-w-[1460px] rounded-[1.65rem] border border-[#d7b56d]/14 bg-[#030712]/92 shadow-[0_24px_70px_rgba(0,0,0,0.48),inset_0_1px_0_rgba(255,255,255,0.08)] backdrop-blur-2xl">
                <div className="pointer-events-none absolute inset-x-7 top-0 h-px bg-gradient-to-r from-transparent via-[#d7b56d]/55 to-transparent"></div>

                <div className="flex items-center justify-between gap-3 px-3 py-2 md:px-4">
                    <button
                        type="button"
                        className="group min-w-0 rounded-[1.25rem] px-3 py-1.5 text-left transition-all duration-300 hover:bg-white/[0.055]"
                        onClick={() => handleNavClick(HEADER_PRIMARY_ITEMS[0])}
                    >
                        <span className="block bg-gradient-to-r from-cyan-100 via-white to-[#d7b56d] bg-clip-text text-2xl font-black tracking-[-0.045em] text-transparent md:text-[1.7rem]">
                            RuCortex
                        </span>
                    </button>

                    <nav className="hidden items-center gap-1 rounded-full border border-[#d7b56d]/12 bg-[#07101f]/88 p-1 text-sm font-bold text-blue-100/82 shadow-[inset_0_1px_0_rgba(255,255,255,0.06)] lg:flex">
                        {HEADER_PRIMARY_ITEMS.slice(0, 2).map((item) => {
                            const active = isNavItemActive(item);

                            return (
                                <button
                                    key={item.key}
                                    type="button"
                                    onClick={() => handleNavClick(item)}
                                    className={`rounded-full px-4 py-2 transition-all duration-300 ${
                                        active
                                            ? "bg-white text-[#07101f] shadow-[0_0_22px_rgba(255,255,255,0.14)]"
                                            : "hover:bg-white/10 hover:text-cyan-100"
                                    }`}
                                >
                                    {item.name}
                                </button>
                            );
                        })}
                        <button
                            type="button"
                            className={`flex items-center gap-2 rounded-full px-4 py-2 transition-all duration-300 ${
                                productMenuOpen || productMenuActive
                                    ? "bg-[#d7b56d] text-[#07101f] shadow-[0_0_22px_rgba(215,181,109,0.28)]"
                                    : "hover:bg-white/10 hover:text-cyan-100"
                            }`}
                            aria-haspopup="true"
                            aria-expanded={productMenuOpen}
                            onClick={() => setProductMenuOpen((open) => !open)}
                        >
                            Продукты
                            <span className={`text-xs leading-none opacity-80 transition-transform duration-200 ${productMenuOpen ? "rotate-180" : ""}`}>
                                ▾
                            </span>
                        </button>
                        {HEADER_PRIMARY_ITEMS.slice(2).map((item) => {
                            const active = isNavItemActive(item);

                            return (
                                <button
                                    key={item.key}
                                    type="button"
                                    onClick={() => handleNavClick(item)}
                                    className={`rounded-full px-4 py-2 transition-all duration-300 ${
                                        active
                                            ? "bg-cyan-300 text-[#081023] shadow-[0_0_22px_rgba(56,189,248,0.32)]"
                                            : "hover:bg-white/10 hover:text-cyan-100"
                                    }`}
                                >
                                    {item.name}
                                </button>
                            );
                        })}
                    </nav>

                    <div className="flex items-center gap-2">
                        <button
                            className="hidden rounded-full border border-[#d7b56d]/30 bg-[#d7b56d]/10 px-5 py-2.5 text-sm font-black uppercase tracking-[0.12em] text-[#f5ead2] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#d7b56d] hover:text-[#07101f] md:inline-flex"
                            onClick={() => handleNavClick(contactItem)}
                        >
                            {contactItem.name}
                        </button>
                        <button
                            type="button"
                            className="shrink-0 rounded-full border border-cyan-300/30 bg-white/7 px-3 py-2 text-sm font-bold text-cyan-100 transition-all duration-300 hover:bg-white/12 sm:px-4 lg:hidden"
                            onClick={() => {
                                setProductMenuOpen(false);
                                setMobileMenuOpen((open) => !open);
                            }}
                            aria-expanded={mobileMenuOpen}
                            aria-label="Открыть меню"
                        >
                            {mobileMenuOpen ? "Закрыть" : "Меню"}
                        </button>
                    </div>
                </div>

                {productMenuOpen ? (
                    <div className="absolute left-1/2 top-[calc(100%+0.85rem)] z-[60] hidden w-[min(820px,calc(100vw-2rem))] -translate-x-1/2 lg:block">
                        <div className="absolute -inset-3 rounded-[2rem] bg-[#d7b56d]/18 blur-2xl"></div>
                        <div className="absolute left-1/2 top-[-0.45rem] h-4 w-4 -translate-x-1/2 rotate-45 border-l border-t border-[#d7b56d]/45 bg-[#02050c]"></div>
                        <div className="relative grid gap-3 rounded-[1.6rem] border border-[#d7b56d]/45 bg-[#02050c] p-3 shadow-[0_38px_110px_rgba(0,0,0,0.9),0_0_0_1px_rgba(215,181,109,0.12),inset_0_1px_0_rgba(255,255,255,0.08)] md:grid-cols-[0.82fr_1.18fr]">
                            <div className="rounded-[1.25rem] border border-[#d7b56d]/18 bg-[radial-gradient(circle_at_18%_20%,rgba(215,181,109,0.22),transparent_34%),#090f1c] p-5">
                                <div className="text-xs font-black uppercase tracking-[0.22em] text-[#d7b56d]">
                                    Линейка RuCortex
                                </div>
                                <div className="mt-4 text-2xl font-black leading-tight tracking-[-0.04em] text-white">
                                    Выберите направление под задачу предприятия
                                </div>
                            </div>

                            <div className="grid gap-2 rounded-[1.25rem] border border-white/8 bg-white/[0.025] p-2">
                                {PRODUCT_NAV_ITEMS.map((item) => {
                                    const active = isNavItemActive(item);

                                    return (
                                        <button
                                            key={item.key}
                                            type="button"
                                            onClick={() => handleNavClick(item)}
                                            className={`grid grid-cols-[auto_1fr] gap-3 rounded-[1.1rem] px-4 py-3 text-left transition-all duration-200 ${
                                                active
                                                    ? "bg-[#d7b56d] text-[#07101f]"
                                                    : "text-blue-100 hover:bg-[#111a31] hover:text-cyan-100"
                                            }`}
                                        >
                                            <span className={`mt-1 h-2.5 w-2.5 rounded-full ${active ? "bg-[#07101f]" : "bg-cyan-300/70"}`}></span>
                                            <span>
                                                <span className="block text-sm font-black">{item.name}</span>
                                                <span className={`mt-1 block text-xs leading-relaxed ${active ? "text-[#07101f]/72" : "text-blue-100/62"}`}>
                                                    {item.description}
                                                </span>
                                            </span>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                ) : null}

                {mobileMenuOpen ? (
                    <nav className="grid grid-cols-1 gap-2 border-t border-white/10 p-3 lg:hidden">
                        {HEADER_PRIMARY_ITEMS.slice(0, 2).map((item) => {
                            const active = isNavItemActive(item);

                            return (
                                <button
                                    key={item.key}
                                    type="button"
                                    onClick={() => handleNavClick(item)}
                                    className={`rounded-2xl px-4 py-3 text-left text-sm font-black transition-all duration-300 ${
                                        active ? "bg-white text-[#07101f]" : "bg-white/[0.055] text-blue-100"
                                    }`}
                                >
                                    {item.name}
                                </button>
                            );
                        })}
                        <div className="px-2 pb-1 pt-2 text-xs font-black uppercase tracking-[0.22em] text-[#d7b56d]/80">
                            Продукты
                        </div>
                        {PRODUCT_NAV_ITEMS.map((item) => {
                            const active = isNavItemActive(item);

                            return (
                                <button
                                    key={item.key}
                                    type="button"
                                    onClick={() => handleNavClick(item)}
                                    className={`rounded-2xl px-4 py-3 text-left transition-all duration-300 ${
                                        active
                                            ? "bg-[#d7b56d] text-[#07101f]"
                                            : "bg-white/[0.055] text-blue-100 hover:bg-white/10"
                                    }`}
                                >
                                    <span className="block text-sm font-black">{item.name}</span>
                                    <span className={`mt-1 block text-xs leading-relaxed ${active ? "text-[#07101f]/72" : "text-blue-100/62"}`}>
                                        {item.description}
                                    </span>
                                </button>
                            );
                        })}
                        <div className="mt-2 px-2 pb-1 pt-1 text-xs font-black uppercase tracking-[0.22em] text-cyan-200/70">
                            Внедрение
                        </div>
                        {[...HEADER_PRIMARY_ITEMS.slice(2), ...HEADER_ACTION_ITEMS].map((item) => {
                            const active = isNavItemActive(item);

                            return (
                                <button
                                    key={item.key}
                                    type="button"
                                    onClick={() => handleNavClick(item)}
                                    className={`rounded-2xl px-4 py-3 text-left text-sm font-bold transition-all duration-300 ${
                                        active
                                            ? "bg-cyan-300 text-[#081023]"
                                            : item.key === "contact"
                                                ? "bg-[#d7b56d]/14 text-[#f5ead2]"
                                                : "bg-white/[0.055] text-blue-100 hover:bg-white/10"
                                    }`}
                                >
                                    {item.name}
                                </button>
                            );
                        })}
                    </nav>
                ) : null}
            </div>
        </header>
    );
}

function RouteShell({ children, className = "" }) {
    return (
        <div className={`route-app ${className}`.trim()}>
            <style>{`
                .route-app {
                    position: relative;
                    min-height: 100svh;
                    width: 100%;
                    color: #eef2ff;
                    overflow: hidden;
                    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
                    background:
                        linear-gradient(135deg, #030712 0%, #07101f 48%, #050914 100%);
                }

                .route-app::before {
                    content: "";
                    position: absolute;
                    inset: 0;
                    pointer-events: none;
                    background:
                        linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
                    background-size: 42px 42px;
                    opacity: 0.12;
                }

                .route-app::after {
                    content: "";
                    position: absolute;
                    inset: -12%;
                    pointer-events: none;
                    background:
                        radial-gradient(circle at 18% 8%, rgba(215, 181, 109, 0.16), transparent 34%),
                        radial-gradient(circle at 82% 14%, rgba(53, 214, 255, 0.13), transparent 28%),
                        radial-gradient(circle at 50% 96%, rgba(20, 184, 166, 0.12), transparent 34%);
                    filter: blur(34px);
                    opacity: 0.58;
                    transform: translateZ(0);
                    z-index: 0;
                }

                .route-app--cv::after {
                    filter: blur(24px);
                    opacity: 0.46;
                }

                .route-page {
                    position: relative;
                    z-index: 1;
                    width: min(70vw, 1180px);
                    min-height: 100svh;
                    margin: 0 auto;
                    padding: 110px 0 24px;
                    display: flex;
                    flex-direction: column;
                }

                .route-app--cv .route-page {
                    width: min(94vw, 1340px);
                    padding-top: 104px;
                    padding-bottom: 48px;
                }

                .route-app--wide .route-page {
                    width: 100%;
                    max-width: none;
                    padding: 0;
                }

                .route-topbar {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 24px;
                    padding-bottom: 12px;
                    border-bottom: 1px solid rgba(215, 181, 109, 0.18);
                }

                .route-brand {
                    border: 0;
                    padding: 0;
                    background: linear-gradient(90deg, #f5ead2 0%, #d7b56d 54%, #5ae3ff 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    font-size: 1.8rem;
                    font-weight: 800;
                    letter-spacing: -0.03em;
                    cursor: pointer;
                    text-decoration: none;
                }

                .route-nav {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    gap: 14px;
                    flex-wrap: wrap;
                }

                .route-nav-link {
                    border: 1px solid rgba(132, 154, 255, 0.2);
                    border-radius: 999px;
                    padding: 11px 18px;
                    text-decoration: none;
                    color: rgba(238, 242, 255, 0.88);
                    background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(16, 19, 42, 0.68));
                    box-shadow: 0 16px 36px rgba(0, 0, 0, 0.22);
                    font-size: 1.1rem;
                    font-weight: 700;
                    letter-spacing: -0.01em;
                    transition: transform 0.2s ease, filter 0.2s ease, border-color 0.2s ease;
                    cursor: pointer;
                }

                .route-nav-link:hover,
                .route-nav-link.is-active {
                    transform: translateY(-2px);
                    filter: brightness(1.04);
                    border-color: rgba(90, 227, 255, 0.45);
                }

                .route-panel {
                    background:
                        linear-gradient(180deg, rgba(53, 214, 255, 0.05), transparent 30%),
                        linear-gradient(180deg, rgba(26, 30, 68, 0.86), rgba(36, 27, 78, 0.78));
                    border: 1px solid rgba(103, 119, 255, 0.26);
                    border-radius: 30px;
                    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.38);
                    backdrop-filter: blur(14px);
                }

                .route-cv-shell {
                    display: grid;
                    grid-template-columns: 1.2fr 0.95fr;
                    gap: 0;
                    align-items: stretch;
                    margin-top: 22px;
                    overflow: hidden;
                    flex: 1;
                }

                .route-cv-copy {
                    padding: 28px 28px 26px;
                    min-height: 270px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    text-align: left;
                    border-radius: 30px 0 0 30px;
                }

                .route-kicker {
                    display: inline-flex;
                    align-self: flex-start;
                    align-items: center;
                    gap: 10px;
                    font-size: 0.78rem;
                    color: rgba(229, 235, 255, 0.72);
                    text-transform: uppercase;
                    letter-spacing: 0.16em;
                    margin-bottom: 12px;
                }

                .route-title {
                    margin: 0;
                    font-size: clamp(1.25rem, 2.1vw, 2rem);
                    line-height: 1.02;
                    letter-spacing: -0.05em;
                }

                .route-title span {
                    display: block;
                    margin-top: 6px;
                    color: #eef2ff;
                }

                .route-lead {
                    margin: 12px 0 0;
                    font-size: 1.3rem;
                    line-height: 1.5;
                    color: rgba(233, 239, 255, 0.78);
                }

                .route-preview {
                    padding: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 270px;
                    border-left: 1px solid rgba(132, 154, 255, 0.18);
                    border-radius: 0 30px 30px 0;
                }

                .route-preview img {
                    width: min(100%, 450px);
                    height: auto;
                    display: block;
                    border-radius: 22px;
                    border: 1px solid rgba(132, 154, 255, 0.25);
                    box-shadow: 0 18px 54px rgba(0, 0, 0, 0.35);
                    object-fit: cover;
                }

                .route-cta-row {
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    gap: 14px;
                    margin: 26px auto;
                }

                .route-cta {
                    text-decoration: none;
                    color: #0c1020;
                    background: linear-gradient(90deg, #f0f5ff 0%, #d6e4ff 100%);
                    border: 1px solid rgba(255,255,255,0.16);
                    border-radius: 999px;
                    padding: 11px 18px;
                    font-weight: 700;
                    font-size: 1.1rem;
                    letter-spacing: -0.01em;
                    box-shadow: 0 16px 36px rgba(0, 0, 0, 0.22);
                    transition: transform 0.2s ease, filter 0.2s ease;
                    cursor: pointer;
                }

                .route-cta:hover {
                    transform: translateY(-2px);
                    filter: brightness(1.03);
                }

                .route-insight-grid {
                    display: grid;
                    grid-template-columns: repeat(3, minmax(0, 1fr));
                    gap: 18px;
                    margin-top: 18px;
                }

                .route-info-card {
                    padding: 20px;
                    border-radius: 24px;
                    background:
                        linear-gradient(180deg, rgba(255, 255, 255, 0.05), transparent 32%),
                        rgba(16, 19, 42, 0.82);
                    border: 1px solid rgba(90, 227, 255, 0.24);
                    box-shadow: 0 16px 42px rgba(0, 0, 0, 0.24);
                }

                .route-info-card h3 {
                    margin: 0 0 10px;
                    font-size: 1.08rem;
                    line-height: 1.2;
                    color: #b9f4ff;
                }

                .route-info-card p {
                    margin: 0;
                    color: rgba(233, 239, 255, 0.76);
                    font-size: 1rem;
                    line-height: 1.55;
                }

                .route-empty-main {
                    flex: 1;
                    margin-top: 22px;
                    min-height: 320px;
                }

                .route-contact-grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 18px;
                    margin-top: 22px;
                    align-items: stretch;
                    flex: 1;
                    min-height: 0;
                }

                .route-contact-copy,
                .route-contact-card,
                .route-empty-main {
                    padding: 18px 22px;
                    border-radius: 24px;
                    background:
                        linear-gradient(180deg, rgba(255, 255, 255, 0.04), transparent 28%),
                        rgba(16, 19, 42, 0.82);
                    border: 1px solid rgba(108, 129, 255, 0.22);
                    box-shadow: 0 12px 38px rgba(0, 0, 0, 0.22);
                }

                .route-contact-copy h1,
                .route-empty-main h1,
                .route-contact-card h2,
                .route-empty-main h2 {
                    margin: 0 0 8px;
                    font-size: 1.3rem;
                    line-height: 1.1;
                    letter-spacing: -0.03em;
                }

                .route-contact-copy p,
                .route-empty-main p {
                    margin: 0;
                    color: rgba(233, 239, 255, 0.78);
                    line-height: 1.45;
                    font-size: 1.1rem;
                    max-width: 78ch;
                }

                .route-form {
                    display: flex;
                    flex-direction: column;
                    gap: 14px;
                }

                .route-form input,
                .route-form textarea {
                    width: 100%;
                    border: 1px solid rgba(90, 227, 255, 0.4);
                    border-radius: 12px;
                    background: rgba(7, 10, 24, 0.72);
                    color: #eef2ff;
                    padding: 12px 16px;
                    font-size: 1rem;
                    outline: none;
                }

                .route-form input::placeholder,
                .route-form textarea::placeholder {
                    color: rgba(233, 239, 255, 0.55);
                }

                .route-form textarea {
                    min-height: 110px;
                    resize: none;
                }

                .route-submit {
                    border: none;
                    border-radius: 12px;
                    padding: 14px;
                    font-size: 1.1rem;
                    color: #0b1635;
                    background: #00e0d9;
                    cursor: pointer;
                    transition: 0.3s;
                    font-weight: 700;
                }

                .route-submit:hover {
                    background: #00c8c2;
                }

                .route-form-note {
                    font-size: 0.95rem;
                    color: rgba(233, 239, 255, 0.7);
                    line-height: 1.45;
                }

                @media (max-width: 1100px) {
                    .route-page {
                        width: min(92vw, 1180px);
                    }

                    .route-cv-shell,
                    .route-insight-grid,
                    .route-contact-grid {
                        grid-template-columns: 1fr;
                        gap: 18px;
                        overflow: visible;
                    }

                    .route-cv-copy,
                    .route-preview {
                        min-height: auto;
                        border-radius: 30px;
                    }

                    .route-preview {
                        border-left: 0;
                    }
                }

                @media (max-width: 760px) {
                    .route-page {
                        padding-top: 86px;
                    }

                    .route-app--cv .route-page {
                        width: min(94vw, 1340px);
                        padding-top: 92px;
                    }

                    .route-app--wide .route-page {
                        width: 100%;
                        padding: 0;
                    }

                    .route-topbar {
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .route-brand {
                        font-size: 1.55rem;
                    }

                    .route-cv-copy,
                    .route-info-card,
                    .route-contact-copy,
                    .route-contact-card,
                    .route-empty-main {
                        padding: 16px 18px;
                    }

                    .route-nav {
                        justify-content: flex-start;
                    }

                    .route-nav-link,
                    .route-cta {
                        width: 100%;
                        text-align: center;
                    }

                    .route-title {
                        font-size: 1.25rem;
                    }

                    .route-lead,
                    .route-contact-copy p {
                        font-size: 1.02rem;
                    }
                }
            `}</style>
            <div className="route-page">{children}</div>
        </div>
    );
}

function RucortexProductPage({ pathname, navigate, onSectionSelect, onCalculatorSelect }) {
    useRoutePageEffect("RuCortex | Промышленная AI-платформа");

    return (
        <RouteShell className="route-app--wide">
            <UnifiedHeader
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={onSectionSelect}
                onCalculatorSelect={onCalculatorSelect}
            />

            <main className="rucortex-page relative z-10 overflow-hidden bg-[#030712] text-[#f5ead2]">
                <section className="relative min-h-screen overflow-hidden bg-[radial-gradient(circle_at_8%_12%,rgba(215,181,109,0.14),transparent_30%),radial-gradient(circle_at_86%_16%,rgba(20,184,166,0.13),transparent_28%),linear-gradient(135deg,#030712_0%,#09111f_48%,#050814_100%)] px-5 pb-28 pt-32 sm:px-8 md:pb-36 md:pt-40 xl:px-12">
                    <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(215,181,109,0.055)_1px,transparent_1px),linear-gradient(rgba(20,184,166,0.045)_1px,transparent_1px)] bg-[length:72px_72px]"></div>
                    <div className="absolute right-[-18%] top-[-10%] h-[620px] w-[620px] rounded-full bg-[#d7b56d]/16 blur-[125px]"></div>
                    <div className="absolute bottom-[-18%] left-[-12%] h-[560px] w-[560px] rounded-full bg-[#14b8a6]/12 blur-[135px]"></div>

                    <div className="relative mx-auto grid max-w-[1520px] gap-14 xl:grid-cols-[1.05fr_0.95fr] xl:items-center xl:gap-24">
                        <article className="min-w-0">
                            <div className="mb-10 flex flex-wrap gap-3">
                                {["корпоративные знания", "RuCortex Creator", "производственные модули"].map((item) => (
                                    <span
                                        key={item}
                                        className="rounded-full border border-[#d7b56d]/24 bg-[#d7b56d]/8 px-4 py-2 text-xs font-black uppercase tracking-[0.16em] text-[#e8d4a2]"
                                    >
                                        {item}
                                    </span>
                                ))}
                            </div>

                            <h1 className="rucortex-hero-title max-w-full break-words text-[clamp(2.7rem,6.8vw,7.1rem)] font-black leading-[0.9] tracking-[-0.075em] text-[#f5ead2] drop-shadow-[0_0_42px_rgba(215,181,109,0.18)] md:max-w-6xl">
                                RuCortex для промышленного AI-контура
                            </h1>
                            <p className="mt-9 max-w-3xl text-xl leading-[1.72] text-[#b8c3d6] md:text-2xl">
                                Платформа связывает документы, регламенты, внутренние базы, модели и
                                прикладные инструменты предприятия, включая RuCortex Creator для генерации
                                документов. Заказчик получает не набор разрозненных экранов, а понятный
                                рабочий контур: источник, ответ, проверка и действие.
                            </p>

                            <div className="mt-12 flex min-w-0 flex-col gap-4 sm:flex-row sm:flex-wrap">
                                <button
                                    type="button"
                                    onClick={() => onSectionSelect("contact-section")}
                                    className="inline-flex w-full max-w-full items-center justify-center rounded-full bg-[#d7b56d] px-8 py-4 text-sm font-black uppercase tracking-[0.16em] text-[#07111f] shadow-[0_18px_44px_rgba(215,181,109,0.24)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#f0cc7b] sm:w-auto"
                                >
                                    Запустить пилот
                                </button>
                                <button
                                    type="button"
                                    onClick={() => navigate("/")}
                                    className="inline-flex w-full max-w-full items-center justify-center rounded-full border border-[#d7b56d]/28 bg-[#0f1728]/70 px-8 py-4 text-sm font-black uppercase tracking-[0.16em] text-[#f5ead2] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#18223a] sm:w-auto"
                                >
                                    Вернуться к компании
                                </button>
                            </div>
                        </article>

                        <aside className="relative min-w-0">
                            <div className="absolute -inset-4 rounded-[3rem] bg-[#d7b56d]/10 blur-2xl"></div>
                            <div className="relative min-w-0 overflow-hidden rounded-[2.5rem] border border-[#d7b56d]/18 bg-[#070b15] p-6 text-[#f5ead2] shadow-[0_34px_90px_rgba(0,0,0,0.48)] md:p-8">
                                <div className="rounded-[2rem] border border-[#d7b56d]/14 bg-[#111827]/80 p-6 md:p-8">
                                    <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between">
                                        <div>
                                            <div className="text-xs font-black uppercase tracking-[0.18em] text-[#d7b56d]">
                                                Рабочий контур
                                            </div>
                                            <div className="mt-2 text-2xl font-black leading-tight">
                                                Документы, данные и действия в одной цепочке
                                            </div>
                                        </div>
                                        <div className="rucortex-pilot-badge hidden rounded-full bg-[#d7b56d] text-xs font-black uppercase tracking-[0.14em] text-[#07111f] sm:inline-flex">
                                            Пилот
                                        </div>
                                    </div>

                                    <div className="mt-9 grid gap-5">
                                        {platformOutcomeItems.map(([title, text]) => (
                                            <div
                                                key={title}
                                                className="min-w-0 rounded-[1.35rem] border border-[#d7b56d]/14 bg-[#0b1220] p-5 text-[#f5ead2] md:p-6"
                                            >
                                                <h3 className="text-xl font-black">{title}</h3>
                                                <p className="mt-3 text-sm leading-[1.72] text-[#a7b4c9] md:text-base">{text}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="mt-6 rounded-[2rem] bg-gradient-to-br from-[#d7b56d] via-[#bd9350] to-[#7f5b2d] p-6 text-[#07111f] shadow-[0_18px_46px_rgba(215,181,109,0.2)] md:p-8">
                                    <div className="text-xs font-black uppercase tracking-[0.18em] opacity-70">
                                        Реальное внедрение
                                    </div>
                                    <div className="mt-3 text-4xl font-black leading-none tracking-[-0.05em]">
                                        ВЗ Электросталь
                                    </div>
                                    <p className="mt-5 text-base leading-[1.72] text-[#2d2a24]">
                                        Вологодская компания купила и внедрила RuCortex. Для новых заказчиков
                                        это подтверждает, что продукт уже проходил проверку в промышленном
                                        рабочем контуре.
                                    </p>
                                </div>
                            </div>
                        </aside>
                    </div>
                </section>

                <section id="rucortex-search-section" className="bg-[#070b15] px-5 py-28 text-[#f5ead2] sm:px-8 md:py-32 xl:px-12">
                    <div className="mx-auto max-w-[1520px]">
                        <div className="flex min-w-0 flex-col gap-12 md:gap-16">
                            <div className="max-w-4xl">
                                <p className="text-sm font-black uppercase tracking-[0.24em] text-[#d7b56d]">
                                    Зачем нужен RuCortex
                                </p>
                                <h2 className="mt-5 max-w-2xl text-3xl font-black leading-[1.02] tracking-[-0.05em] md:text-5xl">
                                    Проблема не в отсутствии AI, а в разрыве между знаниями, данными и действием
                                </h2>
                                <p className="mt-7 max-w-3xl text-lg leading-[1.75] text-[#a7b4c9]">
                                    RuCortex закрывает разрыв между источниками данных, проверяемыми
                                    ответами и действиями сотрудников. В одном контуре видны документы,
                                    знания, интеграции и результат, который можно использовать в работе.
                                </p>
                            </div>

                            <div className="grid w-full gap-6">
                                {platformProblemItems.map((item, index) => (
                                    <article
                                        key={item.label}
                                        className={`relative min-w-0 overflow-hidden rounded-[2rem] border p-7 md:p-9 ${
                                            index === 2
                                                ? "border-[#d7b56d]/28 bg-[#d7b56d] text-[#07111f]"
                                                : "border-[#d7b56d]/14 bg-[#0f1728] text-[#f5ead2]"
                                        }`}
                                    >
                                        <div className={`text-xs font-black uppercase tracking-[0.22em] ${
                                            index === 2 ? "text-[#07111f]/62" : "text-[#d7b56d]"
                                        }`}>
                                            {item.label}
                                        </div>
                                        <h3 className="mt-5 text-2xl font-black leading-tight tracking-[-0.035em] md:text-3xl">
                                            {item.title}
                                        </h3>
                                        <p className={`mt-5 text-base leading-[1.75] md:text-lg ${
                                            index === 2 ? "text-[#202018]/76" : "text-[#a7b4c9]"
                                        }`}>
                                            {item.text}
                                        </p>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="bg-[#070b15] px-5 py-28 text-[#f5ead2] sm:px-8 md:py-32 xl:px-12">
                    <div className="mx-auto flex max-w-[1520px] min-w-0 flex-col gap-12 md:gap-16">
                        <div className="max-w-4xl">
                            <p className="text-sm font-black uppercase tracking-[0.24em] text-[#d7b56d]">
                                Что меняется для заказчика
                            </p>
                            <h2 className="mt-5 max-w-2xl text-3xl font-black leading-[1.02] tracking-[-0.05em] md:text-5xl">
                                Вместо поиска по папкам появляется управляемая система знаний
                            </h2>
                            <p className="mt-7 max-w-3xl text-lg leading-[1.75] text-[#a7b4c9]">
                                Платформа выстраивает понятный путь от источников и AI-ядра до рабочих
                                модулей, чтобы результат можно было проверить и использовать в процессе.
                            </p>
                        </div>

                        <div className="grid w-full gap-6">
                            {platformLayerItems.map((item) => (
                                <article
                                    key={item.title}
                                    className="min-w-0 rounded-[2rem] border border-[#d7b56d]/14 bg-[#0f1728]/74 p-7 shadow-[0_18px_44px_rgba(0,0,0,0.18)] md:p-9"
                                >
                                    <div className="text-sm font-black uppercase tracking-[0.2em] text-[#d7b56d]/82">
                                        {item.label}
                                    </div>
                                    <h3 className="mt-5 text-3xl font-black leading-tight tracking-[-0.04em] text-[#f5ead2]">{item.title}</h3>
                                    <p className="mt-5 max-w-4xl text-lg leading-[1.75] text-[#a7b4c9]">{item.text}</p>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section id="creator-section" className="relative overflow-hidden bg-[#050914] px-5 py-28 text-[#f5ead2] sm:px-8 md:py-32 xl:px-12">
                    <div className="absolute right-[-12%] top-[-18%] h-[620px] w-[620px] rounded-full bg-[#d7b56d]/14 blur-[130px]"></div>
                    <div className="absolute left-[-10%] bottom-[-20%] h-[520px] w-[520px] rounded-full bg-cyan-400/10 blur-[140px]"></div>
                    <div className="relative mx-auto grid max-w-[1520px] gap-14 xl:grid-cols-[0.94fr_1.06fr] xl:items-center xl:gap-24">
                        <div className="min-w-0">
                            <div className="mb-5 inline-flex rounded-full border border-[#d7b56d]/28 bg-[#d7b56d]/10 px-4 py-2 text-xs font-black uppercase tracking-[0.18em] text-[#d7b56d]">
                                Документы и шаблоны
                            </div>
                            <h2 className="max-w-3xl text-3xl font-black leading-[1.02] tracking-[-0.05em] md:text-6xl">
                                RuCortex Creator для генерации документов
                            </h2>
                            <p className="mt-7 max-w-3xl text-lg leading-[1.75] text-[#a7b4c9] md:text-xl">
                                Creator помогает готовить договоры, коммерческие предложения, справки,
                                письма, отчеты и технические описания на основе входного DOCX-файла,
                                шаблонов, исходных данных и корпоративных знаний. Итоговый документ
                                передается на проверку ответственному специалисту.
                            </p>
                            <div className="mt-10 flex min-w-0 flex-col gap-4 sm:flex-row sm:flex-wrap">
                                <button
                                    type="button"
                                    onClick={() => onSectionSelect("contact-section")}
                                    className="inline-flex w-full max-w-full items-center justify-center rounded-full bg-[#d7b56d] px-8 py-4 text-sm font-black uppercase tracking-[0.16em] text-[#07111f] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#f0cc7b] sm:w-auto"
                                >
                                    Обсудить внедрение
                                </button>
                                <button
                                    type="button"
                                    onClick={() => onSectionSelect("contact-section")}
                                    className="inline-flex w-full max-w-full items-center justify-center rounded-full border border-[#d7b56d]/24 px-8 py-4 text-sm font-black uppercase tracking-[0.16em] text-[#f5ead2] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#d7b56d]/10 sm:w-auto"
                                >
                                    Получить демонстрацию
                                </button>
                            </div>
                        </div>

                        <div className="relative min-w-0">
                            <div className="absolute -inset-4 rounded-[2.4rem] bg-[#d7b56d]/12 blur-2xl"></div>
                            <div className="relative min-w-0 overflow-hidden rounded-[2rem] border border-[#d7b56d]/22 bg-[#07101f] p-6 shadow-[0_32px_86px_rgba(0,0,0,0.44)] md:p-8">
                                <div className="rounded-[1.55rem] border border-white/10 bg-[#0d1424] p-6 md:p-8">
                                    <div className="flex flex-wrap items-start justify-between gap-5 border-b border-white/10 pb-6">
                                        <div>
                                            <div className="text-xs font-black uppercase tracking-[0.18em] text-[#d7b56d]">
                                                Работа с документом
                                            </div>
                                            <div className="mt-2 text-xl font-black text-white">
                                                Коммерческое предложение
                                            </div>
                                        </div>
                                        <div className="rounded-full bg-[#d7b56d]/12 px-3 py-1.5 text-xs font-black uppercase tracking-[0.12em] text-[#f5ead2]">
                                            DOCX
                                        </div>
                                    </div>

                                    <div className="mt-7 grid gap-5">
                                        {creatorFeatureItems.map(([title, text], index) => (
                                            <div
                                                key={title}
                                                className={`grid min-w-0 gap-3 rounded-[1.2rem] border p-5 md:p-6 ${
                                                    index === 1
                                                        ? "border-[#d7b56d]/26 bg-[#d7b56d]/12"
                                                        : "border-white/10 bg-white/[0.045]"
                                                }`}
                                            >
                                                <div className="font-mono text-xs font-black text-[#d7b56d]">
                                                    {String(index + 1).padStart(2, "0")}
                                                </div>
                                                <div>
                                                    <div className="text-base font-black text-white">{title}</div>
                                                    <p className="mt-3 text-sm leading-[1.72] text-blue-100/68">{text}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="mt-7 rounded-[1.3rem] border border-cyan-300/16 bg-cyan-300/8 p-5 md:p-6">
                                        <div className="text-xs font-black uppercase tracking-[0.18em] text-cyan-100/72">
                                            Контроль результата
                                        </div>
                                        <p className="mt-3 text-sm leading-[1.72] text-blue-100/72">
                                            Система ускоряет подготовку структуры и текста, помогает вносить
                                            управляемые правки, а финальная проверка остается за ответственным
                                            специалистом.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="rucortex-modules-section" className="relative overflow-hidden bg-[linear-gradient(180deg,#040814_0%,#0a1020_100%)] px-5 py-28 sm:px-8 md:py-32 xl:px-12">
                    <div className="absolute inset-y-0 left-1/2 w-px bg-[#d7b56d]/10"></div>
                    <div className="absolute left-[-12%] top-[10%] h-[520px] w-[520px] rounded-full bg-[#14b8a6]/10 blur-[130px]"></div>
                    <div className="relative mx-auto max-w-[1520px]">
                        <div className="max-w-5xl">
                            <p className="text-sm font-black uppercase tracking-[0.24em] text-[#d7b56d]">
                                Продуктовая карта
                            </p>
                            <h2 className="mt-5 text-3xl font-black leading-[1.02] tracking-[-0.05em] text-[#f5ead2] md:text-6xl">
                                Один продукт, несколько точек входа для предприятия
                            </h2>
                            <p className="mt-7 max-w-3xl text-xl leading-[1.75] text-[#a7b4c9]">
                                Каждый модуль раскрывает отдельный сценарий внедрения, но остается частью
                                общей платформы: от базы знаний и AI-поиска до производственных событий.
                            </p>
                        </div>

                        <div className="mt-16 flex w-full max-w-[1180px] flex-col gap-6">
                            {platformModuleCards.slice(0, 5).map(([title, text], index) => {
                                const isCore = index === 0;
                                const isCreator = title === "RuCortex Creator";
                                const isCalculator = title === "МеталлКалькулятор";

                                return (
                                    <article
                                        key={title}
                                        className={`w-full min-w-0 rounded-[2rem] border p-7 shadow-[0_20px_48px_rgba(0,0,0,0.22)] md:p-9 ${
                                            isCore
                                                ? "border-[#d7b56d]/22 bg-gradient-to-br from-[#d7b56d] to-[#7f5b2d] text-[#07111f]"
                                                : isCreator
                                                    ? "border-[#d7b56d]/28 bg-[#d7b56d]/12 text-[#f5ead2]"
                                                    : isCalculator
                                                        ? "border-[#14b8a6]/22 bg-[#0f766e]/24 text-[#f5ead2]"
                                                        : "border-[#d7b56d]/14 bg-[#101827]/82 text-[#f5ead2]"
                                        }`}
                                    >
                                    <div className={`text-xs font-black uppercase tracking-[0.2em] ${
                                        isCore ? "text-[#07111f]/70" : "text-[#d7b56d]"
                                    }`}>
                                        {title}
                                    </div>
                                    <p className={`mt-5 max-w-4xl text-xl font-black leading-[1.22] tracking-[-0.03em] ${
                                        isCore ? "md:text-3xl" : "md:text-2xl"
                                    }`}>
                                        {text}
                                    </p>
                                </article>
                                );
                            })}
                        </div>
                    </div>
                </section>

                <section id="rucortex-pilot-section" className="bg-[#090f1c] px-5 py-28 text-[#f5ead2] sm:px-8 md:py-32 xl:px-12">
                    <div className="mx-auto max-w-[1520px]">
                        <div className="flex min-w-0 flex-col gap-8 md:gap-10">
                            <div className="max-w-5xl">
                                <p className="text-sm font-black uppercase tracking-[0.24em] text-[#d7b56d]">
                                    Как запускать
                                </p>
                                <h2 className="mt-5 text-3xl font-black leading-[1.02] tracking-[-0.05em] text-[#f5ead2] md:text-6xl">
                                    Пилот строится как инженерная проверка с понятными метриками
                                </h2>
                                <p className="mt-6 text-2xl font-black text-[#d7b56d] md:text-3xl">
                                    Стоимость внедрения — от 500 000 ₽
                                </p>
                            </div>
                            <p className="max-w-4xl text-xl leading-[1.75] text-[#a7b4c9]">
                                Такой формат проще продавать промышленному заказчику: мы заранее фиксируем
                                процесс, источники, ограничения, метрики качества и условия масштабирования.
                            </p>
                        </div>

                        <div className="mt-16 flex w-full max-w-[1180px] flex-col gap-6">
                            {platformPilotItems.map(([step, title, text]) => (
                                <article key={step} className="min-w-0 rounded-[2rem] border border-[#d7b56d]/14 bg-[#0f1728] p-7 md:p-9">
                                    <div className="text-6xl font-black leading-none tracking-[-0.08em] text-[#d7b56d]/28">
                                        {step}
                                    </div>
                                    <h3 className="mt-7 text-2xl font-black tracking-[-0.04em] text-[#f5ead2]">{title}</h3>
                                    <p className="mt-5 max-w-4xl text-base leading-[1.75] text-[#a7b4c9]">{text}</p>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="relative overflow-hidden bg-[#030712] px-5 py-28 text-[#f5ead2] sm:px-8 md:py-36 xl:px-12">
                    <div className="absolute right-[-12%] top-[-30%] h-[620px] w-[620px] rounded-full bg-[#d7b56d]/16 blur-[130px]"></div>
                    <div className="relative mx-auto flex max-w-[1520px] min-w-0 flex-col gap-12 md:gap-16">
                        <div className="max-w-5xl">
                            <p className="text-sm font-black uppercase tracking-[0.24em] text-[#d7b56d]">
                                Готовность к следующему шагу
                            </p>
                            <h2 className="mt-5 text-3xl font-black leading-[1.02] tracking-[-0.05em] md:text-6xl">
                                Начните с одного сценария и покажите эффект на реальных данных
                            </h2>
                        </div>
                        <div className="w-full max-w-[1180px] rounded-[2rem] border border-[#d7b56d]/14 bg-[#0f1728]/86 p-7 shadow-[0_24px_60px_rgba(0,0,0,0.28)] md:p-10">
                            <p className="max-w-4xl text-lg leading-[1.75] text-[#a7b4c9]">
                                Пилот можно начать с одного приоритетного направления: AI-поиска по
                                документам, RuCortex Creator, интеграции с 1C или CRM, контроля СИЗ,
                                распознавания номеров или металлкалькулятора для склада и продаж.
                                После выбора сценария фиксируются контур внедрения и критерии результата.
                            </p>
                            <div className="mt-10 flex min-w-0 flex-col gap-4 sm:flex-row sm:flex-wrap">
                                <button
                                    type="button"
                                    onClick={() => onSectionSelect("contact-section")}
                                    className="inline-flex w-full max-w-full items-center justify-center rounded-full bg-[#d7b56d] px-8 py-4 text-sm font-black uppercase tracking-[0.16em] text-[#07111f] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#f0cc7b] sm:w-auto"
                                >
                                    Запросить демонстрацию
                                </button>
                                <button
                                    type="button"
                                    onClick={() => navigate("/calculator")}
                                    className="inline-flex w-full max-w-full items-center justify-center rounded-full border border-[#d7b56d]/24 px-8 py-4 text-sm font-black uppercase tracking-[0.16em] text-[#f5ead2] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#d7b56d]/10 sm:w-auto"
                                >
                                    МеталлКалькулятор
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </RouteShell>
    );
}

function CvPage({ pathname, navigate, onSectionSelect, onCalculatorSelect }) {
    useRoutePageEffect("RuCortex | Контроль касок");

    return (
        <RouteShell className="route-app--cv">
            <UnifiedHeader
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={onSectionSelect}
                onCalculatorSelect={onCalculatorSelect}
            />

            <main className="product-route-page product-route-page--cv relative z-10 mx-auto w-[94vw] max-w-[1340px] space-y-4 pb-12 pt-24 md:space-y-6 md:pt-28">
                <section className="relative overflow-hidden rounded-[1.6rem] border border-cyan-300/24 bg-[#081023] shadow-[0_18px_46px_rgba(0,0,0,0.32)] md:rounded-[2.4rem]">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_12%,rgba(34,211,238,0.24),transparent_34%),radial-gradient(circle_at_82%_10%,rgba(215,181,109,0.2),transparent_30%),linear-gradient(135deg,rgba(255,255,255,0.06),transparent_42%)]"></div>
                    <div className="relative z-10 grid gap-0 lg:grid-cols-[1.05fr_0.95fr]">
                        <article className="flex min-h-0 flex-col justify-center p-5 py-8 sm:p-7 md:p-10 lg:min-h-[560px] xl:p-14">
                            <div className="mb-5 inline-flex w-fit rounded-full border border-cyan-300/25 bg-cyan-300/10 px-3 py-2 text-[0.68rem] font-black uppercase tracking-[0.16em] text-cyan-100 sm:px-4 sm:text-xs">
                                Компьютерное зрение для охраны труда
                            </div>
                            <h1 className="max-w-4xl text-3xl font-black leading-[1.04] tracking-[-0.04em] text-white sm:text-4xl md:text-5xl md:tracking-[-0.05em] xl:text-6xl">
                                Контроль касок без ручного просмотра камер
                            </h1>
                            <p className="mt-5 max-w-2xl text-base leading-relaxed text-blue-100/82 md:mt-7 md:text-xl">
                                RuCortex подключается к существующим видеопотокам, фиксирует
                                отсутствие каски и собирает события, с которыми служба ОТ
                                может работать как с понятной очередью рисков.
                            </p>

                            <div className="mt-7 grid max-w-2xl grid-cols-1 gap-3 sm:grid-cols-3 md:mt-8">
                                {[
                                    ["CCTV", "работаем с текущими камерами"],
                                    ["События", "кадр, время, зона, тип риска"],
                                    ["Пилот", "точность и ложные срабатывания"],
                                ].map(([label, text]) => (
                                    <div
                                        key={label}
                                        className="rounded-2xl border border-white/10 bg-white/[0.055] p-4"
                                    >
                                        <div className="text-xl font-black text-cyan-200 md:text-2xl">{label}</div>
                                        <div className="mt-1 text-sm leading-snug text-blue-100/70">{text}</div>
                                    </div>
                                ))}
                            </div>

                            <div className="mt-8 flex flex-col gap-3 sm:flex-row md:mt-9">
                                <button
                                    type="button"
                                    onClick={() => navigate("/cv/contact")}
                                    className="w-full rounded-full bg-gradient-to-r from-cyan-300 to-[#f0cc7b] px-6 py-4 text-center text-sm font-black text-[#081023] shadow-[0_0_28px_rgba(56,189,248,0.42)] transition-all duration-300 hover:-translate-y-0.5 sm:w-auto md:px-7 md:text-base"
                                >
                                    Обсудить пилот по камерам
                                </button>
                                <button
                                    type="button"
                                    onClick={() => navigate("/cv/calculate")}
                                    className="w-full rounded-full border border-cyan-300/35 bg-white/8 px-6 py-4 text-center text-sm font-bold text-cyan-100 transition-all duration-300 hover:bg-white/12 sm:w-auto md:px-7 md:text-base"
                                >
                                    Как считается стоимость
                                </button>
                            </div>
                        </article>

                        <aside className="relative flex min-h-0 items-center justify-center border-t border-cyan-300/14 bg-black/18 p-4 sm:p-5 lg:min-h-[520px] lg:border-l lg:border-t-0 xl:p-9">
                            <div className="absolute inset-4 rounded-[1.5rem] bg-cyan-300/8 blur-xl md:inset-6 md:rounded-[2rem]"></div>
                            <div className="relative w-full max-w-[640px] overflow-hidden rounded-[1.4rem] border border-cyan-200/24 bg-[#0d142c] shadow-[0_18px_42px_rgba(0,0,0,0.34)] md:rounded-[2rem]">
                                <img
                                    src={helmetPreview}
                                    alt="Превью фиксации отсутствия каски"
                                    loading="eager"
                                    decoding="async"
                                    className="block aspect-[4/3] w-full object-cover sm:aspect-[16/11] lg:aspect-auto"
                                />
                                <div className="absolute left-3 top-3 rounded-full bg-red-500/90 px-3 py-1.5 text-xs font-black text-white shadow-[0_0_12px_rgba(239,68,68,0.35)] sm:left-4 sm:top-4 sm:px-4 sm:py-2 sm:text-sm">
                                    Событие: нет каски
                                </div>
                                <div className="absolute bottom-3 left-3 right-3 rounded-2xl border border-white/12 bg-[#07101f]/86 p-3 backdrop-blur-md sm:bottom-4 sm:left-4 sm:right-4 sm:p-4">
                                    <div className="flex flex-wrap gap-1.5 text-[0.62rem] font-bold uppercase tracking-[0.1em] text-cyan-100/80 sm:gap-2 sm:text-xs">
                                        <span className="rounded-full bg-white/10 px-2.5 py-1 sm:px-3">Камера 03</span>
                                        <span className="rounded-full bg-white/10 px-2.5 py-1 sm:px-3">Зона: склад</span>
                                        <span className="rounded-full bg-white/10 px-2.5 py-1 sm:px-3">Нужна проверка</span>
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>
                </section>

                <section className="relative overflow-hidden rounded-[1.8rem] border border-[#d7b56d]/18 bg-[#0b1020] p-5 shadow-[0_20px_58px_rgba(0,0,0,0.28)] md:rounded-[2.4rem] md:p-8">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_12%_18%,rgba(215,181,109,0.16),transparent_30%),radial-gradient(circle_at_88%_4%,rgba(34,211,238,0.14),transparent_28%)]"></div>
                    <div className="relative grid gap-8 lg:grid-cols-[0.82fr_1.18fr]">
                        <div>
                            <p className="text-xs font-black uppercase tracking-[0.24em] text-[#d7b56d]">
                                Пульт охраны труда
                            </p>
                            <h2 className="mt-4 text-2xl font-black leading-tight tracking-[-0.035em] text-white md:text-3xl">
                                Не просто детекция, а очередь событий для проверки
                            </h2>
                            <p className="mt-5 text-base leading-relaxed text-blue-100/74 md:text-lg">
                                Страница касок должна ощущаться как рабочий экран специалиста: камера,
                                зона, приоритет, кадр и понятное действие по каждому нарушению.
                            </p>
                            <div className="mt-7 grid grid-cols-2 gap-3">
                                {[
                                    ["03", "камеры в пилоте"],
                                    ["12", "событий за смену"],
                                    ["2 мин", "до проверки кадра"],
                                    ["ОТ", "ответственный контур"],
                                ].map(([value, label]) => (
                                    <div key={label} className="rounded-[1.25rem] border border-white/10 bg-white/[0.055] p-4">
                                        <div className="text-2xl font-black text-[#f5ead2]">{value}</div>
                                        <div className="mt-1 text-xs font-bold uppercase tracking-[0.14em] text-blue-100/50">{label}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="grid gap-3">
                            {cvInsightItems.map((item, index) => (
                                <article
                                    key={item.title}
                                    className={`relative overflow-hidden rounded-[1.35rem] border p-4 md:p-5 ${
                                        index === 0
                                            ? "border-[#d7b56d]/28 bg-[#d7b56d]/14"
                                            : index === 4
                                                ? "border-cyan-300/22 bg-cyan-300/10"
                                                : "border-white/10 bg-white/[0.05]"
                                    }`}
                                >
                                    <div className="grid gap-4 md:grid-cols-[auto_1fr_auto] md:items-start">
                                        <div className="flex h-11 w-11 items-center justify-center rounded-2xl border border-white/10 bg-[#07101f] text-sm font-black text-[#f5ead2]">
                                            {String(index + 1).padStart(2, "0")}
                                        </div>
                                        <div>
                                            <h3 className="text-lg font-black leading-tight text-white md:text-xl">{item.title}</h3>
                                            <p className="mt-2 text-sm leading-relaxed text-blue-100/72 md:text-base">{item.text}</p>
                                        </div>
                                        <div className="w-fit rounded-full border border-white/10 bg-white/[0.07] px-3 py-1 text-xs font-black uppercase tracking-[0.14em] text-cyan-100">
                                            {index === 0 ? "риск" : index === 4 ? "отчет" : "контроль"}
                                        </div>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="relative overflow-hidden rounded-[1.6rem] border border-cyan-300/16 bg-[#07101f]/92 p-5 shadow-[0_14px_38px_rgba(0,0,0,0.26)] md:rounded-[2rem] md:p-8">
                    <div className="absolute inset-y-8 left-8 hidden w-px bg-gradient-to-b from-[#d7b56d] via-cyan-300 to-transparent md:block"></div>
                    <div className="grid gap-6 lg:grid-cols-[0.72fr_1.28fr]">
                        <div className="flex items-center justify-center rounded-[1.4rem] border border-white/10 bg-white/[0.045] p-5">
                            <img
                                src={helmetBg}
                                alt="Иконка решения контроля касок"
                                loading="lazy"
                                decoding="async"
                                className="w-[150px] max-w-[54vw] object-contain opacity-95 drop-shadow-[0_0_22px_rgba(56,189,248,0.35)]"
                            />
                        </div>
                        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
                            {[
                                ["Камера", "получаем поток с зоны риска"],
                                ["Модель", "выделяет отсутствие каски и сохраняет кадр"],
                                ["ОТ", "проверяет событие и видит повторяемость"],
                            ].map(([title, text], index) => (
                                <div key={title} className="relative rounded-2xl border border-white/10 bg-white/[0.055] p-4">
                                    <div className="mb-4 h-1 w-12 rounded-full bg-gradient-to-r from-[#d7b56d] to-cyan-300"></div>
                                    <div className="text-lg font-black text-cyan-100">{title}</div>
                                    <p className="mt-2 text-sm leading-relaxed text-blue-100/72">{text}</p>
                                    <div className="absolute right-4 top-4 text-xs font-black text-white/22">{String(index + 1).padStart(2, "0")}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="overflow-hidden rounded-[1.6rem] border border-[#d7b56d]/18 bg-[#0c1228]/88 p-5 shadow-[0_14px_38px_rgba(0,0,0,0.26)] md:rounded-[2rem] md:p-10">
                    <div className="grid gap-8 xl:grid-cols-[0.85fr_1.15fr]">
                        <div>
                            <p className="text-xs font-black uppercase tracking-[0.2em] text-cyan-300/80 md:text-sm md:tracking-[0.25em]">
                                Внедрение без тяжелого старта
                            </p>
                            <h2 className="mt-4 text-2xl font-black leading-tight tracking-[-0.035em] text-white md:text-3xl">
                                Проверяем на малом контуре и только потом масштабируем
                            </h2>
                            <p className="mt-5 text-base leading-relaxed text-blue-100/76 md:text-lg">
                                Такой формат честнее для заказчика: сначала видим качество на
                                реальном видеопотоке, а затем считаем инфраструктуру, SLA и стоимость.
                            </p>
                        </div>

                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                            {cvRolloutItems.map((item) => (
                                <article
                                    key={item.step}
                                    className="rounded-[1.25rem] border border-white/10 bg-white/[0.055] p-4 md:rounded-[1.4rem] md:p-5"
                                >
                                    <div className="text-xs font-black tracking-[0.28em] text-cyan-300 md:text-sm">
                                        {item.step}
                                    </div>
                                    <h3 className="mt-3 text-lg font-black text-white md:mt-4 md:text-xl">{item.title}</h3>
                                    <p className="mt-3 text-sm leading-relaxed text-blue-100/72">
                                        {item.text}
                                    </p>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="rounded-[1.6rem] border border-cyan-300/18 bg-gradient-to-r from-cyan-300/12 via-[#111633] to-[#d7b56d]/12 p-5 text-center shadow-[0_12px_34px_rgba(0,0,0,0.24)] md:rounded-[2rem] md:p-10">
                            <h2 className="text-2xl font-black leading-tight text-white md:text-3xl">
                        Если камеры уже есть, можно проверить сценарий без закупки новой инфраструктуры
                    </h2>
                    <p className="mx-auto mt-4 max-w-3xl text-base leading-relaxed text-blue-100/78 md:text-lg">
                        Оставьте заявку: обсудим площадку, качество видеопотоков, зоны контроля и
                        критерии, по которым будет понятно, стоит ли запускать систему в боевой режим.
                    </p>
                    <button
                        type="button"
                        onClick={() => navigate("/cv/contact")}
                        className="mt-7 w-full rounded-full bg-white px-8 py-4 text-sm font-black text-[#081023] shadow-[0_0_28px_rgba(255,255,255,0.2)] transition-all duration-300 hover:-translate-y-0.5 sm:w-auto md:text-base"
                    >
                        Получить план пилота
                    </button>
                </section>
            </main>
        </RouteShell>
    );
}

function CvInfoPage({ pathname, navigate, onSectionSelect, onCalculatorSelect, page }) {
    useRoutePageEffect(`RuCortex | ${page.title}`);

    return (
        <RouteShell className="route-app--cv">
            <UnifiedHeader
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={onSectionSelect}
                onCalculatorSelect={onCalculatorSelect}
            />

            <main className="product-route-page product-route-page--cv product-route-page--service relative z-10 mx-auto w-[94vw] max-w-[1340px] space-y-4 pb-12 pt-24 md:space-y-6 md:pt-28">
                <section className="relative overflow-hidden rounded-[1.6rem] bg-[#081023] shadow-[0_18px_46px_rgba(0,0,0,0.32)] md:rounded-[2.4rem]">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_16%_12%,rgba(215,181,109,0.2),transparent_32%),radial-gradient(circle_at_82%_8%,rgba(34,211,238,0.16),transparent_30%),linear-gradient(135deg,rgba(255,255,255,0.06),transparent_46%)]"></div>
                    <div className="relative z-10 grid gap-0 lg:grid-cols-[0.95fr_1.05fr]">
                        <article className="flex min-h-0 flex-col justify-center p-5 py-8 sm:p-7 md:p-10 lg:min-h-[500px] xl:p-12">
                            <div className="mb-5 inline-flex w-fit rounded-full border border-[#d7b56d]/24 bg-[#d7b56d]/10 px-3 py-2 text-[0.68rem] font-black uppercase tracking-[0.16em] text-[#f5ead2] sm:px-4 sm:text-xs">
                                {page.kicker}
                            </div>
                            <h1 className="max-w-4xl text-3xl font-black leading-[1.02] tracking-[-0.045em] text-white sm:text-4xl md:text-5xl">
                                {page.title}
                            </h1>
                            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-blue-100/82 md:text-xl">
                                {page.lead}
                            </p>
                            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                                <button
                                    type="button"
                                    onClick={() => navigate("/cv/contact")}
                                    className="inline-flex w-full items-center justify-center rounded-full bg-gradient-to-r from-cyan-300 to-[#f0cc7b] px-7 py-4 text-center text-sm font-black text-[#081023] shadow-[0_0_28px_rgba(56,189,248,0.34)] transition-all duration-300 hover:-translate-y-0.5 sm:w-auto md:text-base"
                                >
                                    {page.primaryAction}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => navigate("/cv")}
                                    className="w-full rounded-full border border-cyan-300/35 bg-white/8 px-7 py-4 text-center text-sm font-bold text-cyan-100 transition-all duration-300 hover:bg-white/12 sm:w-auto md:text-base"
                                >
                                    Вернуться к решению
                                </button>
                            </div>
                        </article>

                        <aside className="relative flex min-h-0 items-center justify-center border-t border-cyan-300/14 bg-black/22 p-5 lg:min-h-[500px] lg:border-l lg:border-t-0 xl:p-10">
                            <div className="w-full max-w-[620px] rounded-[2rem] bg-[#050b17] p-4 shadow-[0_24px_70px_rgba(0,0,0,0.42),inset_0_0_0_1px_rgba(255,255,255,0.08)]">
                                <div className="rounded-[1.5rem] bg-[linear-gradient(135deg,rgba(215,181,109,0.16),rgba(34,211,238,0.08)),#0b1428] p-5">
                                    <div className="text-xs font-black uppercase tracking-[0.18em] text-cyan-200/78">
                                        {page.asideLabel}
                                    </div>
                                    <h2 className="mt-4 text-2xl font-black leading-tight text-white md:text-3xl">
                                        {page.asideTitle}
                                    </h2>
                                    <div className="mt-6 grid gap-3">
                                        {page.asideItems.map((item, index) => (
                                            <div key={item} className="grid grid-cols-[auto_1fr] gap-3 rounded-2xl bg-white/[0.065] p-4">
                                                <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-cyan-300 text-xs font-black text-[#07101f]">
                                                    {index + 1}
                                                </span>
                                                <p className="text-sm font-bold leading-relaxed text-blue-100/76">{item}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>
                </section>

                <section className="grid grid-cols-1 gap-3 md:grid-cols-3 md:gap-4">
                    {page.highlights.map((item) => (
                        <article
                            key={item.title}
                            className="rounded-[1.4rem] bg-[#111633]/82 p-5 shadow-[0_10px_28px_rgba(0,0,0,0.22)] md:rounded-[1.6rem] md:p-6"
                        >
                            <div className="mb-5 h-1.5 w-14 rounded-full bg-gradient-to-r from-[#d7b56d] to-cyan-300"></div>
                            <h2 className="text-xl font-black leading-tight text-white md:text-2xl">{item.title}</h2>
                            <p className="mt-3 text-sm leading-relaxed text-blue-100/76 md:text-base">{item.text}</p>
                        </article>
                    ))}
                </section>

                <section className="grid grid-cols-1 gap-4 rounded-[1.6rem] bg-[#0c1228]/88 p-5 shadow-[0_14px_38px_rgba(0,0,0,0.26)] md:rounded-[2rem] md:p-10 lg:grid-cols-[0.85fr_1.15fr]">
                    <div>
                        <p className="text-xs font-black uppercase tracking-[0.2em] text-cyan-300/80 md:text-sm md:tracking-[0.25em]">
                            {page.processKicker}
                        </p>
                            <h2 className="mt-4 text-2xl font-black leading-tight tracking-[-0.035em] text-white md:text-3xl">
                            {page.processTitle}
                        </h2>
                        <p className="mt-5 text-base leading-relaxed text-blue-100/76 md:text-lg">
                            {page.processText}
                        </p>
                    </div>

                    <div className="grid grid-cols-1 gap-3">
                        {page.steps.map((item) => (
                            <div
                                key={item.step}
                                className="grid grid-cols-[auto_1fr] gap-4 rounded-2xl bg-white/[0.055] p-4"
                            >
                                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#d7b56d] text-sm font-black text-[#081023]">
                                    {item.step}
                                </div>
                                <div>
                                    <h3 className="text-lg font-black text-cyan-100">{item.title}</h3>
                                    <p className="mt-1 text-sm leading-relaxed text-blue-100/72 md:text-base">{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="rounded-[1.6rem] bg-gradient-to-r from-cyan-300/12 via-[#111633] to-[#d7b56d]/12 p-5 text-center shadow-[0_12px_34px_rgba(0,0,0,0.24)] md:rounded-[2rem] md:p-10">
                            <h2 className="mx-auto max-w-4xl text-2xl font-black leading-tight text-white md:text-3xl">
                        {page.ctaTitle}
                    </h2>
                    <p className="mx-auto mt-4 max-w-3xl text-base leading-relaxed text-blue-100/78 md:text-lg">
                        {page.ctaText}
                    </p>
                    <button
                        type="button"
                        onClick={() => navigate("/cv/contact")}
                        className="mt-7 w-full rounded-full bg-white px-8 py-4 text-sm font-black text-[#081023] shadow-[0_0_28px_rgba(255,255,255,0.2)] transition-all duration-300 hover:-translate-y-0.5 sm:w-auto md:text-base"
                    >
                        {page.ctaAction}
                    </button>
                </section>
            </main>
        </RouteShell>
    );
}

function ContactRoutePage({ pathname, navigate, onSectionSelect, onCalculatorSelect }) {
    useRoutePageEffect("RuCortex | Связаться с нами");

    return (
        <RouteShell className="route-app--cv">
            <UnifiedHeader
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={onSectionSelect}
                onCalculatorSelect={onCalculatorSelect}
            />

            <main className="product-route-page product-route-page--cv product-route-page--service relative z-10 mx-auto w-[94vw] max-w-[1340px] space-y-4 pb-12 pt-24 md:space-y-6 md:pt-28">
                <section className="relative overflow-hidden rounded-[1.6rem] bg-[#081023] shadow-[0_18px_46px_rgba(0,0,0,0.32)] md:rounded-[2.4rem]">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_16%_12%,rgba(215,181,109,0.2),transparent_32%),radial-gradient(circle_at_82%_8%,rgba(34,211,238,0.16),transparent_30%),linear-gradient(135deg,rgba(255,255,255,0.06),transparent_46%)]"></div>
                    <div className="relative z-10 grid gap-0 lg:grid-cols-[0.9fr_1.1fr]">
                        <article className="flex min-h-0 flex-col justify-center p-5 py-8 sm:p-7 md:p-10 lg:min-h-[540px] xl:p-12">
                            <div className="mb-5 inline-flex w-fit rounded-full border border-[#d7b56d]/24 bg-[#d7b56d]/10 px-3 py-2 text-[0.68rem] font-black uppercase tracking-[0.16em] text-[#f5ead2] sm:px-4 sm:text-xs">
                                Заявка на пилот
                            </div>
                            <h1 className="max-w-4xl text-3xl font-black leading-[1.02] tracking-[-0.045em] text-white sm:text-4xl md:text-5xl">
                                Опишите площадку, камеры и задачу
                            </h1>
                            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-blue-100/82 md:text-xl">
                                Мы предложим формат пилота, список подключений и критерии, по которым
                                будет понятно, есть ли эффект на вашей инфраструктуре.
                            </p>
                            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-3">
                                {[
                                    ["1", "площадка и камеры"],
                                    ["2", "сценарий контроля"],
                                    ["3", "критерии пилота"],
                                ].map(([num, text]) => (
                                    <div key={num} className="rounded-2xl bg-white/[0.06] p-4">
                                        <div className="text-2xl font-black text-cyan-200">{num}</div>
                                        <p className="mt-1 text-sm font-bold leading-relaxed text-blue-100/70">{text}</p>
                                    </div>
                                ))}
                            </div>
                        </article>

                        <aside className="relative flex min-h-0 items-center justify-center border-t border-cyan-300/14 bg-black/22 p-5 lg:min-h-[540px] lg:border-l lg:border-t-0 xl:p-10">
                            <LeadForm
                                className="w-full max-w-[620px]"
                                source="Страница /cv/contact"
                                commentPlaceholder="Задача, источники данных, число камер или желаемый сценарий"
                            />
                        </aside>
                    </div>
                </section>

                <section className="grid grid-cols-1 gap-3 md:grid-cols-3 md:gap-4">
                    {[
                        ["Камеры", "RTSP-потоки, точки контроля, качество кадра и освещение."],
                        ["События", "Что фиксируем: отсутствие каски, номер автомобиля, зона риска или другой сценарий."],
                        ["Интеграции", "Нужен ли журнал событий, выгрузка, CRM, 1С или внутренняя база."],
                    ].map(([title, text]) => (
                        <article key={title} className="rounded-[1.4rem] bg-[#111633]/82 p-5 shadow-[0_10px_28px_rgba(0,0,0,0.22)] md:rounded-[1.6rem] md:p-6">
                            <div className="mb-5 h-1.5 w-14 rounded-full bg-gradient-to-r from-[#d7b56d] to-cyan-300"></div>
                            <h2 className="text-xl font-black leading-tight text-white md:text-2xl">{title}</h2>
                            <p className="mt-3 text-sm leading-relaxed text-blue-100/76 md:text-base">{text}</p>
                        </article>
                    ))}
                </section>
            </main>
        </RouteShell>
    );
}

function LicensePlatePage({ pathname, navigate, onSectionSelect, onCalculatorSelect }) {
    useRoutePageEffect("RuCortex | Распознавание номеров");

    return (
        <RouteShell className="route-app--cv">
            <UnifiedHeader
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={onSectionSelect}
                onCalculatorSelect={onCalculatorSelect}
            />

            <main className="product-route-page product-route-page--numbers relative z-10 mx-auto w-[94vw] max-w-[1340px] space-y-4 pb-12 pt-24 md:space-y-6 md:pt-28">
                <section className="relative overflow-hidden rounded-[1.6rem] border border-cyan-300/20 bg-[#07101f] shadow-[0_18px_46px_rgba(0,0,0,0.32)] md:rounded-[2.4rem]">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_12%,rgba(34,211,238,0.22),transparent_34%),radial-gradient(circle_at_82%_0%,rgba(59,130,246,0.18),transparent_30%),linear-gradient(135deg,rgba(255,255,255,0.06),transparent_48%)]"></div>
                    <div className="relative z-10 grid gap-0 lg:grid-cols-[0.95fr_1.05fr]">
                        <article className="flex min-h-0 flex-col justify-center p-5 py-8 sm:p-7 md:p-10 lg:min-h-[560px] xl:p-14">
                            <div className="mb-5 inline-flex w-fit rounded-full border border-cyan-300/25 bg-cyan-300/10 px-3 py-2 text-[0.68rem] font-black uppercase tracking-[0.16em] text-cyan-100 sm:px-4 sm:text-xs">
                                КПП / территория / логистика
                            </div>
                            <h1 className="max-w-4xl text-3xl font-black leading-[1.04] tracking-[-0.04em] text-white sm:text-4xl md:text-5xl md:tracking-[-0.045em] xl:text-5xl">
                                Распознавание автомобильных номеров для контроля въезда и выезда
                            </h1>
                            <p className="mt-5 max-w-2xl text-base leading-relaxed text-blue-100/82 md:mt-7 md:text-xl">
                                RuCortex подключается к видеопотокам, выделяет транспорт, считывает
                                госномер и сохраняет событие с кадром, камерой и временем. Это помогает
                                КПП и промышленным площадкам быстрее вести учет транспортных событий.
                            </p>

                            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                                <button
                                    type="button"
                                    onClick={() => navigate("/cv/contact")}
                                    className="inline-flex w-full items-center justify-center rounded-full bg-gradient-to-r from-[#d7b56d] to-cyan-300 px-7 py-4 text-center text-sm font-black text-[#081023] shadow-[0_0_28px_rgba(52,211,153,0.34)] transition-all duration-300 hover:-translate-y-0.5 sm:w-auto md:text-base"
                                >
                                    Запустить пилот
                                </button>
                                <button
                                    type="button"
                                    onClick={() => navigate("/cv")}
                                    className="w-full rounded-full border border-cyan-300/35 bg-white/8 px-7 py-4 text-center text-sm font-bold text-cyan-100 transition-all duration-300 hover:bg-white/12 sm:w-auto md:text-base"
                                >
                                    Смотреть контроль СИЗ
                                </button>
                            </div>
                        </article>

                        <aside className="relative flex min-h-0 items-center justify-center border-t border-cyan-300/14 bg-black/22 p-5 lg:min-h-[560px] lg:border-l lg:border-t-0 xl:p-10">
                            <div className="w-full max-w-[620px] rounded-[2rem] border border-cyan-200/18 bg-[#050b17] p-4 shadow-[0_24px_70px_rgba(0,0,0,0.42)]">
                                <div className="mb-3 flex items-center justify-between rounded-2xl border border-white/10 bg-white/[0.055] px-4 py-3">
                                    <div>
                                        <div className="text-xs font-black uppercase tracking-[0.18em] text-cyan-200/80">
                                            Камера КПП-01
                                        </div>
                                        <div className="mt-1 text-sm font-bold text-blue-100/64">
                                            Въезд на территорию
                                        </div>
                                    </div>
                                    <div className="rounded-full bg-[#d7b56d]/12 px-3 py-1 text-xs font-black text-cyan-200">
                                        LIVE
                                    </div>
                                </div>

                                <div className="relative overflow-hidden rounded-[1.5rem] border border-white/10 bg-[linear-gradient(180deg,#13213d_0%,#07101f_100%)] p-5">
                                    <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.035)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.035)_1px,transparent_1px)] bg-[length:34px_34px] opacity-60"></div>
                                    <div className="absolute left-0 right-0 top-[42%] h-px bg-cyan-300/70 shadow-[0_0_18px_rgba(34,211,238,0.8)]"></div>
                                    <div className="relative mx-auto mt-12 w-[86%] max-w-[430px] rounded-t-[4rem] rounded-b-[1.6rem] border border-cyan-200/20 bg-[#0b1428] p-5 shadow-[0_18px_46px_rgba(0,0,0,0.38)]">
                                        <div className="mx-auto h-20 w-[72%] rounded-t-[3rem] border border-white/12 bg-gradient-to-b from-cyan-300/20 to-blue-950/60"></div>
                                        <div className="mt-4 grid grid-cols-[1fr_auto_1fr] items-center gap-3">
                                            <div className="h-7 rounded-full bg-cyan-200/14"></div>
                                            <div className="rounded-lg border border-cyan-200/55 bg-white px-4 py-2 text-center font-mono text-xl font-black tracking-[0.12em] text-[#07101f] shadow-[0_0_22px_rgba(56,189,248,0.28)]">
                                                А123ВС 77
                                            </div>
                                            <div className="h-7 rounded-full bg-cyan-200/14"></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-3">
                                    {[
                                        ["Номер", "А123ВС 77"],
                                        ["Уверенность", "96%"],
                                        ["Событие", "Въезд"],
                                    ].map(([label, value]) => (
                                        <div key={label} className="rounded-2xl border border-white/10 bg-white/[0.055] p-3 text-center">
                                            <div className="text-xs font-bold uppercase tracking-[0.14em] text-blue-100/52">
                                                {label}
                                            </div>
                                            <div className="mt-1 text-lg font-black text-cyan-200">{value}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </aside>
                    </div>
                </section>

                <section className="relative overflow-hidden rounded-[1.8rem] border border-[#d7b56d]/18 bg-[#06151a] p-5 shadow-[0_20px_58px_rgba(0,0,0,0.28)] md:rounded-[2.4rem] md:p-8">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_8%_18%,rgba(16,185,129,0.16),transparent_30%),linear-gradient(90deg,rgba(255,255,255,0.045)_1px,transparent_1px)] bg-[length:76px_76px]"></div>
                    <div className="relative grid gap-8 lg:grid-cols-[0.8fr_1.2fr]">
                        <div>
                            <p className="text-xs font-black uppercase tracking-[0.24em] text-[#d7b56d]">
                                Маршрут КПП
                            </p>
                            <h2 className="mt-4 text-2xl font-black leading-tight tracking-[-0.035em] text-white md:text-3xl">
                                Каждый проезд превращается в проверяемую запись
                            </h2>
                            <p className="mt-5 text-base leading-relaxed text-blue-100/74 md:text-lg">
                                Визуальная логика страницы должна напоминать движение транспорта:
                                точка входа, фиксация номера, статус события и дальнейшая проверка.
                            </p>
                        </div>

                        <div className="relative">
                            <div className="absolute left-5 top-8 hidden h-[calc(100%-4rem)] w-1 rounded-full bg-gradient-to-b from-[#d7b56d] via-cyan-300 to-blue-400 md:block"></div>
                            <div className="grid gap-4">
                                {plateUseCases.map((item, index) => (
                                    <article
                                        key={item.title}
                                        className="relative rounded-[1.35rem] border border-white/10 bg-white/[0.055] p-5 md:ml-12"
                                    >
                                        <div className="absolute -left-14 top-6 hidden h-10 w-10 items-center justify-center rounded-2xl border border-[#d7b56d]/24 bg-[#07101f] text-xs font-black text-[#f5ead2] md:flex">
                                            {String(index + 1).padStart(2, "0")}
                                        </div>
                                        <div className="mb-4 flex flex-wrap items-center gap-2">
                                            <span className="rounded-full bg-[#d7b56d]/12 px-3 py-1 text-xs font-black uppercase tracking-[0.14em] text-[#f5ead2]">
                                                {index === 0 ? "въезд" : index === 1 ? "территория" : "логистика"}
                                            </span>
                                            <span className="rounded-full border border-white/10 px-3 py-1 text-xs font-bold text-blue-100/54">
                                                журнал событий
                                            </span>
                                        </div>
                                        <h3 className="text-xl font-black leading-tight text-white md:text-2xl">{item.title}</h3>
                                        <p className="mt-3 text-sm leading-relaxed text-blue-100/74 md:text-base">{item.text}</p>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="relative overflow-hidden rounded-[1.6rem] border border-blue-300/18 bg-[#0c1228]/88 p-5 shadow-[0_14px_38px_rgba(0,0,0,0.26)] md:rounded-[2rem] md:p-10">
                    <div className="grid gap-8 lg:grid-cols-[0.82fr_1.18fr]">
                        <div>
                            <p className="text-xs font-black uppercase tracking-[0.2em] text-[#d7b56d] md:text-sm md:tracking-[0.25em]">
                                Как работает
                            </p>
                            <h2 className="mt-4 text-2xl font-black leading-tight tracking-[-0.035em] text-white md:text-3xl">
                                От видеопотока до события в журнале
                            </h2>
                            <p className="mt-5 text-base leading-relaxed text-blue-100/76 md:text-lg">
                                Пилот можно начать на существующих камерах: проверить качество ракурса,
                                освещение, частоту ложных срабатываний и удобство журнала до масштабного
                                внедрения.
                            </p>
                        </div>

                        <div className="grid gap-3">
                            {platePipelineItems.map(([title, text], index) => (
                                <div
                                    key={title}
                                    className={`grid gap-4 rounded-[1.25rem] border p-4 md:grid-cols-[auto_1fr] ${
                                        index === 2
                                            ? "border-[#d7b56d]/24 bg-[#d7b56d]/12"
                                            : "border-white/10 bg-white/[0.055]"
                                    }`}
                                >
                                    <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-[#d7b56d] to-cyan-300 text-sm font-black text-[#06151a]">
                                        {String(index + 1).padStart(2, "0")}
                                    </div>
                                    <div>
                                        <div className="flex flex-wrap items-center gap-2">
                                            <h3 className="text-lg font-black text-cyan-100">{title}</h3>
                                            {index === 2 ? (
                                                <span className="rounded-full bg-white/10 px-2.5 py-1 text-[0.65rem] font-black uppercase tracking-[0.12em] text-[#f5ead2]">
                                                    ключевой шаг
                                                </span>
                                            ) : null}
                                        </div>
                                        <p className="mt-1 text-sm leading-relaxed text-blue-100/72 md:text-base">{text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="grid grid-cols-1 gap-4 rounded-[1.6rem] border border-cyan-300/16 bg-[#07101f]/88 p-5 shadow-[0_14px_38px_rgba(0,0,0,0.26)] md:rounded-[2rem] md:p-8 lg:grid-cols-[1fr_1fr]">
                    <div>
                        <p className="text-xs font-black uppercase tracking-[0.2em] text-cyan-300/80 md:text-sm md:tracking-[0.25em]">
                            Что получит команда
                        </p>
                            <h2 className="mt-4 text-2xl font-black leading-tight tracking-[-0.035em] text-white md:text-3xl">
                            Контроль транспорта без ручного просмотра камер
                        </h2>
                        <p className="mt-5 text-base leading-relaxed text-blue-100/76 md:text-lg">
                            Система не заменяет службу безопасности, а дает ей структурированный поток
                            событий: что произошло, где, когда, какой номер распознан и какой кадр нужно
                            проверить.
                        </p>
                    </div>
                    <div className="grid grid-cols-1 gap-3">
                        {plateFeatureItems.map((item) => (
                            <div
                                key={item}
                                className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/[0.055] p-4"
                            >
                                <span className="mt-1 h-2.5 w-2.5 flex-shrink-0 rounded-full bg-cyan-300"></span>
                                <p className="text-sm leading-relaxed text-blue-100/78 md:text-base">{item}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="rounded-[1.6rem] border border-cyan-300/18 bg-gradient-to-r from-cyan-300/12 via-[#111633] to-blue-500/12 p-5 text-center shadow-[0_12px_34px_rgba(0,0,0,0.24)] md:rounded-[2rem] md:p-10">
                            <h2 className="text-2xl font-black leading-tight text-white md:text-3xl">
                        Начните с 1-2 камер и реальных проездов
                    </h2>
                    <p className="mx-auto mt-4 max-w-3xl text-base leading-relaxed text-blue-100/78 md:text-lg">
                        Для пилота достаточно выбрать точку въезда или контролируемую зону, собрать тестовые
                        события и оценить точность распознавания на вашей инфраструктуре.
                    </p>
                    <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
                        <button
                            type="button"
                            onClick={() => onSectionSelect("contact-section")}
                            className="inline-flex w-full items-center justify-center rounded-full bg-white px-8 py-4 text-sm font-black text-[#081023] shadow-[0_0_28px_rgba(255,255,255,0.2)] transition-all duration-300 hover:-translate-y-0.5 sm:w-auto md:text-base"
                        >
                            Обсудить пилот
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate("/")}
                            className="w-full rounded-full border border-cyan-300/35 bg-white/8 px-8 py-4 text-sm font-bold text-cyan-100 transition-all duration-300 hover:bg-white/12 sm:w-auto md:text-base"
                        >
                            На главную
                        </button>
                    </div>
                </section>
            </main>
        </RouteShell>
    );
}

function CalculatorPage({ pathname, navigate, onSectionSelect, onCalculatorSelect }) {
    useRoutePageEffect("RuCortex | Калькулятор металлопроката");

    return (
        <RouteShell className="route-app--cv">
            <UnifiedHeader
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={onSectionSelect}
                onCalculatorSelect={onCalculatorSelect}
            />

            <main className="product-route-page product-route-page--calculator relative z-10 mx-auto w-[94vw] max-w-[1340px] space-y-4 pb-12 pt-24 md:space-y-6 md:pt-28">
                <section className="relative overflow-hidden rounded-[1.6rem] border border-cyan-300/24 bg-[#07101f] shadow-[0_18px_46px_rgba(0,0,0,0.32)] md:rounded-[2.4rem]">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_12%,rgba(34,211,238,0.24),transparent_34%),radial-gradient(circle_at_82%_8%,rgba(96,165,250,0.18),transparent_28%),linear-gradient(135deg,rgba(255,255,255,0.06),transparent_44%)]"></div>
                    <div className="relative z-10 grid gap-0 lg:grid-cols-[0.95fr_1.05fr]">
                        <article className="flex min-h-0 flex-col justify-center p-5 py-8 sm:p-7 md:p-10 lg:min-h-[540px] xl:p-12">
                            <div className="mb-5 inline-flex w-fit rounded-full border border-cyan-300/28 bg-cyan-300/10 px-3 py-2 text-[0.68rem] font-black uppercase tracking-[0.16em] text-cyan-100 sm:px-4 sm:text-xs">
                                ГОСТ / ТУ / офлайн Android
                            </div>
                            <h1 className="max-w-3xl text-3xl font-black leading-[1.02] tracking-[-0.045em] text-white sm:text-4xl md:text-5xl">
                                МеталлКалькулятор RuCortex
                            </h1>
                            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-blue-100/82 md:text-xl">
                                Нормативный пересчет массы, длины, площади и количества металлопроката
                                без Excel, ручных формул и сторонних сервисов.
                            </p>

                            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2">
                                {[
                                    ["Нормативы", "ГОСТ, ТУ, табличные значения"],
                                    ["Единицы", "тонны, метры, м² и штуки"],
                                    ["Материал", "марка стали, плотность, цинк"],
                                    ["Офлайн", "работает на Android без сети"],
                                ].map(([title, text]) => (
                                    <div key={title} className="rounded-2xl border border-white/10 bg-white/[0.055] p-4">
                                        <div className="text-sm font-black uppercase tracking-[0.14em] text-cyan-200">
                                            {title}
                                        </div>
                                        <p className="mt-2 text-sm leading-relaxed text-blue-100/72">{text}</p>
                                    </div>
                                ))}
                            </div>

                            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                                <a
                                    href="/rucortex-metal-calculator.apk"
                                    download="rucortex-metal-calculator.apk"
                                    className="inline-flex w-full items-center justify-center rounded-full bg-gradient-to-r from-cyan-300 to-blue-400 px-7 py-4 text-center text-sm font-black text-[#081023] shadow-[0_0_28px_rgba(56,189,248,0.42)] transition-all duration-300 hover:-translate-y-0.5 sm:w-auto md:text-base"
                                >
                                    Скачать APK
                                </a>
                                <button
                                    type="button"
                                    onClick={() => onSectionSelect("contact-section")}
                                    className="w-full rounded-full border border-cyan-300/35 bg-white/8 px-7 py-4 text-center text-sm font-bold text-cyan-100 transition-all duration-300 hover:bg-white/12 sm:w-auto md:text-base"
                                >
                                    Нужна версия под компанию
                                </button>
                            </div>

                            <p className="mt-4 max-w-xl text-sm leading-relaxed text-blue-100/62">
                                APK устанавливается вручную. Google Play и RuStore будут подключены
                                после публикации приложения.
                            </p>
                        </article>

                        <aside className="relative flex min-h-0 items-center justify-center border-t border-cyan-300/14 bg-black/22 p-5 lg:min-h-[540px] lg:border-l lg:border-t-0 xl:p-10">
                            <div className="absolute inset-10 rounded-full bg-cyan-300/10 blur-2xl"></div>
                            <div className="relative w-full max-w-[600px]">
                                <div className="rounded-[2rem] border border-cyan-200/20 bg-[#050b17] p-4 shadow-[0_24px_70px_rgba(0,0,0,0.42)]">
                                    <div className="mb-4 flex items-center justify-between rounded-2xl border border-white/10 bg-white/[0.055] px-4 py-3">
                                        <div>
                                            <div className="text-xs font-black uppercase tracking-[0.18em] text-cyan-200/80">
                                                Расчет металлопроката
                                            </div>
                                            <div className="mt-1 text-sm font-bold text-blue-100/64">
                                                Труба профильная · ГОСТ 8639
                                            </div>
                                        </div>
                                        <img
                                            src={androidBg}
                                            alt="Иконка Android-приложения"
                                            loading="eager"
                                            decoding="async"
                                            className="h-12 w-12 rounded-2xl border border-cyan-200/16 bg-white/[0.04] object-contain p-2"
                                        />
                                    </div>

                                    <div className="grid grid-cols-1 gap-4 md:grid-cols-[0.9fr_1.1fr]">
                                        <div className="space-y-3">
                                            {[
                                                ["Изделие", "Труба 60 × 40 × 3"],
                                                ["Марка", "Сталь 09Г2С"],
                                                ["Количество", "120 м"],
                                            ].map(([label, value]) => (
                                                <div key={label} className="rounded-2xl border border-white/10 bg-[#0b1428] p-4">
                                                    <div className="text-xs font-bold uppercase tracking-[0.14em] text-blue-100/48">
                                                        {label}
                                                    </div>
                                                    <div className="mt-2 text-base font-black text-white">{value}</div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="rounded-[1.5rem] border border-cyan-300/18 bg-[radial-gradient(circle_at_20%_12%,rgba(34,211,238,0.16),transparent_36%),#0a1327] p-4">
                                            <div className="text-xs font-black uppercase tracking-[0.18em] text-cyan-200/76">
                                                Результат
                                            </div>
                                            <div className="mt-4 grid grid-cols-2 gap-3">
                                                {[
                                                    ["Масса", "0,52 т"],
                                                    ["Погонный вес", "4,31 кг/м"],
                                                    ["Длина", "120 м"],
                                                    ["Единицы", "м / т / шт"],
                                                ].map(([label, value]) => (
                                                    <div key={label} className="rounded-2xl bg-white/[0.07] p-3">
                                                        <div className="text-[0.66rem] font-bold uppercase tracking-[0.14em] text-blue-100/46">
                                                            {label}
                                                        </div>
                                                        <div className="mt-1 text-lg font-black text-cyan-100">{value}</div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="mt-4 rounded-2xl border border-[#d7b56d]/18 bg-[#d7b56d]/10 p-3 text-sm font-bold leading-relaxed text-[#f5ead2]">
                                                Расчет выполнен по нормативной геометрии и плотности материала.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-4 grid grid-cols-3 gap-2 text-center">
                                    {[
                                        ["ГОСТ / ТУ", "нормы"],
                                        ["Офлайн", "Android"],
                                        ["Сортамент", "13+"],
                                    ].map(([label, value]) => (
                                        <div key={label} className="rounded-2xl border border-white/10 bg-[#0b1428]/88 p-3">
                                            <div className="text-xs font-bold uppercase tracking-[0.14em] text-blue-100/48">
                                                {label}
                                            </div>
                                            <div className="mt-1 text-base font-black text-cyan-200">{value}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </aside>
                    </div>
                </section>

                <section className="relative overflow-hidden rounded-[1.8rem] border border-[#d7b56d]/18 bg-[#10131c] p-5 shadow-[0_20px_58px_rgba(0,0,0,0.28)] md:rounded-[2.4rem] md:p-8">
                    <div className="absolute inset-0 bg-[linear-gradient(rgba(215,181,109,0.06)_1px,transparent_1px),linear-gradient(90deg,rgba(34,211,238,0.05)_1px,transparent_1px)] bg-[length:42px_42px]"></div>
                    <div className="relative grid gap-8 lg:grid-cols-[0.78fr_1.22fr]">
                        <div>
                            <p className="text-xs font-black uppercase tracking-[0.24em] text-[#d7b56d]">
                                Инженерный лист
                            </p>
                            <h2 className="mt-4 text-2xl font-black leading-tight tracking-[-0.035em] text-white md:text-3xl">
                                Расчет должен выглядеть как инструмент, а не как рекламная карточка
                            </h2>
                            <p className="mt-5 text-base leading-relaxed text-blue-100/74 md:text-lg">
                                Поэтому страница калькулятора получает эстетику рабочего листа:
                                назначение, входные параметры, нормативная база и результат пересчета.
                            </p>
                        </div>

                        <div className="overflow-hidden rounded-[1.4rem] border border-white/10 bg-[#070b15]/86">
                            {calculatorUseCases.map((item, index) => (
                                <article
                                    key={item.title}
                                    className={`grid gap-4 border-b border-white/10 p-5 last:border-b-0 md:grid-cols-[0.22fr_0.78fr] md:p-6 ${
                                        index === 1 ? "bg-[#d7b56d]/10" : ""
                                    }`}
                                >
                                    <div>
                                        <div className="font-mono text-sm font-black text-[#d7b56d]">
                                            ЗАДАЧА {String(index + 1).padStart(2, "0")}
                                        </div>
                                        <div className="mt-3 h-1 w-16 rounded-full bg-gradient-to-r from-[#d7b56d] to-cyan-300"></div>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-black leading-tight text-white md:text-2xl">{item.title}</h3>
                                        <p className="mt-3 text-sm leading-relaxed text-blue-100/74 md:text-base">{item.text}</p>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="relative overflow-hidden rounded-[1.6rem] border border-blue-300/18 bg-[#0c1228]/88 p-5 shadow-[0_14px_38px_rgba(0,0,0,0.26)] md:rounded-[2rem] md:p-10">
                    <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
                        <div>
                            <p className="text-xs font-black uppercase tracking-[0.2em] text-[#d7b56d] md:text-sm md:tracking-[0.25em]">
                                Что считает
                            </p>
                            <h2 className="mt-4 text-2xl font-black leading-tight tracking-[-0.035em] text-white md:text-3xl">
                                Нормативные расчеты вместо ручной сверки справочников
                            </h2>
                            <p className="mt-5 text-base leading-relaxed text-blue-100/76 md:text-lg">
                                Главный акцент инструмента — расчеты по нормативным данным ГОСТ и ТУ.
                                Для разных видов проката используются стандартные размеры, табличные
                                значения и геометрические формулы, чтобы результат был близок к реальным
                                параметрам продукции.
                            </p>
                        </div>

                        <div className="grid grid-cols-1 gap-3">
                            {calculatorFeatureItems.map((item, index) => (
                                <div
                                    key={item}
                                    className={`grid grid-cols-[auto_1fr] gap-3 rounded-2xl border p-4 ${
                                        index === 2
                                            ? "border-[#d7b56d]/28 bg-[#d7b56d]/12"
                                            : "border-white/10 bg-white/[0.055]"
                                    }`}
                                >
                                    <span className="mt-0.5 font-mono text-xs font-black text-[#d7b56d]">
                                        {String(index + 1).padStart(2, "0")}
                                    </span>
                                    <p className="text-sm leading-relaxed text-blue-100/78 md:text-base">{item}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="grid grid-cols-1 gap-6 rounded-[1.6rem] border border-cyan-300/16 bg-[#07101f]/88 p-5 shadow-[0_14px_38px_rgba(0,0,0,0.26)] md:rounded-[2rem] md:p-8 lg:grid-cols-[1.08fr_0.92fr]">
                    <div>
                        <p className="text-xs font-black uppercase tracking-[0.2em] text-cyan-300/80 md:text-sm md:tracking-[0.25em]">
                            Поддерживаемый прокат
                        </p>
                        <h2 className="mt-4 text-2xl font-black leading-tight tracking-[-0.035em] text-white md:text-3xl">
                            От арматуры и труб до шпунтов, канатов и крепежа
                        </h2>
                        <div className="mt-6 grid grid-cols-2 gap-2 sm:grid-cols-3">
                            {calculatorProductGroups.map((item) => (
                                <span
                                    key={item}
                                    className="rounded-[1rem] border border-white/10 bg-white/[0.055] px-3 py-2 text-sm font-bold text-blue-100/82"
                                >
                                    {item}
                                </span>
                            ))}
                        </div>
                    </div>
                    <div className="grid gap-3">
                        <div className="rounded-[1.3rem] border border-[#d7b56d]/18 bg-[#d7b56d]/10 p-5">
                            <div className="text-lg font-black text-cyan-200">Нестандартные размеры</div>
                            <p className="mt-2 text-sm leading-relaxed text-blue-100/74 md:text-base">
                                Если типоразмера нет в справочнике, можно ввести произвольные значения.
                                Расчет выполняется по формулам, применяемым в нормативной логике ГОСТ.
                            </p>
                        </div>
                        <div className="rounded-[1.3rem] border border-white/10 bg-white/[0.055] p-5">
                            <div className="text-lg font-black text-cyan-200">Оцинкованные позиции</div>
                            <p className="mt-2 text-sm leading-relaxed text-blue-100/74 md:text-base">
                                Для оцинкованных изделий учитывается масса цинкового покрытия, а для
                                материалов — плотность и выбранная марка стали.
                            </p>
                        </div>
                        <div className="rounded-[1.3rem] border border-white/10 bg-white/[0.055] p-5">
                            <div className="text-lg font-black text-cyan-200">Прозрачная база</div>
                            <p className="mt-2 text-sm leading-relaxed text-blue-100/74 md:text-base">
                                Часть исходной справочной логики взята с 23мет и адаптирована под
                                продуктовую линейку RuCortex.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="grid grid-cols-1 gap-4 rounded-[1.6rem] border border-cyan-300/16 bg-[#0b142d]/86 p-5 shadow-[0_14px_38px_rgba(0,0,0,0.26)] md:rounded-[2rem] md:p-8 lg:grid-cols-[0.72fr_1.28fr]">
                    <div className="flex items-center justify-center rounded-[1.4rem] border border-white/10 bg-white/[0.045] p-5">
                        <img
                            src={androidBg}
                            alt="Иконка Android калькулятора металлопроката"
                            loading="lazy"
                            decoding="async"
                            className="w-[150px] max-w-[50vw] object-contain opacity-95 drop-shadow-[0_0_18px_rgba(56,189,248,0.28)]"
                        />
                    </div>
                    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
                        {[
                            ["Сортамент", "арматура, трубы, листы, рулоны, профнастил, уголки, швеллеры и профильный прокат"],
                            ["Нормативы", "ГОСТ, ТУ, табличные значения, плотность материала и марка стали"],
                            ["Результат", "масса, длина, площадь, количество и пересчет между единицами"],
                        ].map(([title, text]) => (
                            <div key={title} className="rounded-2xl border border-white/10 bg-white/[0.055] p-4">
                                <div className="text-lg font-black text-cyan-200">{title}</div>
                                <p className="mt-2 text-sm leading-relaxed text-blue-100/72">{text}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="rounded-[1.6rem] border border-cyan-300/18 bg-gradient-to-r from-cyan-300/12 via-[#111633] to-blue-500/12 p-5 text-center shadow-[0_12px_34px_rgba(0,0,0,0.24)] md:rounded-[2rem] md:p-10">
                            <h2 className="text-2xl font-black leading-tight text-white md:text-3xl">
                        Можно скачать сейчас, а корпоративную версию адаптировать под ваш сортамент
                    </h2>
                    <p className="mx-auto mt-4 max-w-3xl text-base leading-relaxed text-blue-100/78 md:text-lg">
                        Базовое Android-приложение уже можно использовать офлайн. Для компании можно
                        подготовить версию с вашими справочниками, типоразмерами, нормативными таблицами
                        и правилами пересчета.
                    </p>
                    <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
                        <a
                            href="/rucortex-metal-calculator.apk"
                            download="rucortex-metal-calculator.apk"
                            className="inline-flex w-full items-center justify-center rounded-full bg-white px-8 py-4 text-sm font-black text-[#081023] shadow-[0_0_28px_rgba(255,255,255,0.2)] transition-all duration-300 hover:-translate-y-0.5 sm:w-auto md:text-base"
                        >
                            Скачать приложение
                        </a>
                        <button
                            type="button"
                            onClick={() => onSectionSelect("contact-section")}
                            className="w-full rounded-full border border-cyan-300/35 bg-white/8 px-8 py-4 text-sm font-bold text-cyan-100 transition-all duration-300 hover:bg-white/12 sm:w-auto md:text-base"
                        >
                            Обсудить доработку
                        </button>
                    </div>
                </section>
            </main>
        </RouteShell>
    );
}

export default function App() {
    return (
        <>
            <YandexMetrika />
            <AppRouter />
        </>
    );
}

function AppRouter() {
    const { pathname, navigate } = useSpaRouter();
    const [pendingSectionTarget, setPendingSectionTarget] = React.useState(null);
    const [pendingHeroSlideId, setPendingHeroSlideId] = React.useState(null);

    React.useEffect(() => {
        const handleEmailCopy = () => {
            const selectedText = window.getSelection?.()?.toString() || "";
            if (selectedText.includes("electrosteel@mail.ru")) {
                window.ym?.(105850410, "reachGoal", "email_copy");
            }
        };

        document.addEventListener("copy", handleEmailCopy);
        return () => document.removeEventListener("copy", handleEmailCopy);
    }, []);

    React.useEffect(() => {
        const isCoarsePointer = window.matchMedia?.("(pointer: coarse)")?.matches;
        const prefersReducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
        if (isCoarsePointer || prefersReducedMotion) {
            return undefined;
        }

        let cancelled = false;
        const preloadRouteImages = () => {
            if (cancelled) return;

            ROUTE_PRELOAD_IMAGES.forEach((src) => {
                const image = new Image();
                image.decoding = "async";
                image.src = src;
                image.decode?.().catch(() => {});
            });
        };

        const hasIdleCallback = typeof window.requestIdleCallback === "function";
        const preloadId = hasIdleCallback
            ? window.requestIdleCallback(preloadRouteImages, { timeout: 2500 })
            : window.setTimeout(preloadRouteImages, 1200);

        return () => {
            cancelled = true;
            if (hasIdleCallback) {
                window.cancelIdleCallback(preloadId);
            } else {
                window.clearTimeout(preloadId);
            }
        };
    }, []);

    const openHomeSection = React.useCallback((target) => {
        if (pathname === "/") return;
        setPendingHeroSlideId(null);
        setPendingSectionTarget(target);
        navigate("/", { scrollTop: false });
    }, [navigate, pathname]);

    const openCalculatorFromHeader = React.useCallback(() => {
        if (pathname === "/calculator") return;
        navigate("/calculator");
    }, [navigate, pathname]);

    if (pathname === "/rucortex" || pathname === "/rucortex/") {
        return (
            <RucortexProductPage
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={openHomeSection}
                onCalculatorSelect={openCalculatorFromHeader}
            />
        );
    }

    if (pathname === "/calculator" || pathname === "/calculator/") {
        return (
            <CalculatorPage
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={openHomeSection}
                onCalculatorSelect={openCalculatorFromHeader}
            />
        );
    }

    if (pathname === "/numbers" || pathname === "/numbers/") {
        return (
            <LicensePlatePage
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={openHomeSection}
                onCalculatorSelect={openCalculatorFromHeader}
            />
        );
    }

    if (pathname === "/cv" || pathname === "/cv/") {
        return (
            <CvPage
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={openHomeSection}
                onCalculatorSelect={openCalculatorFromHeader}
            />
        );
    }

    if (pathname === "/cv/example" || pathname.startsWith("/cv/example/")) {
        return (
            <CvInfoPage
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={openHomeSection}
                onCalculatorSelect={openCalculatorFromHeader}
                page={{
                    kicker: "Пример пилота",
                    title: "Как выглядит внедрение контроля касок",
                    lead:
                        "Показываем типовую схему: выбираем камеры, задаем зоны контроля, собираем события и проверяем точность на реальном видеопотоке.",
                    primaryAction: "Обсудить похожий пилот",
                    asideLabel: "Сценарий",
                    asideTitle: "От камеры до отчета для охраны труда",
                    asideItems: [
                        "Выбираем 2-5 камер, где хорошо видны люди и зона риска.",
                        "Настраиваем зоны контроля, пороги фиксации и правила хранения кадров.",
                        "Собираем события за пилотный период и вручную проверяем спорные случаи.",
                        "Формируем отчет: точность, ложные срабатывания, проблемные зоны и план масштабирования.",
                    ],
                    highlights: [
                        {
                            title: "Минимальный контур",
                            text: "Не нужно начинать со всей площадки: достаточно нескольких камер и понятной зоны контроля.",
                        },
                        {
                            title: "Проверка качества",
                            text: "Сразу видно, насколько хорошо ракурс, освещение и поток подходят для видеоаналитики.",
                        },
                        {
                            title: "Отчет по рискам",
                            text: "На выходе — список событий, метрик, ограничений и условий для масштабирования.",
                        },
                    ],
                    processKicker: "Этапы примера",
                    processTitle: "Пилот строится как проверка рабочей гипотезы",
                    processText:
                        "Точность подтверждается на реальном видео: система считает события, показывает спорные случаи и фиксирует ограничения пилота.",
                    steps: [
                        { step: "01", title: "Камеры", text: "Проверяем доступ к потоку, ракурс, качество кадра и зоны контроля." },
                        { step: "02", title: "События", text: "Настраиваем фиксацию отсутствия каски и ручную проверку спорных кадров." },
                        { step: "03", title: "Метрики", text: "Считаем точность, ложные срабатывания и нагрузку на специалиста." },
                        { step: "04", title: "Решение", text: "Готовим вывод: масштабировать, донастроить или изменить точки контроля." },
                    ],
                    ctaTitle: "Такой пример можно собрать на вашей площадке",
                    ctaText:
                        "Для старта нужен список камер, описание зоны контроля и ответственный специалист, который подтвердит события пилота.",
                    ctaAction: "Запросить пример под площадку",
                }}
            />
        );
    }

    if (pathname === "/cv/calculate" || pathname.startsWith("/cv/calculate/")) {
        return (
            <CvInfoPage
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={openHomeSection}
                onCalculatorSelect={openCalculatorFromHeader}
                page={{
                    kicker: "Оценка внедрения",
                    title: "Стоимость внедрения — от 500 000 ₽",
                    lead:
                        "Не называем абстрактную цену без данных. Сначала фиксируем площадку, видеопотоки, хранение событий, интеграции и требования к поддержке.",
                    primaryAction: "Получить расчет",
                    asideLabel: "Что влияет на оценку",
                    asideTitle: "Цена складывается из понятных технических параметров",
                    asideItems: [
                        "Количество камер и площадок, которые нужно подключить к системе.",
                        "Качество потоков, необходимость серверного размещения или облачного контура.",
                        "Срок хранения кадров, журнал событий, роли пользователей и отчетность.",
                        "Интеграции с 1С, CRM, пропусками, внутренними базами или BI.",
                    ],
                    highlights: [
                        {
                            title: "Пилот до сметы",
                            text: "Проверяем качество на реальных потоках, чтобы итоговая оценка не была угадыванием.",
                        },
                        {
                            title: "Прозрачный состав",
                            text: "Разделяем модель, серверный контур, хранение, интерфейс, интеграции и поддержку.",
                        },
                        {
                            title: "Масштабирование",
                            text: "После пилота понятно, сколько камер можно подключать дальше и какие ресурсы нужны.",
                        },
                    ],
                    processKicker: "Порядок расчета",
                    processTitle: "Сначала проверяем контур, потом считаем внедрение",
                    processText:
                        "Такой порядок снижает риск ошибочной сметы: фактические ограничения камер и площадки видны до закупок и масштабирования.",
                    steps: [
                        { step: "01", title: "Исходные данные", text: "Число камер, площадок, потоков, зоны контроля и ожидаемые события." },
                        { step: "02", title: "Тест видео", text: "Проверяем ракурсы, освещение, стабильность потока и качество кадров." },
                        { step: "03", title: "Контур", text: "Определяем сервер, хранение, доступы, журнал событий и требования ИБ." },
                        { step: "04", title: "Оценка", text: "Собираем смету пилота и план масштабирования по площадкам." },
                    ],
                    ctaTitle: "Расчет будет точнее после короткой диагностики",
                    ctaText:
                        "Опишите площадку и число камер. Мы предложим формат пилота и список данных, которые нужны для нормальной оценки.",
                    ctaAction: "Оставить данные для расчета",
                }}
            />
        );
    }

    if (pathname === "/cv/contact" || pathname.startsWith("/cv/contact/")) {
        return (
            <ContactRoutePage
                pathname={pathname}
                navigate={navigate}
                onSectionSelect={openHomeSection}
                onCalculatorSelect={openCalculatorFromHeader}
            />
        );
    }

    return (
        <MainLanding
            pathname={pathname}
            navigate={navigate}
            pendingSectionTarget={pendingSectionTarget}
            pendingHeroSlideId={pendingHeroSlideId}
            onPendingSectionHandled={() => setPendingSectionTarget(null)}
            onPendingHeroHandled={() => setPendingHeroSlideId(null)}
        />
    );
}

function CookieConsent() {
    const [visible, setVisible] = React.useState(false);
    const barRef = React.useRef(null);

    React.useEffect(() => {
        const saved = localStorage.getItem("cookie_accepted");
        if (!saved) setVisible(true);
    }, []);

    // когда баннер виден — кладём класс и высоту
    React.useEffect(() => {
        const root = document.documentElement; // <html>
        if (visible) {
            const h = barRef.current?.offsetHeight || 0;
            root.classList.add("cookie-open");
            root.style.setProperty("--cookie-bar-h", `${h}px`);
        } else {
            root.classList.remove("cookie-open");
            root.style.removeProperty("--cookie-bar-h");
        }
    }, [visible]);

    const accept = () => {
        localStorage.setItem("cookie_accepted", "true");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            ref={barRef}
            className="cookie-bar fixed left-0 right-0 bottom-0 z-[9999]"
            // немного внутреннего отступа под iOS-«чёлку»
            style={{ paddingBottom: "calc(env(safe-area-inset-bottom,0px) + 8px)" }}
        >
            <div className="mx-auto max-w-6xl px-4">
                <div className="flex flex-col md:flex-row items-center justify-between
                        rounded-2xl border border-[#d7b56d]/28
                        bg-[#07101f]/95 border-t border-[#d7b56d]/24
                        shadow-[0_18px_46px_rgba(0,0,0,0.36)]
                        px-4 py-3 md:px-6 md:py-4">
                    <p className="text-sm md:text-base md:pr-4">
                        Продолжая пользоваться сайтом, вы соглашаетесь с условиями
                        использования и обработкой cookie-файлов. (Подробнее —{" "}
                        <button
                            onClick={() => {
                                window.dispatchEvent(new CustomEvent("open-privacy-policy"));
                            }}
                            className="text-cyan-200 underline hover:text-[#d7b56d]"
                        >
                            Политика конфиденциальности
                        </button>
                        )
                    </p>

                    <button
                        onClick={accept}
                        className="mt-3 md:mt-0 inline-flex items-center justify-center
                       rounded-full bg-[#d7b56d] px-6 py-2 font-semibold text-[#07111f]
                       transition hover:bg-[#f0cc7b]"
                    >
                        СОГЛАСИТЬСЯ
                    </button>
                </div>
            </div>
        </div>
    );
}


function MainLanding({
    pathname,
    navigate,
    pendingSectionTarget,
    pendingHeroSlideId,
    onPendingSectionHandled,
    onPendingHeroHandled,
}) {

    const [activeSection, setActiveSection] = useState(null);
    const [policyOpen, setPolicyOpen] = React.useState(false);
    const [heroSlideIndex, setHeroSlideIndex] = useState(0);
    const [heroIsVisible, setHeroIsVisible] = useState(true);
    const heroFadeTimeoutRef = React.useRef(null);

    const activeHeroSlide = heroSlides[heroSlideIndex];

    useEffect(() => {
        const openPolicy = () => setPolicyOpen(true);
        window.addEventListener("open-privacy-policy", openPolicy);
        return () => window.removeEventListener("open-privacy-policy", openPolicy);
    }, []);

    useEffect(() => {
        const canvas = document.getElementById("particles-canvas");
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        const reduceMotionQuery = window.matchMedia?.("(prefers-reduced-motion: reduce)");
        const coarsePointerQuery = window.matchMedia?.("(pointer: coarse)");
        const isMobileDevice = () =>
            coarsePointerQuery?.matches ||
            window.innerWidth < 768 ||
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (reduceMotionQuery?.matches || isMobileDevice()) {
            canvas.style.display = "none";
            return;
        }

        let particles = [];
        let mouse = { x: null, y: null };
        let animationFrameId = null;
        let idleTimeoutId = null;
        let isHeroVisible = true;

        const resize = () => {
            const pixelRatio = Math.min(window.devicePixelRatio || 1, 1.5);
            canvas.width = Math.floor(window.innerWidth * pixelRatio);
            canvas.height = Math.floor(window.innerHeight * pixelRatio);
            canvas.style.width = `${window.innerWidth}px`;
            canvas.style.height = `${window.innerHeight}px`;
            ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        };
        resize();
        window.addEventListener("resize", resize, { passive: true });

        const handleMouseMove = (e) => {
            mouse.x = e.x;
            mouse.y = e.y;
        };
        window.addEventListener("mousemove", handleMouseMove, { passive: true });

        class Particle {
            constructor(x, y, size, speedX, speedY, color) {
                this.x = x;
                this.y = y;
                this.size = size;
                this.speedX = speedX;
                this.speedY = speedY;
                this.color = color;
            }
            update() {
                this.x += this.speedX;
                this.y += this.speedY;

                const dx = mouse.x - this.x;
                const dy = mouse.y - this.y;
                const distance = Math.sqrt(dx * dx + dy * dy);
                if (distance < 150) {
                    this.x -= dx / 40;
                    this.y -= dy / 40;
                }

                if (this.x > canvas.width || this.x < 0) this.speedX *= -1;
                if (this.y > canvas.height || this.y < 0) this.speedY *= -1;
            }
            draw() {
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.fillStyle = this.color;
                ctx.shadowBlur = 10;
                ctx.shadowColor = this.color;
                ctx.fill();
            }
        }

        const initParticles = () => {
            particles = [];
            const count = window.innerWidth >= 1280 ? 42 : 28;
            const colors = ["#22D3EE", "#D7B56D", "#14B8A6", "#60A5FA"];
            for (let i = 0; i < count; i++) {
                const size = Math.random() * 2 + 1;
                const x = Math.random() * canvas.width;
                const y = Math.random() * canvas.height;
                const speedX = (Math.random() - 0.5) * 1;
                const speedY = (Math.random() - 0.5) * 1;
                const color = colors[Math.floor(Math.random() * colors.length)];
                particles.push(new Particle(x, y, size, speedX, speedY, color));
            }
        };

        const scheduleNextFrame = () => {
            if (!isHeroVisible) {
                idleTimeoutId = window.setTimeout(() => {
                    animationFrameId = requestAnimationFrame(animate);
                }, 240);
                return;
            }

            animationFrameId = requestAnimationFrame(animate);
        };

        const animate = () => {
            if (!isHeroVisible) {
                scheduleNextFrame();
                return;
            }

            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // рисуем связи между частицами
            for (let i = 0; i < particles.length; i++) {
                for (let j = i; j < particles.length; j++) {
                    const dx = particles[i].x - particles[j].x;
                    const dy = particles[i].y - particles[j].y;
                    const distance = Math.sqrt(dx * dx + dy * dy);
                    if (distance < 96) {
                        const opacity = 1 - distance / 96;
                        ctx.strokeStyle = `rgba(56, 189, 248, ${opacity * 0.4})`;
                        ctx.lineWidth = 1;
                        ctx.beginPath();
                        ctx.moveTo(particles[i].x, particles[i].y);
                        ctx.lineTo(particles[j].x, particles[j].y);
                        ctx.stroke();
                    }
                }
            }

            // обновляем частицы
            for (let p of particles) {
                p.update();
                p.draw();
            }

            scheduleNextFrame();
        };

        initParticles();
        const hero = canvas.closest("section");
        const heroObserver = "IntersectionObserver" in window && hero
            ? new IntersectionObserver(([entry]) => {
                isHeroVisible = entry.isIntersecting;
            }, { threshold: 0.06 })
            : null;

        heroObserver?.observe(hero);
        animationFrameId = requestAnimationFrame(animate);

        return () => {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }
            if (idleTimeoutId) {
                window.clearTimeout(idleTimeoutId);
            }
            heroObserver?.disconnect();
            window.removeEventListener("resize", resize);
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);

    useEffect(() => {
        return () => window.clearTimeout(heroFadeTimeoutRef.current);
    }, []);

    const queueHeroSlide = React.useCallback((nextIndex) => {
        window.clearTimeout(heroFadeTimeoutRef.current);
        setHeroIsVisible(false);
        heroFadeTimeoutRef.current = window.setTimeout(() => {
            setHeroSlideIndex(nextIndex);
            setHeroIsVisible(true);
        }, 140);
    }, []);

    useEffect(() => {
        const timer = window.setTimeout(() => {
            queueHeroSlide((heroSlideIndex + 1) % heroSlides.length);
        }, 10000);

        return () => window.clearTimeout(timer);
    }, [heroSlideIndex, queueHeroSlide]);


    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            const headerOffset = 80;
            const elementPosition = section.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - headerOffset;
            window.scrollTo({ top: offsetPosition, behavior: "smooth" });
        }
    };

    const goToPreviousHeroSlide = () => {
        queueHeroSlide((heroSlideIndex - 1 + heroSlides.length) % heroSlides.length);
    };

    const goToNextHeroSlide = () => {
        queueHeroSlide((heroSlideIndex + 1) % heroSlides.length);
    };

    const openHeroSlideById = React.useCallback((slideId) => {
        const nextIndex = heroSlides.findIndex((slide) => slide.id === slideId);
        if (nextIndex === -1) return;

        window.scrollTo({ top: 0, behavior: "smooth" });

        if (nextIndex === heroSlideIndex) {
            return;
        }

        queueHeroSlide(nextIndex);
    }, [heroSlideIndex, queueHeroSlide]);

    useEffect(() => {
        const sections = [
            { id: "scenario-section", name: "scenario" },
            { id: "solution-section", name: "solution" },
            { id: "technology-section", name: "technology" },
            { id: "integration-section", name: "integration" },
            { id: "process-section", name: "process" },
            { id: "advantage-section", name: "advantage" },
            { id: "contact-section", name: "contact" },
        ];

        if (!("IntersectionObserver" in window)) {
            return undefined;
        }

        const visibleSections = new Map();
        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                const sectionName = entry.target.dataset.navSection;
                if (!sectionName) continue;

                if (entry.isIntersecting) {
                    visibleSections.set(sectionName, entry.intersectionRatio);
                } else {
                    visibleSections.delete(sectionName);
                }
            }

            const nextActive = [...visibleSections.entries()].sort((a, b) => b[1] - a[1])[0]?.[0] ?? null;
            setActiveSection((current) => (current === nextActive ? current : nextActive));
        }, {
            root: null,
            rootMargin: "-35% 0px -45% 0px",
            threshold: [0.02, 0.18, 0.35, 0.55],
        });

        sections.forEach((section) => {
            const el = document.getElementById(section.id);
            if (!el) return;
            el.dataset.navSection = section.name;
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!pendingSectionTarget) return;

        const timer = window.setTimeout(() => {
            scrollToSection(pendingSectionTarget);
            onPendingSectionHandled?.();
        }, 0);

        return () => window.clearTimeout(timer);
    }, [onPendingSectionHandled, pendingSectionTarget]);

    useEffect(() => {
        if (!pendingHeroSlideId) return;

        const timer = window.setTimeout(() => {
            openHeroSlideById(pendingHeroSlideId);
            onPendingHeroHandled?.();
        }, 0);

        return () => window.clearTimeout(timer);
    }, [onPendingHeroHandled, openHeroSlideById, pendingHeroSlideId]);

    const handleHeroActionClick = (action) => {
        if (action.newTab) {
            window.open(action.href, "_blank", "noopener,noreferrer");
            return;
        }

        if (action.href.startsWith("#")) {
            scrollToSection(action.href.slice(1));
            return;
        }

        if (action.href.startsWith("/")) {
            navigate(action.href);
        }
    };

    const handleScenarioAction = (action) => {
        if (action === "contact") {
            scrollToSection("contact-section");
            return;
        }

        if (action === "integration") {
            scrollToSection("integration-section");
            return;
        }

        if (action === "cv") {
            navigate("/cv");
            return;
        }

        if (action === "numbers") {
            navigate("/numbers");
            return;
        }

        if (action === "calculator") {
            navigate("/calculator");
        }
    };



    return (
        <div
            className="App min-h-screen overflow-x-hidden bg-[#030712] text-[#f5ead2]">
            {/* Header */}
            <UnifiedHeader
                pathname={pathname}
                navigate={navigate}
                activeSection={activeSection}
                onSectionSelect={scrollToSection}
                onCalculatorSelect={() => openHeroSlideById("metal-calculator")}
            />
            <style>{`
  @keyframes gradient-text {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  .animate-gradient-text {
    background-size: 200% 200%;
    animation: gradient-text 6s ease infinite;
  }
`}</style>


            <style>{`
  @keyframes gradient-text {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  .animate-gradient-text {
    background-size: 200% 200%;
    animation: gradient-text 6s ease infinite;
  }
`}</style>


            {/* Hero section */}
            <section className="hero-stack-section relative mb-10 min-h-[100svh] w-full max-w-full overflow-hidden bg-[#030712] px-4 pb-28 pt-32 text-[#f5ead2] sm:px-8 md:mb-16 md:pb-40 md:pt-40 xl:px-12">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_12%_16%,rgba(215,181,109,0.16),transparent_32%),radial-gradient(circle_at_84%_18%,rgba(20,184,166,0.13),transparent_30%),linear-gradient(135deg,#030712_0%,#08101e_48%,#02040b_100%)]"></div>
                <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(215,181,109,0.055)_1px,transparent_1px),linear-gradient(rgba(20,184,166,0.04)_1px,transparent_1px)] bg-[length:84px_84px]"></div>
                <div className="absolute left-0 top-0 h-full w-full bg-[linear-gradient(115deg,transparent_0%,transparent_54%,rgba(215,181,109,0.08)_54.2%,transparent_70%)]"></div>
                <div className="absolute bottom-[-18%] right-[-10%] h-[560px] w-[560px] rounded-full bg-cyan-400/10 blur-[130px]"></div>

                <div className="hero-stack-layout relative z-10 mx-auto grid w-full max-w-[1320px] min-w-0 gap-16 overflow-hidden py-6 md:gap-20 md:py-10 xl:gap-24">
                    <motion.article
                        initial={{opacity: 0, y: 22}}
                        animate={{opacity: 1, y: 0}}
                        transition={{duration: 0.55}}
                        className="mx-auto w-full max-w-full min-w-0 px-0 sm:px-3 md:max-w-[1180px] md:px-6"
                    >
                        <div className="mb-9 flex flex-wrap gap-3 md:mb-10">
                            {["промышленный AI", "документы", "камеры", "интеграции"].map((item) => (
                                <span
                                    key={item}
                                    className="rounded-full border border-[#d7b56d]/24 bg-[#d7b56d]/8 px-4 py-2 text-xs font-black uppercase tracking-[0.16em] text-[#e8d4a2]"
                                >
                                    {item}
                                </span>
                            ))}
                        </div>

                        <h1 className="max-w-full break-words text-[clamp(2rem,9.2vw,8.6rem)] font-black leading-[0.96] tracking-[-0.035em] text-[#f5ead2] drop-shadow-[0_0_44px_rgba(215,181,109,0.13)] md:leading-[0.88] md:tracking-[-0.085em]">
                            AI-контур для промышленной компании
                        </h1>
                        <p className="mt-10 max-w-full text-lg leading-relaxed text-[#b8c3d6] md:max-w-4xl md:text-2xl">
                            RuCortex связывает корпоративные знания, документы, камеры и прикладные
                            инструменты в единую систему. Платформа помогает быстрее находить ответы,
                            контролировать производственные события и запускать AI на реальных данных.
                        </p>

                        <div className="mt-12 flex min-w-0 flex-col gap-4 sm:flex-row">
                            <button
                                type="button"
                                onClick={() => navigate("/rucortex")}
                                className="inline-flex w-full max-w-full items-center justify-center rounded-full bg-[#d7b56d] px-8 py-4 text-sm font-black uppercase tracking-[0.16em] text-[#07111f] shadow-[0_20px_50px_rgba(215,181,109,0.24)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#f0cc7b] sm:w-auto"
                            >
                                Смотреть платформу
                            </button>
                            <button
                                type="button"
                                onClick={() => scrollToSection("contact-section")}
                                className="inline-flex w-full max-w-full items-center justify-center rounded-full border border-[#d7b56d]/26 bg-[#0d1628]/74 px-8 py-4 text-sm font-black uppercase tracking-[0.16em] text-[#f5ead2] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#17233b] sm:w-auto"
                            >
                                Обсудить пилот
                            </button>
                        </div>

                        <div className="mt-16 grid gap-px overflow-hidden rounded-[1.8rem] border border-[#d7b56d]/14 bg-[#d7b56d]/14 shadow-[0_22px_58px_rgba(0,0,0,0.26)] md:grid-cols-3">
                            {[
                                ["Внедрение", "ВЗ Электросталь", "Вологодская компания купила и внедрила продукт."],
                                ["Запуск", "Пилотный контур", "Начинаем с конкретного процесса и измеримых метрик."],
                                ["Модули", "Чат с ИИ, документы, CV", "Работа с документами, распознавание СИЗ и автомобильных номеров, калькулятор металлопроката."],
                            ].map(([label, title, text], index) => (
                                <div
                                    key={label}
                                className={`${index === 1 ? "bg-[#d7b56d] text-[#07111f]" : "bg-[#0b1220]/92 text-[#f5ead2]"} min-w-0 p-6 md:p-8`}
                                >
                                    <div className={`text-xs font-black uppercase tracking-[0.18em] ${index === 1 ? "text-[#07111f]/64" : "text-[#d7b56d]"}`}>
                                        {label}
                                    </div>
                                    <div className="mt-4 text-2xl font-black leading-tight tracking-[-0.04em]">
                                        {title}
                                    </div>
                                    <p className={`mt-3 text-sm leading-relaxed ${index === 1 ? "text-[#202018]/74" : "text-[#a7b4c9]"}`}>
                                        {text}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </motion.article>

                    <motion.aside
                        initial={{opacity: 0, y: 22}}
                        animate={{opacity: 1, y: 0}}
                        transition={{duration: 0.55, delay: 0.08}}
                        className="relative mx-auto w-full max-w-full min-w-0 md:max-w-[1180px]"
                    >
                        <div className="relative min-w-0 overflow-hidden rounded-2xl border border-[#d7b56d]/24 bg-[#07101f]/95 p-6 shadow-[0_34px_100px_rgba(0,0,0,0.48)] sm:p-7 md:p-10 xl:p-12">
                            <div className="pointer-events-none absolute inset-x-8 top-0 h-px bg-gradient-to-r from-transparent via-[#d7b56d]/70 to-transparent"></div>
                            <div className="relative flex flex-wrap items-start justify-between gap-6">
                                <div>
                                    <div className="text-xs font-black uppercase tracking-[0.22em] text-[#d7b56d]">
                                        Линейка RuCortex
                                    </div>
                                    <div className="mt-2 text-2xl font-black leading-tight text-white md:text-3xl">
                                        4 продукта в одном AI-контуре
                                    </div>
                                </div>
                                <div className="flex shrink-0 gap-2">
                                    <button
                                        type="button"
                                        onClick={goToPreviousHeroSlide}
                                        aria-label="Предыдущий продукт"
                                        className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-[#d7b56d]/26 bg-[#d7b56d]/10 text-lg font-black text-[#f5ead2] transition-all duration-300 hover:bg-[#d7b56d] hover:text-[#07111f]"
                                    >
                                        ←
                                    </button>
                                    <button
                                        type="button"
                                        onClick={goToNextHeroSlide}
                                        aria-label="Следующий продукт"
                                        className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-[#d7b56d]/26 bg-[#d7b56d]/10 text-lg font-black text-[#f5ead2] transition-all duration-300 hover:bg-[#d7b56d] hover:text-[#07111f]"
                                    >
                                        →
                                    </button>
                                </div>
                            </div>

                            <div className={`relative mt-8 grid min-h-0 min-w-0 gap-6 transition-opacity duration-200 ${heroIsVisible ? "opacity-100" : "opacity-0"} md:gap-8`}>
                                <div className="flex min-h-[260px] items-center justify-center overflow-hidden rounded-xl border border-white/10 bg-[#091525] p-6 md:min-h-[320px] md:p-8">
                                    <img
                                        src={activeHeroSlide.image}
                                        alt={activeHeroSlide.alt}
                                        decoding="async"
                                        className="h-auto max-h-[260px] w-full max-w-[320px] object-contain drop-shadow-[0_0_30px_rgba(56,189,248,0.36)] md:max-h-[300px] md:max-w-[360px]"
                                    />
                                </div>

                                <div className="flex min-h-0 min-w-0 flex-col justify-between rounded-xl border border-white/10 bg-white/[0.035] p-6 md:p-8">
                                    <div>
                                        <div className="inline-flex rounded-lg border border-cyan-300/18 bg-cyan-300/8 px-3 py-1.5 text-xs font-black uppercase tracking-[0.16em] text-cyan-100/82">
                                            {activeHeroSlide.id === "ai-search" ? "Платформа" : activeHeroSlide.id === "computer-vision" ? "Видеоаналитика" : activeHeroSlide.id === "license-plates" ? "КПП и территория" : "Инженерные расчеты"}
                                        </div>
                                        <h2 className="mt-5 text-[clamp(2rem,4vw,3.45rem)] font-black leading-[0.98] text-white">
                                            {activeHeroSlide.title}
                                        </h2>
                                        <p className="mt-5 text-base leading-relaxed text-blue-100/74 md:text-lg">
                                            {activeHeroSlide.description}
                                        </p>
                                    </div>
                                    {activeHeroSlide.apkDownload ? (
                                        <a
                                            href={activeHeroSlide.apkDownload.href}
                                            download={activeHeroSlide.apkDownload.fileName}
                                            className="mt-6 inline-flex w-full items-center justify-center rounded-xl bg-[#d7b56d] px-6 py-3 text-center text-sm font-black uppercase leading-tight tracking-[0.12em] text-[#07111f] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#f0cc7b] sm:w-auto"
                                        >
                                            {activeHeroSlide.apkDownload.label}
                                        </a>
                                    ) : (
                                        <button
                                            type="button"
                                            onClick={() => handleHeroActionClick(activeHeroSlide.action)}
                                            className="mt-6 inline-flex w-full items-center justify-center rounded-xl bg-[#d7b56d] px-6 py-3 text-center text-sm font-black uppercase leading-tight tracking-[0.12em] text-[#07111f] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#f0cc7b] sm:w-auto"
                                        >
                                            {activeHeroSlide.action?.label}
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="relative mt-8 grid grid-cols-2 gap-3 md:grid-cols-4">
                                {heroSlides.map((slide, index) => (
                                    <button
                                        key={slide.id}
                                        type="button"
                                        onClick={() => queueHeroSlide(index)}
                                        className={`min-h-[64px] rounded-xl border px-3 py-3 text-left transition-all duration-300 ${
                                            index === heroSlideIndex
                                                ? "border-[#d7b56d]/70 bg-[#d7b56d] text-[#07111f]"
                                                : "border-white/10 bg-white/[0.045] text-blue-100/72 hover:border-[#d7b56d]/32 hover:bg-white/[0.07] hover:text-white"
                                        }`}
                                    >
                                        <span className="block text-[0.65rem] font-black uppercase leading-none tracking-[0.14em] opacity-70">
                                            0{index + 1}
                                        </span>
                                        <span className="mt-2 block text-xs font-black uppercase leading-tight tracking-[0.08em]">
                                            {slide.id === "ai-search" ? "Платформа" : slide.id === "computer-vision" ? "СИЗ" : slide.id === "license-plates" ? "Номера" : "Калькулятор"}
                                        </span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </motion.aside>
                </div>
            </section>

            {/* Company preview section */}
            <section className="relative overflow-hidden bg-[linear-gradient(135deg,#030712_0%,#09111f_48%,#040814_100%)] px-5 py-24 text-[#f5ead2] sm:px-8 md:py-32 xl:px-12">
                <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(215,181,109,0.055)_1px,transparent_1px),linear-gradient(rgba(20,184,166,0.045)_1px,transparent_1px)] bg-[length:80px_80px]"></div>
                <div className="absolute right-[-16%] top-[-20%] h-[560px] w-[560px] rounded-full bg-[#d7b56d]/14 blur-[120px]"></div>
                <div className="absolute left-[-18%] bottom-[-24%] h-[520px] w-[520px] rounded-full bg-[#14b8a6]/10 blur-[130px]"></div>

                <div className="relative z-10 mx-auto max-w-[1520px]">
                    <motion.article
                        initial={{opacity: 0, y: 24}}
                        whileInView={{opacity: 1, y: 0}}
                        transition={{duration: 0.55}}
                        viewport={{once: true, amount: 0.3}}
                        className="grid gap-10 lg:grid-cols-[1.08fr_0.92fr] lg:items-end"
                    >
                        <div>
                            <p className="mb-5 text-sm font-black uppercase tracking-[0.24em] text-[#d7b56d]">
                                Компания и продукт
                            </p>
                            <h2 className="max-w-5xl text-[clamp(3rem,6.5vw,7.8rem)] font-black leading-[0.9] tracking-[-0.08em] text-[#f5ead2] drop-shadow-[0_0_42px_rgba(215,181,109,0.14)]">
                                Продуктовая линейка для промышленного AI-внедрения
                            </h2>
                            <p className="mt-7 max-w-3xl text-xl leading-relaxed text-[#a7b4c9] md:text-2xl">
                                RuCortex объединяет AI-поиск по документам, корпоративные интеграции,
                                документогенерацию, контроль СИЗ, распознавание номеров и инженерные
                                расчеты. Продукты помогают промышленным командам быстрее находить информацию,
                                контролировать события и работать с данными из разных систем.
                            </p>
                        </div>

                        <div className="rounded-[2.25rem] border border-[#d7b56d]/18 bg-[#070b15] p-6 text-[#f5ead2] shadow-[0_28px_74px_rgba(0,0,0,0.4)] md:p-8">
                            <div className="text-sm font-black uppercase tracking-[0.22em] text-[#d7b56d]">
                                Реальное внедрение
                            </div>
                                <div className="mt-5 whitespace-nowrap text-[clamp(1.15rem,5.8vw,3.7rem)] font-black leading-none tracking-[-0.035em]">
                                ВЗ Электросталь
                            </div>
                            <p className="mt-6 text-lg leading-relaxed text-[#a7b4c9]">
                                Вологодская производственная компания купила и внедрила продукт RuCortex.
                                Это подтверждает, что решение проверялось не только на демонстрационных
                                сценариях, но и в рабочем контуре заказчика.
                            </p>
                            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                                <button
                                    type="button"
                                    onClick={() => navigate("/rucortex")}
                                    className="inline-flex w-full items-center justify-center rounded-full bg-[#d7b56d] px-7 py-4 text-sm font-black uppercase tracking-[0.14em] text-[#07111f] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#f0cc7b] sm:w-auto"
                                >
                                    Смотреть RuCortex
                                </button>
                                <button
                                    type="button"
                                    onClick={() => scrollToSection("contact-section")}
                                    className="inline-flex w-full items-center justify-center rounded-full border border-[#d7b56d]/24 px-7 py-4 text-sm font-black uppercase tracking-[0.14em] text-[#f5ead2] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#d7b56d]/10 sm:w-auto"
                                >
                                    Обсудить пилот
                                </button>
                            </div>
                        </div>
                    </motion.article>

                    <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-[2rem] bg-[#d7b56d]/16 shadow-[0_24px_70px_rgba(0,0,0,0.28)] lg:grid-cols-3">
                        {companyPreviewItems.map((item, index) => (
                            <motion.article
                                key={item.label}
                                initial={{opacity: 0, y: 22}}
                                whileInView={{opacity: 1, y: 0}}
                                transition={{duration: 0.5, delay: index * 0.08}}
                                viewport={{once: true, amount: 0.3}}
                                className={`${index === 1 ? "bg-gradient-to-br from-[#d7b56d] to-[#8a642f] text-[#07111f]" : "bg-[#101827] text-[#f5ead2]"} min-h-[290px] p-6 md:p-8`}
                            >
                                <div className={`text-xs font-black uppercase tracking-[0.2em] ${index === 1 ? "text-[#07111f]/68" : "text-[#d7b56d]"}`}>
                                    {item.label}
                                </div>
                                <h3 className={`mt-8 text-3xl font-black leading-tight tracking-[-0.04em] ${index === 1 ? "text-[#07111f]" : "text-[#f5ead2]"}`}>
                                    {item.title}
                                </h3>
                                <p className={`mt-5 text-base leading-relaxed ${index === 1 ? "text-[#1c1b17]/78" : "text-[#a7b4c9]"}`}>
                                    {item.text}
                                </p>
                            </motion.article>
                        ))}
                    </div>
                </div>
            </section>

            {/* Scenario section */}
            <section
                id="scenario-section"
                className="relative overflow-hidden bg-[linear-gradient(180deg,#07101f_0%,#0b1428_52%,#050914_100%)] px-6 py-24 text-[#f5ead2]"
            >
                <div className="absolute inset-0 opacity-25">
                    <div className="absolute left-[12%] top-[12%] h-[420px] w-[420px] rounded-full bg-cyan-500/25 blur-[150px]"></div>
                    <div className="absolute bottom-[4%] right-[10%] h-[360px] w-[360px] rounded-full bg-[#d7b56d]/18 blur-[150px]"></div>
                </div>

                <div className="relative z-10 mx-auto max-w-7xl">
                    <motion.div
                        initial={{opacity: 0, y: 24}}
                        whileInView={{opacity: 1, y: 0}}
                        transition={{duration: 0.6}}
                        viewport={{once: true}}
                        className="mb-12 max-w-4xl"
                    >
                        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.28em] text-[#d7b56d]">
                            Не просто AI, а рабочие сценарии
                        </p>
                        <h2 className="text-3xl font-extrabold leading-tight text-[#f5ead2] drop-shadow-[0_0_24px_rgba(215,181,109,0.18)] md:text-4xl">
                            Выберите задачу, которую RuCortex должен решить первой
                        </h2>
                        <p className="mt-5 text-lg md:text-xl leading-relaxed text-blue-100/82">
                            Сильный пилот начинается не с презентации технологии, а с выбора
                            конкретного процесса: где теряется время, где нужны проверяемые ответы,
                            где камера должна фиксировать риск или где команде нужен готовый инструмент.
                        </p>
                    </motion.div>

                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
                        {businessScenarioItems.map((item, index) => (
                            <motion.article
                                key={item.title}
                                initial={{opacity: 0, y: 28}}
                                whileInView={{opacity: 1, y: 0}}
                                transition={{duration: 0.5, delay: index * 0.06}}
                                viewport={{once: true, amount: 0.3}}
                                className="group flex min-h-[330px] flex-col justify-between rounded-[1.35rem] border border-[#d7b56d]/18 bg-[#0f1728]/82 p-6 shadow-[0_18px_48px_rgba(0,0,0,0.3)] backdrop-blur-md transition-all duration-300 hover:-translate-y-1 hover:border-[#d7b56d]/38 hover:shadow-[0_0_42px_rgba(215,181,109,0.16)]"
                            >
                                <div>
                                    <div className="mb-6 h-1.5 w-16 rounded-full bg-gradient-to-r from-[#d7b56d] to-cyan-300 shadow-[0_0_18px_rgba(215,181,109,0.34)]"></div>
                                    <h3 className="text-2xl font-bold leading-tight text-white">
                                        {item.title}
                                    </h3>
                                    <p className="mt-4 text-base leading-relaxed text-blue-100/78">
                                        {item.text}
                                    </p>
                                </div>

                                <button
                                    type="button"
                                    onClick={() => handleScenarioAction(item.action)}
                                    className="mt-8 inline-flex min-h-[48px] items-center justify-center rounded-full border border-[#d7b56d]/32 bg-white/8 px-5 py-3 text-center text-sm font-bold uppercase leading-tight tracking-[0.14em] text-[#f5ead2] transition-all duration-300 group-hover:bg-[#d7b56d] group-hover:text-[#07111f]"
                                >
                                    {item.actionLabel}
                                </button>
                            </motion.article>
                        ))}
                    </div>
                </div>
            </section>

            {/* Problem section */}
            <section
                className="relative overflow-hidden bg-[#070b15] px-6 py-20 text-white">
                <div className="absolute right-[-12%] top-[-20%] h-[520px] w-[520px] rounded-full bg-[#d7b56d]/12 blur-[130px]"></div>
                <div className="absolute bottom-[-22%] left-[-10%] h-[480px] w-[480px] rounded-full bg-cyan-500/12 blur-[140px]"></div>

                <div className="relative z-10 mx-auto grid max-w-7xl gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
                    <motion.div
                        initial={{opacity: 0, y: 24}}
                        whileInView={{opacity: 1, y: 0}}
                        transition={{duration: 0.55}}
                        viewport={{once: true}}
                        className="max-w-2xl"
                    >
                        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.26em] text-[#d7b56d]">
                            Почему нужен контур
                        </p>
                        <h2 className="text-3xl font-extrabold leading-tight tracking-[-0.035em] text-white md:text-4xl">
                            Данные в разных местах тормозят работу команды
                        </h2>
                        <p className="mt-5 text-base leading-relaxed text-blue-100/78 md:text-lg">
                            Когда документы, заявки и производственные события живут в разных системах,
                            сотрудники теряют время на поиск информации вручную. RuCortex собирает знания и действия
                            в единый проверяемый контур.
                        </p>
                        <button
                            type="button"
                            onClick={() => navigate("/rucortex")}
                            className="mt-8 inline-flex items-center justify-center rounded-full border border-[#d7b56d]/35 bg-[#d7b56d] px-6 py-3 text-sm font-black uppercase tracking-[0.14em] text-[#07111f] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#f0cc7b]"
                        >
                            Смотреть RuCortex
                        </button>
                    </motion.div>

                    <div className="grid gap-4 md:grid-cols-3 lg:grid-cols-1">
                        {platformProblemItems.map((item, index) => (
                            <motion.article
                                key={item.label}
                                initial={{opacity: 0, y: 22}}
                                whileInView={{opacity: 1, y: 0}}
                                transition={{duration: 0.45, delay: index * 0.06}}
                                viewport={{once: true, amount: 0.3}}
                                className="rounded-[1.45rem] border border-[#d7b56d]/16 bg-[#0f1728]/86 p-5 shadow-[0_18px_44px_rgba(0,0,0,0.24)]"
                            >
                                <div className="text-xs font-black uppercase tracking-[0.2em] text-[#d7b56d]">
                                    {item.label}
                                </div>
                                <h3 className="mt-3 text-xl font-black leading-tight tracking-[-0.03em] text-white md:text-2xl">
                                    {item.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-blue-100/72 md:text-base">
                                    {item.text}
                                </p>
                            </motion.article>
                        ))}
                    </div>
                </div>
            </section>

            {/* Solution section */}
            <section
                id="solution-section"
                className="relative overflow-hidden bg-[linear-gradient(180deg,#070b15_0%,#0b1428_52%,#07101f_100%)] px-6 py-20 text-center">
                {/* Фоновое свечение */}
                <div className="absolute inset-0 opacity-20">
                    <div
                        className="absolute top-1/2 left-1/2 w-[700px] h-[700px] bg-cyan-500/30 blur-[200px] rounded-full animate-glow"></div>
                </div>

                {/* Контент */}
                <div className="relative z-10 mx-auto max-w-6xl">
                    <motion.h2
                        initial={{opacity: 0, y: 30}}
                        whileInView={{opacity: 1, y: 0}}
                        transition={{duration: 0.6}}
                        viewport={{once: true}}
                        className="mb-8 text-3xl font-extrabold leading-tight text-[#f5ead2] drop-shadow-[0_0_20px_rgba(215,181,109,0.16)] md:text-4xl"
                    >
                        Что делает RuCortex
                    </motion.h2>

                    <motion.p
                        initial={{opacity: 0}}
                        whileInView={{opacity: 1}}
                        transition={{delay: 0.2, duration: 0.8}}
                        viewport={{once: true}}
                        className="mx-auto mb-12 max-w-3xl text-base leading-relaxed text-blue-100/78 md:text-lg"
                    >
                        <span className="font-semibold text-[#d7b56d]">RuCortex</span> связывает
                        документы, базы, интеграции и прикладные модули в один рабочий контур,
                        чтобы сотрудники получали проверяемые ответы и быстрее переходили к действию.
                    </motion.p>

                    {/* Плитки преимуществ */}
                    <div className="grid gap-5 md:grid-cols-2">
                        {platformSolutionItems.map((text, i) => (
                            <motion.div
                                key={i}
                                initial={{opacity: 0, y: 20}}
                                whileInView={{opacity: 1, y: 0}}
                                transition={{duration: 0.45, delay: i * 0.05}}
                                viewport={{once: true, amount: 0.3}}
                                className="rounded-[1.25rem] border border-[#d7b56d]/16 bg-[#0f1728]/76 p-6 text-left shadow-[0_16px_42px_rgba(0,0,0,0.22)]"
                            >
                                <p className="text-base leading-relaxed text-blue-100/80">{text}</p>
                            </motion.div>
                        ))}
                    </div>

                    <button
                        type="button"
                        onClick={() => navigate("/rucortex")}
                        className="mt-10 inline-flex items-center justify-center rounded-full border border-[#d7b56d]/32 bg-white/8 px-7 py-3 text-sm font-black uppercase tracking-[0.14em] text-[#f5ead2] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#d7b56d] hover:text-[#07111f]"
                    >
                        Подробнее о платформе
                    </button>
                </div>
            </section>


            {/* Technology section */}
            <section
                id="technology-section"
                className="relative overflow-hidden bg-[linear-gradient(180deg,#07101f_0%,#0b1428_52%,#07101f_100%)] px-6 py-20 text-white">
                {/* Светящаяся подложка */}
                <div className="absolute inset-0 opacity-30">
                    <div
                        className="absolute top-1/2 left-1/2 w-[900px] h-[900px] bg-[#d7b56d]/16 blur-[200px] rounded-full animate-glow"></div>
                </div>

                <div className="relative z-10 max-w-7xl mx-auto">
                    <h2 className="mb-14 text-center text-3xl font-extrabold text-[#f5ead2] drop-shadow-[0_0_25px_rgba(215,181,109,0.18)] md:text-4xl">
                        Технология RuCortex
                    </h2>

                    <style>{`
      @keyframes borderFlow {
        0% { box-shadow: 0 0 25px rgba(215,181,109,0.08), inset 0 0 0 1px rgba(215,181,109,0.18); }
        10% { box-shadow: 0 0 40px rgba(215,181,109,0.18), inset 0 0 0 1px rgba(6,182,212,0.42); }
        25% { box-shadow: 0 0 60px rgba(6,182,212,0.4), inset 0 0 0 1px rgba(6,182,212,0.7); }
        50% { box-shadow: 0 0 40px rgba(215,181,109,0.18), inset 0 0 0 1px rgba(215,181,109,0.24); }
        75% { box-shadow: 0 0 25px rgba(6,182,212,0.3), inset 0 0 0 1px rgba(6,182,212,0.2); }
        100% { box-shadow: 0 0 25px rgba(215,181,109,0.08), inset 0 0 0 1px rgba(215,181,109,0.18); }
      }
      @keyframes glowLine {
        0% { opacity: 0; transform: scaleX(0); }
        20% { opacity: 1; transform: scaleX(1); }
        80% { opacity: 1; transform: scaleX(1); }
        100% { opacity: 0; transform: scaleX(0); }
      }
      .animate-borderFlow { animation: borderFlow 10s linear infinite; }
      .animate-glowLine { animation: glowLine 10s linear infinite; transform-origin: left; }
    `}</style>

                    {/* Основная сетка */}
                    <div className="relative grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                        {/* Световые линии между блоками */}
                        {[0, 1, 2, 3, 4, 5].map((_, i) => (
                            <div
                                key={i}
                                className="absolute w-[60%] h-[3px] left-[20%] bg-gradient-to-r from-[#d7b56d] via-cyan-300 to-[#d7b56d] blur-sm rounded-full opacity-60 animate-glowLine"
                                style={{
                                    top: `${22 + i * 31}%`,
                                    animationDelay: `${i * 1.2}s`,
                                }}
                            ></div>
                        ))}

                        {/* Карточки */}
                        {[
                            "Безопасный периметр",
                            "Корпоративные источники",
                            "Гибридный поиск",
                            "Подготовка знаний",
                            "Смысловые индексы",
                            "Ответ с проверкой",
                            "Агентный сценарий",
                            "Права доступа",
                            "Мониторинг качества",
                        ].map((title, i) => (
                            <motion.div
                                key={i}
                                whileHover={{scale: 1.05}}
                                className="relative rounded-2xl bg-gradient-to-br from-[#0b1428] to-[#07101f] p-6
                     border border-cyan-400/30 backdrop-blur-sm transition-all
                     animate-borderFlow hover:shadow-[0_0_42px_rgba(215,181,109,0.24)]"
                                style={{animationDelay: `${i * 1.1}s`}}
                            >
                                <h3 className="text-2xl font-bold mb-3 text-[#d7b56d]">{title}</h3>
                                <p className="text-blue-100 text-base leading-relaxed">
                                    {
                                        [
                                            "API, роли, журнал действий и ограничения доступа защищают корпоративные данные на каждом запросе.",
                                            "Подключаем документы, 1С, Битрикс24, CRM, базы данных и файловые архивы с понятной схемой обновления.",
                                            "Комбинируем полнотекстовый, векторный и графовый поиск, чтобы находить не только совпадения слов, но и смысловые связи.",
                                            "Извлекаем факты, таблицы, нормативные ссылки и карточки сущностей, превращая документы и файлы в базу знаний.",
                                            "Индексы разделяются по типам данных, правам и критичности, поэтому ответы можно контролировать и обновлять без хаоса.",
                                            "Модель формирует ответ только на основе найденных источников и возвращает цитаты для ручной проверки.",
                                            "Оркестратор выбирает нужные инструменты: поиск, уточняющий вопрос, расчет, подготовку письма или документа.",
                                            "Перед выдачей ответ проходит проверку на формат, конфиденциальность, полноту источников и права доступа.",
                                            "Метрики запросов, оценка ответов и регрессионные тесты помогают поддерживать качество после каждого обновления базы.",
                                        ][i]
                                    }
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Integration section */}
            <section
                id="integration-section"
                className="relative overflow-hidden bg-[linear-gradient(180deg,#07101f_0%,#0b1428_52%,#07101f_100%)] px-6 py-20 text-white">
                <div className="absolute inset-0 opacity-28">
                    <div
                        className="absolute top-1/2 left-1/2 w-[820px] h-[820px] bg-cyan-500/18 blur-[220px] rounded-full animate-glow"></div>
                </div>

                <div className="relative z-10 max-w-7xl mx-auto">
                    <motion.h2
                        initial={{opacity: 0, y: 24}}
                        whileInView={{opacity: 1, y: 0}}
                        transition={{duration: 0.6}}
                        viewport={{once: true}}
                        className="mb-4 text-center text-3xl font-extrabold text-[#f5ead2] drop-shadow-[0_0_25px_rgba(215,181,109,0.18)] md:text-4xl"
                    >
                        Интеграция
                    </motion.h2>

                    <motion.p
                        initial={{opacity: 0, y: 18}}
                        whileInView={{opacity: 1, y: 0}}
                        transition={{delay: 0.1, duration: 0.6}}
                        viewport={{once: true}}
                        className="max-w-3xl mx-auto text-center text-lg md:text-xl text-blue-100 mb-10 leading-relaxed"
                    >
                        Подключаем RuCortex к тем системам, где уже живут знания и процессы. На
                        пилоте фиксируем минимальный набор источников, права доступа и критерии
                        качества ответов.
                    </motion.p>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {integrationItems.map((item, index) => {
                            const reverse = index % 2 === 1;

                            return (
                                <motion.div
                                    key={item.id}
                                    initial={{opacity: 0, y: 30}}
                                    whileInView={{opacity: 1, y: 0}}
                                    transition={{duration: 0.55, delay: index * 0.06}}
                                    viewport={{once: true, amount: 0.3}}
                                    className="relative overflow-hidden rounded-[1.4rem] border border-[#d7b56d]/16 bg-gradient-to-br from-[#0b1428]/95 to-[#07101f]/92 shadow-[0_0_24px_rgba(56,189,248,0.1)]"
                                >
                                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(215,181,109,0.14)_0%,_transparent_45%),radial-gradient(circle_at_bottom_left,_rgba(56,189,248,0.14)_0%,_transparent_40%)]"></div>
                                    <div
                                        className={`relative z-10 flex flex-col ${reverse ? "md:flex-row-reverse" : "md:flex-row"} items-stretch gap-5 p-5 md:p-6`}
                                    >
                                        <div className="relative flex-shrink-0 w-full md:w-[150px] lg:w-[170px] flex items-center justify-center md:justify-start">
                                            <div
                                                className="absolute inset-3 rounded-full blur-3xl opacity-90"
                                                style={{background: item.glowSoft}}
                                            ></div>
                                            <div
                                                className="absolute inset-6 rounded-full blur-2xl opacity-80"
                                                style={{background: item.glowSoft}}
                                            ></div>
                                            <div className="relative z-10 flex items-center justify-center w-full h-full md:justify-start">
                                                <img
                                                    src={item.image}
                                                    alt={item.title}
                                                    loading="lazy"
                                                    decoding="async"
                                                    className="relative z-10 w-[88%] max-w-[145px] h-auto object-contain drop-shadow-[0_0_32px_var(--logo-glow)]"
                                                    style={{"--logo-glow": item.glow}}
                                                />
                                            </div>
                                        </div>

                                        <div className={`flex-1 flex flex-col justify-center ${reverse ? "text-right md:items-end" : "text-center md:text-left"}`}>
                                            <h3 className="text-2xl md:text-3xl font-bold mb-3 tracking-wide bg-gradient-to-r from-[#d7b56d] via-cyan-200 to-[#f5ead2] bg-clip-text text-transparent drop-shadow-[0_0_18px_rgba(215,181,109,0.16)]">
                                                {item.title}
                                            </h3>
                                            <p className={`text-blue-100 text-base md:text-lg leading-relaxed max-w-xl ${reverse ? "md:ml-auto" : ""}`}>
                                                {item.text}
                                            </p>
                                        </div>
                                    </div>
                                </motion.div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* Pilot process section */}
            <section
                id="process-section"
                className="relative overflow-hidden bg-[linear-gradient(180deg,#07101f_0%,#0b1428_55%,#050914_100%)] px-6 py-24 text-white"
            >
                <div className="absolute inset-0 opacity-20">
                    <div className="absolute left-1/2 top-0 h-[560px] w-[900px] -translate-x-1/2 rounded-full bg-cyan-400/20 blur-[190px]"></div>
                </div>

                <div className="relative z-10 mx-auto max-w-7xl">
                    <div className="mx-auto mb-14 max-w-4xl text-center">
                        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.28em] text-[#d7b56d]">
                            Как доводим до результата
                        </p>
                        <h2 className="text-3xl font-extrabold leading-tight md:text-4xl">
                            Начинаем с прототипа, а не с дорогого внедрения вслепую
                        </h2>
                        <p className="mt-5 text-lg md:text-xl leading-relaxed text-blue-100/80">
                            Эта логика сильнее обычного “оставьте заявку”: заказчик заранее понимает,
                            что будет проверено, какие данные нужны и по каким критериям принимается
                            решение о масштабировании.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
                        {pilotStepItems.map((item, index) => (
                            <motion.article
                                key={item.step}
                                initial={{opacity: 0, y: 24}}
                                whileInView={{opacity: 1, y: 0}}
                                transition={{duration: 0.5, delay: index * 0.08}}
                                viewport={{once: true, amount: 0.28}}
                                className="relative overflow-hidden rounded-[1.35rem] border border-[#d7b56d]/18 bg-[#0f1728]/80 p-6 shadow-[0_18px_48px_rgba(0,0,0,0.28)]"
                            >
                                <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-cyan-400/12 blur-2xl"></div>
                                <div className="relative z-10">
                                    <span className="text-sm font-black tracking-[0.32em] text-[#d7b56d]">
                                        {item.step}
                                    </span>
                                    <h3 className="mt-5 text-2xl font-bold text-white">{item.title}</h3>
                                    <p className="mt-4 text-base leading-relaxed text-blue-100/76">
                                        {item.text}
                                    </p>
                                </div>
                            </motion.article>
                        ))}
                    </div>

                    <div className="mt-12 flex justify-center">
                        <button
                            type="button"
                            onClick={() => scrollToSection("contact-section")}
                            className="rounded-full bg-[#d7b56d] px-8 py-4 text-lg font-bold text-[#07111f] shadow-[0_18px_42px_rgba(215,181,109,0.24)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#f0cc7b]"
                        >
                            Начать с диагностики
                        </button>
                    </div>
                </div>
            </section>

            {/* Competitive Advantage section */}
            <section
                id="advantage-section"
                className="relative overflow-hidden bg-[linear-gradient(180deg,#050914_0%,#0b1428_52%,#07101f_100%)] px-6 py-20 text-white">
                <div className="absolute inset-0 opacity-30">
                    <div
                        className="absolute top-1/2 left-1/2 w-[800px] h-[800px] bg-[#d7b56d]/14 blur-[200px] rounded-full animate-glow"></div>
                </div>

                <div className="relative z-10 max-w-6xl mx-auto">
                    <h2 className="mb-14 text-center text-3xl font-extrabold text-[#f5ead2] drop-shadow-[0_0_25px_rgba(215,181,109,0.18)] md:text-4xl">
                        Что проверяем на пилоте
                    </h2>

                    <div
                        className="overflow-x-auto rounded-2xl border border-cyan-400/30 shadow-[0_0_35px_rgba(56,189,248,0.2)] backdrop-blur-sm">
                        <table className="min-w-[680px] w-full border-collapse text-left text-blue-100">
                            <thead className="bg-gradient-to-r from-[#d7b56d]/24 to-cyan-700/20 text-white">
                            <tr>
                                <th className="p-5 text-lg font-semibold border-b border-cyan-400/30">Критерий</th>
                                <th className="p-5 text-lg font-semibold border-b border-cyan-400/30">Как оцениваем</th>
                            </tr>
                            </thead>
                            <tbody>
                            {[
                                {
                                    metric: "Время ответа",
                                    value: "Сравниваем типовые вопросы до и после подключения источников",
                                },
                                {
                                    metric: "Проверяемость",
                                    value: "Каждый ответ должен вести к документу, разделу, строке или карточке данных",
                                },
                                {
                                    metric: "Точность",
                                    value: "Отдельно считаем корректные ответы, уточняющие вопросы и ошибки",
                                },
                                {
                                    metric: "Актуальность",
                                    value: "Проверяем обновление нормативов, прайсов, остатков и версий документов",
                                },
                                {
                                    metric: "Интеграции",
                                    value: "Подключаем приоритетные источники: 1С, Битрикс24, CRM, базы данных или файловые архивы",
                                },
                                {
                                    metric: "ИБ и размещение",
                                    value: "Согласуем роли, журналы действий и вариант размещения в частном контуре или on-prem",
                                },
                            ].map((row, i) => (
                                <tr
                                    key={i}
                                    className={`transition-all duration-500 hover:bg-gradient-to-r hover:from-cyan-900/30 hover:to-[#7f5b2d]/20 ${
                                        i % 2 === 0 ? "bg-[#0b1428]/54" : "bg-[#07101f]/56"
                                    }`}
                                >
                                    <td className="p-5 text-base font-medium border-b border-cyan-400/20">{row.metric}</td>
                                    <td className="p-5 text-base border-b border-cyan-400/20 text-blue-50 font-semibold">
                                        {row.value}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <style>{`
    @keyframes glow {
      0%, 100% { opacity: 0.3; transform: scale(1); }
      50% { opacity: 0.6; transform: scale(1.05); }
    }
    .animate-glow {
      animation: glow 10s ease-in-out infinite;
    }
  `}</style>
            </section>

            {/* Pilot Section */}
            <section
                id="contact-section"
                className="relative overflow-hidden bg-[linear-gradient(135deg,#07101f_0%,#0b1428_52%,#050914_100%)] px-6 py-20 text-white md:px-8"
            >
                {/* Анимированный градиентный фон */}
                <div className="absolute inset-0">
                    <div
                        className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(215,181,109,0.12)_0%,_transparent_70%)] animate-slow-pulse"></div>
                    <div
                        className="absolute top-1/2 left-1/2 w-[1000px] h-[1000px] bg-cyan-500/20 blur-[250px] rounded-full animate-glow"></div>
                </div>

                <div className="relative z-10 max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-16">
                    {/* === ЛЕВАЯ ЧАСТЬ (текст + изображение) === */}
                    <div className="flex-1 relative flex flex-col justify-center items-start">
                        {/* Фон — мозг с мягким свечением */}
                        <img
                            src={brainBg}
                            alt="RuCortex Pilot"
                            loading="lazy"
                            decoding="async"
                            className="absolute -top-10 left-0 w-[400px] opacity-25 blur-[1px] select-none animate-brain-flow"
                        />

                        <h2 className="mb-6 bg-gradient-to-r from-[#d7b56d] via-cyan-200 to-[#f5ead2] bg-clip-text text-3xl font-extrabold text-transparent md:text-4xl">
                            Запустите пилот на ваших данных
                        </h2>

                        <p className="text-blue-100 mb-8 text-lg leading-relaxed max-w-md">
                            Выберите один рабочий сценарий: поиск по нормативам, ответы по 1С,
                            контроль СИЗ по камерам или подготовка технических ответов. Мы
                            подключим ограниченный контур и измерим результат на реальных запросах.
                        </p>

                        <h3 className="text-2xl font-semibold mb-4 text-[#d7b56d]">
                            Что входит в пилот:
                        </h3>

                        <ul className="space-y-3 text-blue-100 text-base leading-relaxed">
                            <li className="flex items-start gap-3">
                                <span className="text-cyan-400 text-xl">⚡</span>
                                Список источников и критерии качества
                            </li>
                            <li className="flex items-start gap-3">
                                <span className="text-cyan-400 text-xl">⏱️</span>
                                Тестовые вопросы, события или бизнес-сценарии
                            </li>
                            <li className="flex items-start gap-3">
                                <span className="text-cyan-400 text-xl">🔧</span>
                                Отчет по точности, скорости и дальнейшему масштабированию
                            </li>
                        </ul>
                    </div>

                    {/* === ПРАВАЯ ЧАСТЬ (форма) === */}
                    <div className="flex-1 w-full">
                        <LeadForm source="Главная секция заявки на пилот" />
                    </div>
                </div>

                <style>{`
    @keyframes glow {
      0%, 100% { opacity: 0.3; transform: scale(1); }
      50% { opacity: 0.6; transform: scale(1.05); }
    }
    .animate-glow {
      animation: glow 12s ease-in-out infinite;
    }

    @keyframes gradient-text {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
    .animate-gradient-text {
      background-size: 200% 200%;
      animation: gradient-text 6s ease infinite;
    }

    @keyframes brain-flow {
      0%, 100% { transform: translateY(0) rotate(0deg); opacity: 0.25; }
      50% { transform: translateY(-10px) rotate(1deg); opacity: 0.35; }
    }
    .animate-brain-flow {
      animation: brain-flow 10s ease-in-out infinite;
    }

    @keyframes slow-pulse {
      0%, 100% { opacity: 0.15; transform: scale(1); }
      50% { opacity: 0.3; transform: scale(1.05); }
    }
    .animate-slow-pulse {
      animation: slow-pulse 15s ease-in-out infinite;
    }
  `}</style>
            </section>
            <SiteFooter onOpenPolicy={() => setPolicyOpen(true)} />
            <PrivacyModal open={policyOpen} onClose={() => setPolicyOpen(false)} />
            <CookieConsent />
        </div>
    );
}

function CvRouteShell({ children, withNav = false }) {
    return (
        <div className="cv-route-shell">
            <style>{`
                .cv-route-shell {
                    position: relative;
                    min-height: 100svh;
                    width: 100%;
                    overflow-x: hidden;
                    overflow-y: auto;
                    color: #eef2ff;
                    background:
                        linear-gradient(135deg, #090b18 0%, #111530 45%, #0b0d1d 100%);
                    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
                }

                .cv-route-shell::before {
                    content: "";
                    position: fixed;
                    inset: 0;
                    pointer-events: none;
                    background:
                        linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
                    background-size: 42px 42px;
                    opacity: 0.18;
                }

                .cv-route-shell::after {
                    content: "";
                    position: fixed;
                    inset: -12%;
                    pointer-events: none;
                    background:
                        radial-gradient(circle at 18% 8%, rgba(121, 87, 255, 0.22), transparent 34%),
                        radial-gradient(circle at 82% 14%, rgba(53, 214, 255, 0.14), transparent 28%),
                        radial-gradient(circle at 50% 96%, rgba(92, 108, 255, 0.16), transparent 34%);
                    filter: blur(70px);
                    opacity: 0.9;
                    transform: translateZ(0);
                    z-index: 0;
                }

                .cv-route-page {
                    position: relative;
                    z-index: 1;
                    width: min(70vw, 1180px);
                    min-height: 100svh;
                    margin: 0 auto;
                    padding: 18px 0 56px;
                    display: flex;
                    flex-direction: column;
                }

                .cv-route-content {
                    display: flex;
                    flex-direction: column;
                    flex: 1 0 auto;
                }

                .cv-route-spacer {
                    flex: 1 0 auto;
                    min-height: 56px;
                }

                .cv-topbar {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 24px;
                    padding-bottom: 12px;
                    border-bottom: 1px solid rgba(135, 133, 255, 0.16);
                }

                .cv-brand {
                    font-size: 1.8rem;
                    font-weight: 800;
                    letter-spacing: -0.03em;
                    background: linear-gradient(90deg, #d7b56d 0%, #5ae3ff 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    text-decoration: none;
                    cursor: pointer;
                }

                .cv-nav {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 14px;
                    flex-wrap: wrap;
                    flex: 1;
                }

                .cv-nav-link,
                .cv-cta,
                .cv-plain-link {
                    text-decoration: none;
                    transition: filter 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;
                }

                .cv-nav-link {
                    border: 0;
                    padding: 0;
                    background: transparent;
                    box-shadow: none;
                    font-size: 1.02rem;
                    font-weight: 500;
                    letter-spacing: 0;
                    color: rgba(238, 242, 255, 0.9);
                }

                .cv-nav-link:hover,
                .cv-cta:hover,
                .cv-plain-link:hover {
                    filter: brightness(1.04);
                }

                .cv-nav-link.is-active,
                .cv-nav-link:hover {
                    color: transparent;
                    background: linear-gradient(90deg, #d7b56d 0%, #5ae3ff 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    text-shadow: 0 0 16px rgba(90, 227, 255, 0.28);
                }

                .cv-panel {
                    background:
                        linear-gradient(180deg, rgba(53, 214, 255, 0.05), transparent 30%),
                        linear-gradient(180deg, rgba(26, 30, 68, 0.86), rgba(36, 27, 78, 0.78));
                    border: 2px solid rgba(56, 189, 248, 0.36);
                    border-radius: 30px;
                    box-shadow:
                        0 0 24px rgba(56, 189, 248, 0.18),
                        0 24px 80px rgba(0, 0, 0, 0.38);
                    backdrop-filter: blur(14px);
                }

                .cv-hero-shell {
                    display: grid;
                    grid-template-columns: 1.2fr 0.95fr;
                    gap: 0;
                    align-items: stretch;
                    margin-top: 22px;
                    overflow: hidden;
                    flex: 1;
                }

                .cv-main-copy {
                    padding: 28px 28px 26px;
                    min-height: 270px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    text-align: left;
                    border-radius: 30px 0 0 30px;
                }

                .cv-kicker {
                    display: inline-flex;
                    align-self: flex-start;
                    align-items: center;
                    gap: 10px;
                    font-size: 0.78rem;
                    color: rgba(229, 235, 255, 0.72);
                    text-transform: uppercase;
                    letter-spacing: 0.16em;
                    margin-bottom: 12px;
                }

                .cv-title {
                    margin: 0;
                    font-size: clamp(1.25rem, 2.1vw, 2rem);
                    line-height: 1.02;
                    letter-spacing: -0.05em;
                    max-width: none;
                    background: linear-gradient(90deg, #d7b56d 0%, #5ae3ff 45%, #7fdcff 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    text-shadow: 0 0 18px rgba(56, 189, 248, 0.15);
                }

                .cv-title span {
                    display: block;
                    margin-top: 6px;
                    color: #eef2ff;
                }

                .cv-lead {
                    max-width: none;
                    margin: 12px 0 0;
                    font-size: 1.3rem;
                    line-height: 1.5;
                    color: rgba(233, 239, 255, 0.78);
                }

                .cv-preview {
                    padding: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 270px;
                    border-left: 0;
                    border-radius: 0 30px 30px 0;
                }

                .cv-preview img {
                    width: min(100%, 450px);
                    height: auto;
                    display: block;
                    border-radius: 22px;
                    border: 1px solid rgba(132, 154, 255, 0.25);
                    box-shadow: 0 18px 54px rgba(0, 0, 0, 0.35);
                    object-fit: cover;
                }

                .cv-cta-row {
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    gap: 14px;
                    margin: 26px auto;
                }

                .cv-cta {
                    color: #ffffff;
                    background: linear-gradient(90deg, #d7b56d 0%, #06b6d4 100%);
                    border: 0;
                    border-radius: 999px;
                    padding: 12px 22px;
                    font-weight: 700;
                    font-size: 1.1rem;
                    letter-spacing: -0.01em;
                    box-shadow: 0 0 20px rgba(215, 181, 109, 0.55);
                    cursor: pointer;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    background-clip: padding-box;
                }

                .cv-stack {
                    display: grid;
                    gap: 12px;
                }

                .cv-stack > .cv-feature:not(.cv-mini-card) {
                    display: none;
                }

                .cv-feature {
                    padding: 18px 22px;
                    border-radius: 24px;
                    background:
                        linear-gradient(180deg, rgba(255, 255, 255, 0.04), transparent 28%),
                        rgba(16, 19, 42, 0.82);
                    border: 2px solid rgba(56, 189, 248, 0.38);
                    box-shadow:
                        0 0 22px rgba(56, 189, 248, 0.2),
                        0 12px 38px rgba(0, 0, 0, 0.22);
                    text-align: left;
                }

                .cv-feature h2,
                .cv-feature h3 {
                    margin: 0 0 8px;
                    line-height: 1.1;
                    letter-spacing: -0.03em;
                    background: linear-gradient(90deg, #d7b56d 0%, #5ae3ff 45%, #7fdcff 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    text-shadow: 0 0 16px rgba(56, 189, 248, 0.16);
                }

                .cv-feature h2 {
                    font-size: 1.3rem;
                }

                .cv-feature h3 {
                    font-size: 1.3rem;
                    line-height: 1.15;
                    letter-spacing: -0.02em;
                }

                .cv-feature p {
                    margin: 0;
                    color: rgba(233, 239, 255, 0.78);
                    line-height: 1.45;
                    font-size: 1.1rem;
                    max-width: 78ch;
                }

                .cv-feature-grid {
                    display: grid;
                    grid-template-columns: repeat(10, minmax(0, 1fr));
                    gap: 12px;
                }

                .cv-span-5 { grid-column: span 5; }
                .cv-span-6 { grid-column: span 6; }
                .cv-span-4 { grid-column: span 4; }

                .cv-mini-card {
                    min-height: 128px;
                    padding: 18px 20px;
                    width: 100%;
                }

                .cv-empty-main {
                    flex: 1;
                    margin-top: 22px;
                    min-height: 0;
                }

                .cv-contact-grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 18px;
                    margin-top: 22px;
                    align-items: stretch;
                    flex: 1;
                    min-height: 0;
                }

                .cv-contact-copy,
                .cv-contact-card,
                .cv-empty-main {
                    padding: 18px 22px;
                    border-radius: 24px;
                    background:
                        linear-gradient(180deg, rgba(255, 255, 255, 0.04), transparent 28%),
                        rgba(16, 19, 42, 0.82);
                    border: 2px solid rgba(56, 189, 248, 0.38);
                    box-shadow:
                        0 0 22px rgba(56, 189, 248, 0.2),
                        0 12px 38px rgba(0, 0, 0, 0.22);
                }

                .cv-contact-copy h1,
                .cv-contact-card h2,
                .cv-empty-main h2 {
                    margin: 0 0 8px;
                    font-size: 1.3rem;
                    line-height: 1.1;
                    letter-spacing: -0.03em;
                    background: linear-gradient(90deg, #d7b56d 0%, #5ae3ff 45%, #7fdcff 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    text-shadow: 0 0 16px rgba(56, 189, 248, 0.16);
                }

                .cv-contact-copy p {
                    margin: 0;
                    color: rgba(233, 239, 255, 0.78);
                    line-height: 1.45;
                    font-size: 1.1rem;
                    max-width: 78ch;
                }

                .cv-contact-main {
                    margin-top: 22px;
                    display: flex;
                    justify-content: center;
                }

                .cv-contact-copyblock {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    min-height: 260px;
                }

                .cv-contact-copyblock img {
                    position: absolute;
                    top: -10px;
                    left: 0;
                    width: 400px;
                    opacity: 0.24;
                    filter: blur(1px);
                    user-select: none;
                    pointer-events: none;
                }

                .cv-contact-copyblock h1 {
                    margin: 0 0 18px;
                    font-size: 2rem;
                    line-height: 1.1;
                    max-width: 640px;
                    background: linear-gradient(90deg, #d7b56d 0%, #5ae3ff 45%, #7fdcff 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    text-shadow: 0 0 16px rgba(56, 189, 248, 0.16);
                }

                .cv-contact-copyblock p {
                    margin: 0 0 20px;
                    color: rgba(233, 239, 255, 0.88);
                    font-size: 1.02rem;
                    line-height: 1.6;
                    max-width: 520px;
                }

                .cv-contact-copyblock h2 {
                    margin: 0 0 12px;
                    font-size: 1.5rem;
                    background: linear-gradient(90deg, #5ae3ff 0%, #d7b56d 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    text-shadow: 0 0 16px rgba(56, 189, 248, 0.16);
                }

                .cv-contact-copyblock ul {
                    margin: 0;
                    padding: 0;
                    list-style: none;
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    color: rgba(233, 239, 255, 0.9);
                    font-size: 1rem;
                    line-height: 1.5;
                }

                .cv-contact-copyblock li {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                }

                .cv-contact-copyblock li span {
                    color: #5ae3ff;
                    font-size: 1.2rem;
                    line-height: 1;
                    margin-top: 2px;
                }

                .cv-contact-form-card {
                    position: relative;
                    width: 100%;
                    max-width: 620px;
                    margin: 0;
                    background: rgba(20, 22, 56, 0.66);
                    border: 2px solid rgba(56, 189, 248, 0.42);
                    border-radius: 24px;
                    padding: 28px;
                    backdrop-filter: blur(12px);
                    box-shadow:
                        0 0 24px rgba(56, 189, 248, 0.2),
                        0 12px 38px rgba(0, 0, 0, 0.22);
                }

                .cv-contact-form-card h3 {
                    margin: 0 0 22px;
                    text-align: center;
                    font-size: 1.5rem;
                    background: linear-gradient(90deg, #d7b56d 0%, #5ae3ff 45%, #7fdcff 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    text-shadow: 0 0 16px rgba(56, 189, 248, 0.16);
                }

                .cv-form {
                    display: flex;
                    flex-direction: column;
                    gap: 14px;
                }

                .cv-form input,
                .cv-form textarea {
                    width: 100%;
                    border: 1px solid rgba(90, 227, 255, 0.4);
                    border-radius: 12px;
                    background: rgba(7, 10, 24, 0.72);
                    color: #eef2ff;
                    padding: 12px 16px;
                    font-size: 1rem;
                    outline: none;
                }

                .cv-form input::placeholder,
                .cv-form textarea::placeholder {
                    color: rgba(233, 239, 255, 0.55);
                }

                .cv-form textarea {
                    min-height: 110px;
                    resize: none;
                }

                .cv-submit {
                    border: none;
                    border-radius: 12px;
                    padding: 14px;
                    font-size: 1.1rem;
                    color: #ffffff;
                    background: linear-gradient(90deg, #d7b56d 0%, #06b6d4 100%);
                    cursor: pointer;
                    transition: opacity 0.3s, transform 0.3s, box-shadow 0.3s;
                    font-weight: 700;
                    box-shadow: 0 0 20px rgba(215, 181, 109, 0.55);
                }

                .cv-submit:hover {
                    opacity: 0.92;
                    transform: translateY(-1px);
                }

                .cv-form-note {
                    font-size: 0.95rem;
                    color: rgba(233, 239, 255, 0.7);
                    line-height: 1.45;
                }

                @media (max-width: 1100px) {
                    .cv-route-page {
                        width: min(92vw, 1180px);
                    }

                    .cv-hero-shell,
                    .cv-contact-grid {
                        grid-template-columns: 1fr;
                        gap: 18px;
                        overflow: visible;
                    }

                    .cv-main-copy,
                    .cv-preview {
                        min-height: auto;
                        border-radius: 30px;
                    }

                    .cv-preview {
                        border-left: 0;
                    }
                }

                @media (max-width: 760px) {
                    .cv-route-page {
                        padding-top: 14px;
                    }

                    .cv-topbar {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .cv-brand {
                        font-size: 1.55rem;
                    }

                    .cv-main-copy, .cv-feature, .cv-mini-card, .cv-contact-copy, .cv-contact-card, .cv-empty-main {
                        padding: 16px 18px;
                    }

                    .cv-nav {
                        justify-content: center;
                    }

                    .cv-nav-link,
                    .cv-cta {
                        width: 100%;
                        text-align: center;
                    }

                    .cv-title {
                        font-size: 1.25rem;
                    }

                    .cv-lead,
                    .cv-contact-copy p {
                        font-size: 1.02rem;
                    }

                    .cv-contact-form-card {
                        padding: 18px;
                    }

                    .cv-feature-grid {
                        grid-template-columns: 1fr;
                    }

                    .cv-span-6, .cv-span-5, .cv-span-4 {
                        grid-column: auto;
                    }
                }
            `}</style>
            <div className="cv-route-page">{children}</div>
        </div>
    );
}


